<script>
  import { onDestroy, onMount, tick } from "svelte";
  import { writable } from "svelte/store";
  import { damfilters } from "lib/stores.js";
  import { fetchWithSession } from "../../../../lib/util/fetchWithSession";
  import { activitiesStoreProject } from "@stores/projectStores.js";
  import { filtersConfigStore } from "@stores/damFiltersConfigStores.js";
  import { getApplicableFilters } from "../../../../lib/util/getDamApplicableFilters";
  import { fly } from "svelte/transition";
  import LFilters from "../components/LFilters.svelte";
  import { recordingStore } from "@stores/recordingStore.js";
  import Filter from "../analysis/components/filter/Filter.svelte";
  import { ROUTES } from "@utils/routes.js";
  import { uiFeatureStore } from "@stores/uiFeatureStore.js";
  import {
    SectionWrapper,
    Accordion,
    Tooltip,
    Button,
    Pagination,
  } from "paxray-components-svelte";
  import {
    DOWNLOAD_ICON,
    SPEED_ICON,
    EXPLORE_ICON,
    TRANSITIONS_ICON,
    VARIANTS_ICON,
    PIE_CHART_ICON,
    NEXT_STEP_ICON,
    OCCURRENCE_ICON,
    LAYERS_CLEAR_ICON,
    CATEGORY_ICON,
    SAVINGS_ICON,
    TEXT_FIELDS_ICON,
    CONTENT_PASTE_ICON,
    SCHEDULE_ICON,
    APPS_DARK_ICON,
    WARNING_ICON,
    FIT_SCREEN_ICON,
    FULLSCREEN_ICON,
    FULLSCREEN_OFF_ICON,
    BOT_WHITE_ICON,
  } from "@utils/icons.js";
  import AddToActivity from "../../analysis-frontend/analysis/components/AddToActivity_steprecording.svelte";
  import Header from "lib/components/Header.svelte";
  import AppDrilldownSourceMenu from "../analysis/components/AppDrilldownSourceMenu.svelte";
  import Modal from "lib/components/Modal.svelte";
  import { useSvelteFlow } from "@xyflow/svelte";
  import {
    ToastNotification,
    Loading,
    OverflowMenu,
    OverflowMenuItem,
    DataTable,
    Checkbox,
  } from "carbon-components-svelte";
  import FlowPlotter from "../../analysis-frontend/analysis/components/FlowPlotterTasks.svelte";
  import TaskSelection from "./TaskSelection.svelte";
  import { MIN_TASK_EXECUTIONS } from "lib/util/taskThresholds.js";
  import SideKPI from "../../../../lib/components/sideKPI.svelte";
  import BpmnViewer from "./BpmnViewer.svelte";
  import BpmnInlinePreview from "./BpmnInlinePreview.svelte";
  import PddExport from "./PddExport.svelte";
  import PddExportMenuItem from "./PddExportMenuItem.svelte";

  import { text } from "svelte/internal";

  const searchParams = new URLSearchParams(window.location.search);

  export let idproject = searchParams.get("idproject");

  // temp data
  let teams = [];
  let processes = [];
  let selectedClusters = [];
  let casesSelected = false;
  let seeMinimap = false;
  let saveOption;
  let loading = true;
  let loadingCases = true;
  let activities = [];
  let paxbotVisible = false;
  let paxbotMessage = "";
  let paxbotTitle = "";
  let selectedProcesses = [];
  let firstGraphLoad = true;
  let selectedProcess = "";
  let selectedSubprocess = "";
  let selectedTask = "";
  let selectedTeam = "";
  let currentSubtask = searchParams.get("subtaskid") || "";
  let loadingSubtaskList = true;
  let graphActivities = [];
  let selectedVariantIds = [];
  let selectedTransitionIds = [];
  let preservedTransitionOptions = [];
  let appliedVariantIds = [];
  let lastSubtask = "";
  let lastGraphContext = "";
  let lastGraphScope = "";
  let quantificationOpen = true;
  let applicationsOpen = true;
  let legendOpen = true;
  let variantPage = 1;
  let transitionPage = 1;
  let openVariantGroups = {};
  let transitionSettingsOpen = false;
  let transitionMinCount = 0;
  let initializeTransitions = true;
  let graphMode = "transitions";
  let transitionMetric = "nextStep";
  let graphRequestSeq = 0;
  let graphRefreshSeq = 0;
  let lastGraphRequestKey = "";
  let inFlightGraphRequestKey = "";
  let windowSequenceRefreshTimer = null;
  let windowSequenceController = null;
  let lastWindowSequenceSelectionKey = "";
  let contextualWindowSequences = {};
  let graphLoadKey = "";
  let graphColorMetric = "none";
  let appNameMappings = [];
  let appTypesByName = {};
  let explorerMode = "exploration";
  let optimizationData = null;
  let optimizationLoading = false;
  let optimizationError = "";
  let optimizationLoadedSubtask = "";
  let optimizationRequestSeq = 0;
  let lastTaskFrequencyUpdate = "";
  let selectedOpportunityIds = [];
  let openOpportunityDetails = {};
  const OPTIMIZATION_COLORS = [
    "#C9E2FF",
    "#8EC1F0",
    "#57A3EA",
    "#2F80ED",
    "#1F65C8",
  ];
  const APP_TYPE_DEFINITIONS = [
    { key: "main", label: "Main Apps", color: "#b7e3bd" },
    { key: "support", label: "Support Apps", color: "#e5e8a8" },
    { key: "communication", label: "Communication Apps", color: "#abcfe8" },
    { key: "unwanted", label: "Unwanted Apps", color: "#e6a7ad" },
  ];
  const TRAFFIC_LIGHT_LEGEND = [
    { label: "High", color: "#e6a7ad" },
    { label: "Medium", color: "#e5e8a8" },
    { label: "Low", color: "#b7e3bd" },
  ];
  const CLASSIFICATION_LEGEND = [
    { label: "Waste", color: "#e6a7ad" },
    { label: "Business Required", color: "#e5e8a8" },
    { label: "Value Adding", color: "#b7e3bd" },
  ];
  const explorerModeLabels = {
    exploration: "Explore",
    optimization: "Optimize",
  };
  const graphModeLabels = {
    transitions: "Transitions",
    variants: "Variants",
  };
  const transitionMetricLabels = {
    caseCoverage: "Case coverage",
    nextStep: "Next-step probability",
    occurrences: "Occurrences",
  };
  const transitionMetricIcons = {
    caseCoverage: PIE_CHART_ICON,
    nextStep: NEXT_STEP_ICON,
    occurrences: OCCURRENCE_ICON,
  };
  const graphColorMetricLabels = {
    none: "None",
    "optimization:classification": "Classification",
    "optimization:savings": "Savings",
    text: "Text",
    copy: "Copy & Paste",
    time: "Time",
    appType: "App Type",
  };
  const SAVINGS_LEGEND = [
    { label: "High Savings", color: "#b7e3bd" },
    { label: "Medium Savings", color: "#e5e8a8" },
    { label: "Low Savings", color: "#e6a7ad" },
    { label: "No Savings", color: "#ffffff" },
  ];
  let simulationVariantId = "";
  let simulationStep = 0;
  let simulationCaseIndex = 0;
  let simulationSlate = "";
  let simulationTimer = null;
  const variantsPerPage = 5;
  const transitionsPerPage = 5;
  const getTransitionId = (edge) => `${edge.from}->${edge.to}`;
  $: PAXBOT_ENABLED = $uiFeatureStore.processExplorer.aiBot;

  const { fitView, zoomIn, zoomOut, getZoom } = useSvelteFlow();
  let zoomLevel = writable((getZoom() * 100).toFixed(0));
  let initialZoomValue = writable(0);
  let fullscreen = false;

  let selectedNode = "";
  let selectedNodes = [];
  let expandedNodes = [];
  let fullGraphView;
  let fullNodeInfo = true;
  let triggerUpdate = false;
  let nnodes = 0;
  let nedges = 0;
  let minFrequency = 0;
  let graph = {
    activityMappingCluster: [],
    //allactivitymapping: [],
    edges: [],
    // executionFrequency: 0,
    // nactivities: 0,
    nodes: [],
    // nusers: 0,
    // timepercase: 0,
    // totaltime: 0,
    uniquePrograms: [],
    //uniqueActivities: 0,
    variants: [],
    maxtime: 0,
    meantime: 0,
    mintime: 0,
  };
  $: ({ allActivities, toastMsg, saveSuccessful } = $activitiesStoreProject);
  $: ({ processes, listOfSubprocesses, listOfTeams } = $recordingStore);
  const { setCurrentView } = filtersConfigStore;
  $: setCurrentView("Process Explorer", "Activities");
  // Datenquelle wie im App Drilldown: 0 = Registrations (task_recordings),
  // 1 = Global = erkannte Laeufe der Hauptphase (task_runs, source=main).
  let selectedSourceIndex = 0;
  let lastSourceIndex = 0;
  function dataSource() {
    return selectedSourceIndex === 1 ? "main" : "recordings";
  }
  $: if (selectedSourceIndex !== lastSourceIndex) {
    lastSourceIndex = selectedSourceIndex;
    getSubtasks();
    if (currentSubtask) getTaskGraph(currentSubtask);
  }

  const { getAllActivities } = activitiesStoreProject;
  $: if (idproject && toastMsg === null) {
    getAllActivities(idproject);
  }

  let activitiesToShow = [];
  let edgesToShow = [];

  let flowPlotterElement;
  let activityEditorElement;
  let flowPlotterCaseElement;
  let bpmnViewerElement;
  let bpmnReportRendererElement;
  let generatedBpmnXml = null;
  let generatedBpmnActivityMetrics = [];
  let generatedBpmnConnectionMetrics = [];
  let reportBpmnXml = "";
  let showBpmnViewer = false;
  let bpmnGenerating = false;
  let bpmnSaving = false;
  let bpmnSaved = false;
  let bpmnModalOpen = false;
  let bpmnExportFormat = "standard";
  let bpmnExportOrientation = "horizontal";
  let bicIdentifier = "";
  let bicValidTo = "";
  let bicChangeLog = "";
  let bicGenerateTexts = false;
  let bicProcessTimeUnit = "minutes";
  let tableHeaders = [
    { key: "include", value: "Include", width: "80px" },
    { key: "activity", value: "Activity" },
    {
      key: "cases",
      value: "Cases",
      width: "90px",
      tooltip:
        "Fraction of cases that include at least one occurrence of the activity",
    },
  ];
  let systemMinFrequency = 0;
  let fileMinFrequency = 0;
  let reworkMinFrequency = 0;
  let includesActivities = [];
  let paginationBPMN = { pageSize: 5, page: 1 };
  let bpmnTopKMode = "balanced";
  let bpmnArtifactMode = "balanced";
  let bpmnTopKPathCount = 3;
  let bpmnTopKCoverage = 80;
  let bpmnVariantIds = [];
  let bpmnOpenVariantGroups = {};
  let bpmnSectionsOpen = {
    topK: true,
    selection: true,
    gateway: true,
    artifacts: true,
  };
  const showGatewayBehaviorSelection = false;
  let gatewayBehavior = "split_xor";
  let includeDatabases = true;
  let includeDocuments = true;
  let includeAvgTime = false;
  let includeFrequency = false;
  let bpmnPreviewXml = "";
  let bpmnPreviewLoading = false;
  let bpmnPreviewError = "";
  let bpmnPreviewTimer = null;
  let bpmnPreviewRequestSeq = 0;
  let bpmnPreviewStateKey = "";
  let lastBpmnPreviewSignature = "";

  $: paxbotAnnotations = Array.isArray(paxbotMessage) ? paxbotMessage : [];
  $: paxbotText =
    typeof paxbotMessage === "string" && paxbotMessage.trim()
      ? paxbotMessage
      : "";
  $: paxbotHeading = paxbotTitle || "Pax AI";
  let paxbotInput = "";
  let paxbotLanguage = "en";
  let paxbotLoading = false;
  let paxbotFocusedStepContext = null;
  const paxbotLanguages = [
    { key: "en", label: "EN", name: "English" },
    { key: "de", label: "DE", name: "Deutsch" },
    { key: "es", label: "ES", name: "Español" },
    { key: "fr", label: "FR", name: "Français" },
    { key: "it", label: "IT", name: "Italiano" },
  ];
  const paxbotLanguageText = {
    en: {
      hello:
        "Hi, I'm Pax AI. Ask me anything about the current task or graph. I can also help with navigation or interpretation questions.",
      starterQuestions: [
        "What should I look at first?",
        "Explain this graph",
        "Where are the bottlenecks?",
        "Where is a lot of copy & paste?",
      ],
      disclaimer: "Pax AI can make mistakes. Check important results.",
      thinking: "Pax AI is thinking...",
      replying: "Pax AI is replying...",
      placeholder: "Ask Pax AI...",
    },
    de: {
      hello:
        "Hi, ich bin Pax AI. Frag mich gerne etwas zum aktuellen Task oder Graph. Ich helfe dir auch bei Navigations- oder Verständnisfragen.",
      starterQuestions: [
        "Was soll ich zuerst prüfen?",
        "Erkläre diesen Graphen",
        "Wo sind Engpässe?",
        "Wo gibt es viel Copy & Paste?",
      ],
      disclaimer: "Pax AI kann Fehler machen. Prüfe wichtige Ergebnisse.",
      thinking: "Pax AI denkt nach...",
      replying: "Pax AI antwortet...",
      placeholder: "Pax AI fragen...",
    },
    es: {
      hello:
        "Hola, soy Pax AI. Pregúntame sobre la tarea o el gráfico actual. También puedo ayudarte con navegación o interpretación.",
      starterQuestions: [
        "¿Qué debería revisar primero?",
        "Explica este gráfico",
        "¿Dónde hay cuellos de botella?",
        "¿Dónde hay mucho copiar y pegar?",
      ],
      disclaimer:
        "Pax AI puede cometer errores. Revisa los resultados importantes.",
      thinking: "Pax AI está pensando...",
      replying: "Pax AI está respondiendo...",
      placeholder: "Pregunta a Pax AI...",
    },
    fr: {
      hello:
        "Bonjour, je suis Pax AI. Posez-moi vos questions sur la tâche ou le graphique actuel. Je peux également vous aider à naviguer ou à interpréter les données.",
      starterQuestions: [
        "Que dois-je examiner en premier ?",
        "Explique ce graphique",
        "Où se trouvent les goulots d'étranglement ?",
        "Où y a-t-il beaucoup de copier-coller ?",
      ],
      disclaimer:
        "Pax AI peut faire des erreurs. Vérifiez les résultats importants.",
      thinking: "Pax AI réfléchit...",
      replying: "Pax AI répond...",
      placeholder: "Demander à Pax AI...",
    },
    it: {
      hello:
        "Ciao, sono Pax AI. Chiedimi qualcosa sul task o sul grafico attuale. Posso aiutarti anche con navigazione o interpretazione.",
      starterQuestions: [
        "Cosa dovrei controllare prima?",
        "Spiega questo grafico",
        "Dove sono i colli di bottiglia?",
        "Dove c'è molto copia e incolla?",
      ],
      disclaimer:
        "Pax AI può commettere errori. Verifica i risultati importanti.",
      thinking: "Pax AI sta pensando...",
      replying: "Pax AI sta rispondendo...",
      placeholder: "Chiedi a Pax AI...",
    },
  };
  $: paxbotLocale = paxbotLanguageText[paxbotLanguage] || paxbotLanguageText.en;
  let paxbotChatMessages = [
    {
      role: "assistant",
      text: "Hi, ich bin Pax AI. Frag mich gerne etwas zum aktuellen Task oder Graph. Ich helfe dir auch bei Navigations- oder Verständnisfragen.",
    },
  ];
  let paxbotMessagesElement;
  let paxbotScrollSignature = "";
  let paxbotTyping = false;
  let paxbotTypingTimer;
  $: if (
    paxbotChatMessages.length === 1 &&
    paxbotChatMessages[0]?.role === "assistant" &&
    paxbotChatMessages[0]?.text?.startsWith("Hi, ich")
  ) {
    paxbotChatMessages = [
      { role: "assistant", text: paxbotLanguageText.en.hello },
    ];
  }

  async function scrollPaxbotToBottom() {
    await tick();
    if (!paxbotMessagesElement) return;
    paxbotMessagesElement.scrollTop = paxbotMessagesElement.scrollHeight;
  }

  function clearPaxbotTyping() {
    if (paxbotTypingTimer) {
      clearTimeout(paxbotTypingTimer);
      paxbotTypingTimer = null;
    }
    paxbotTyping = false;
  }

  function animatePaxbotAnswer(answer) {
    clearPaxbotTyping();
    const fullText = String(answer || "").trim();
    const typingId = `paxbot-${Date.now()}-${Math.random()}`;
    let visibleLength = 0;
    paxbotTyping = true;
    paxbotChatMessages = [
      ...paxbotChatMessages,
      { role: "assistant", text: "", typingId },
    ];

    const typeNext = () => {
      visibleLength = Math.min(
        visibleLength + (fullText.length > 180 ? 3 : 2),
        fullText.length,
      );
      paxbotChatMessages = paxbotChatMessages.map((message) =>
        message.typingId === typingId
          ? { ...message, text: fullText.slice(0, visibleLength) }
          : message,
      );
      if (visibleLength < fullText.length) {
        paxbotTypingTimer = setTimeout(typeNext, 14);
      } else {
        paxbotTypingTimer = null;
        paxbotTyping = false;
      }
    };

    typeNext();
  }

  $: {
    const lastPaxbotMessage = paxbotChatMessages[paxbotChatMessages.length - 1];
    const nextPaxbotScrollSignature = [
      paxbotVisible,
      paxbotLoading,
      paxbotChatMessages.length,
      lastPaxbotMessage?.role || "",
      lastPaxbotMessage?.text || "",
    ].join("|");
    if (paxbotVisible && nextPaxbotScrollSignature !== paxbotScrollSignature) {
      paxbotScrollSignature = nextPaxbotScrollSignature;
      scrollPaxbotToBottom();
    }
  }

  let subtaskList = [];
  let filteredSubtaskList = [];

  let controller = new AbortController();
  let reportGenerating = false;
  let pddGenerating = false;
  let pddTemplateModalOpen = false;
  let pddExportElement;
  let reportModalOpen = false;
  let reportMode = "manager";
  let selectedReportTaskIds = [];
  let openReportL3Groups = {};
  let reportSearchTerm = "";
  let reportTeamFilter = "";
  let reportL3Filter = "";
  let reportPage = 1;
  let reportFilterKey = "";
  const reportItemsPerPage = 8;
  let actionPlanGenerating = false;
  let actionPlanModalOpen = false;
  let selectedActionPlanTaskIds = [];
  let openActionPlanL3Groups = {};
  let actionPlanSearchTerm = "";
  let actionPlanPage = 1;
  let actionPlanFilterKey = "";
  const actionPlanItemsPerPage = 8;
  let reportJobId = "";
  let reportToastVisible = false;
  let reportToastKind = "info";
  let reportToastTitle = "";
  let reportToastSubtitle = "";

  let isUpdatingFilters = false;
  let lastFilterString = null;

  $: {
    if ($damfilters[idproject] && $filtersConfigStore.storeLoaded) {
      const applicableFilters = getApplicableFilters($damfilters[idproject]);
      const filterString = JSON.stringify(applicableFilters);
      if (lastFilterString === null) {
        // Erstauswertung: Liste und Graph laden bereits onMount bzw. der
        // Graph-Block - sonst laedt beides doppelt (Filter null -> "[]").
        lastFilterString = filterString;
      } else if (filterString !== lastFilterString) {
        lastFilterString = filterString;
        getSubtasks();
        if (currentSubtask) {
          getTaskGraph(
            currentSubtask,
            graphMode === "variants" ? appliedVariantIds : [],
          );
        }
      }
    }
  }

  $: currentSubtaskEntry =
    subtaskList.find((subtask) => subtask.id === currentSubtask) || null;
  $: optimizationSubtaskList = filteredSubtaskList.map((task) => ({
    ...task,
    value:
      task.optimization_hours != null
        ? Number(task.optimization_hours).toFixed(1)
        : "0.0",
  }));
  // Tasks below the registration threshold are hidden in the task list. If all of
  // them are hidden no task is ever selected, so show the empty state instead of loading.
  $: hiddenTaskCount = filteredSubtaskList.filter(
    (task) =>
      (Number(task.value ?? task.nrecordings ?? 0) || 0) < modalTaskThreshold,
  ).length;
  $: allTasksHidden =
    filteredSubtaskList.length > 0 &&
    hiddenTaskCount === filteredSubtaskList.length;
  $: noTasksAvailable =
    !loadingSubtaskList && (filteredSubtaskList.length === 0 || allTasksHidden);
  $: selectedOpportunities = (optimizationData?.opportunities || []).filter(
    (opportunity) => selectedOpportunityIds.includes(opportunity.id),
  );
  $: selectedOpportunitySteps = new Set(
    selectedOpportunities.flatMap((opportunity) => opportunity.steps || []),
  );
  $: allOptimizationOpportunityCards = (
    optimizationData?.opportunities || []
  ).map(opportunityToCard);
  $: optimizationOpportunityCards =
    selectedOpportunities.map(opportunityToCard);
  $: optimizationTotals = getOptimizationTotals(
    optimizationData,
    selectedOpportunities,
  );
  $: opportunityStats = getOpportunityStats(
    optimizationData?.opportunities || [],
  );
  $: optimizationReady =
    explorerMode === "optimization" &&
    !optimizationLoading &&
    optimizationData &&
    optimizationLoadedSubtask === currentSubtask;
  $: taskNameById = getTaskNameById(listOfSubprocesses);
  $: taskGroupsByLevel = getTaskGroupsByLevel(processes, listOfSubprocesses);
  // Report und Action Plan bieten nur Tasks an, die auch die Task-Auswahl
  // freigibt: mindestens MIN_TASK_EXECUTIONS Aufnahmen (Optimierung: alle).
  $: modalTaskThreshold =
    explorerMode === "optimization" ? 0 : MIN_TASK_EXECUTIONS;
  $: actionPlanL3Options = getActionPlanL3Options(
    (subtaskList || []).filter(
      (task) =>
        (Number(task.value ?? task.nrecordings ?? 0) || 0) >=
        modalTaskThreshold,
    ),
    taskGroupsByLevel,
  );
  $: filteredActionPlanL3Options = filterActionPlanL3Options(
    actionPlanL3Options,
    actionPlanSearchTerm,
  );
  $: pagedActionPlanL3Options = filteredActionPlanL3Options.slice(
    (actionPlanPage - 1) * actionPlanItemsPerPage,
    actionPlanPage * actionPlanItemsPerPage,
  );
  $: reportL3Options = actionPlanL3Options;
  $: reportTeamOptions = [
    ...new Set(
      reportL3Options.flatMap((option) =>
        option.tasks.flatMap((task) => task.teams || []),
      ),
    ),
  ]
    .filter(Boolean)
    .sort((left, right) => left.localeCompare(right));
  $: filteredReportL3Options = filterReportL3Options(
    reportL3Options,
    reportSearchTerm,
    reportTeamFilter,
    reportL3Filter,
  );
  $: pagedReportL3Options = filteredReportL3Options.slice(
    (reportPage - 1) * reportItemsPerPage,
    reportPage * reportItemsPerPage,
  );
  $: {
    const nextActionPlanFilterKey = `${actionPlanSearchTerm}:${actionPlanL3Options.length}`;
    if (nextActionPlanFilterKey !== actionPlanFilterKey) {
      actionPlanFilterKey = nextActionPlanFilterKey;
      actionPlanPage = 1;
    }
  }
  $: {
    const nextReportFilterKey = `${reportSearchTerm}:${reportTeamFilter}:${reportL3Filter}:${reportL3Options.length}`;
    if (nextReportFilterKey !== reportFilterKey) {
      reportFilterKey = nextReportFilterKey;
      reportPage = 1;
    }
  }
  $: if (
    explorerMode !== "optimization" &&
    String(graphColorMetric).startsWith("optimization")
  ) {
    graphColorMetric = "none";
  }
  $: if (
    explorerMode === "optimization" &&
    ["text", "copy", "time", "appType"].includes(graphColorMetric)
  ) {
    graphColorMetric = "none";
  }

  $: {
    const nextGraphLoadKey = `${currentSubtask}-${selectedProcess}-${selectedSubprocess}-${selectedTeam}`;
    if (
      currentSubtask &&
      allActivities &&
      toastMsg !== null &&
      nextGraphLoadKey !== graphLoadKey
    ) {
      graphLoadKey = nextGraphLoadKey;
      getTaskGraph(currentSubtask, []);
    }
  }

  $: if (explorerMode === "optimization" && currentSubtask) {
    loadOptimizationData(currentSubtask);
  }

  $: if (triggerUpdate) {
    if (
      graphMode === "transitions" &&
      currentSelectedTransitionOptions.length
    ) {
      preservedTransitionOptions = currentSelectedTransitionOptions;
    }
    triggerUpdate = false;
    graphRefreshSeq += 1;
    getTaskGraph(
      currentSubtask,
      graphMode === "variants" ? appliedVariantIds : [],
    );
  }

  $: if (currentSubtask) resetButtonsValues();

  $: {
    selectedClusters = selectedProcesses.map((process) => process.id);
  }

  $: {
    if (fullGraphView === 3) {
      casesSelected = true;
    } else {
      casesSelected = false;
    }
  }

  $: variantOptions = (graph["variants"] || []).filter(
    (variant) =>
      variant &&
      typeof variant === "object" &&
      !Array.isArray(variant) &&
      variant.id &&
      variantHasSteps(variant),
  );
  $: variantGroups = createVariantGroups(variantOptions);
  $: visibleVariantGroups = variantGroups
    .slice((variantPage - 1) * variantsPerPage, variantPage * variantsPerPage)
    .map((group, index) => ({
      ...group,
      open:
        openVariantGroups[group.id] ??
        group.variants.some((variant) =>
          selectedVariantIds.includes(variant.id),
        ),
      selected: group.variants.every((variant) =>
        selectedVariantIds.includes(variant.id),
      ),
    }));
  $: if (variantPage > Math.ceil(variantGroups.length / variantsPerPage)) {
    variantPage = Math.max(
      Math.ceil(variantGroups.length / variantsPerPage),
      1,
    );
  }
  $: selectedVariantOptions = variantOptions.filter((variant) =>
    selectedVariantIds.includes(variant.id),
  );
  $: variantOptionsTotal = variantOptions.reduce(
    (sum, variant) => sum + (Number(variant.count) || 0),
    0,
  );
  $: selectedCoverage = selectedVariantOptions.reduce(
    (sum, variant) =>
      sum + (Number(variant.count) || 0) / Math.max(variantOptionsTotal, 1),
    0,
  );
  $: globalTaskTimeStats = getVariantTimeStats(variantOptions);
  $: transitionOptions = ((transitionMetric && graph["edges"]) || [])
    .filter((edge) => edge.from !== edge.to)
    .sort(
      (a, b) =>
        edgeFrequency(b, graph["executionFrequency"] || 1) -
        edgeFrequency(a, graph["executionFrequency"] || 1),
    );
  $: visibleTransitionOptions = (transitionMetric && transitionOptions).filter(
    (edge) =>
      edgeFrequency(edge, graph["executionFrequency"] || 1) >= minFrequency &&
      (Number(edge.value) || 0) >= transitionMinCount,
  );
  $: currentSelectedTransitionOptions = visibleTransitionOptions.filter(
    (edge) => selectedTransitionIds.includes(getTransitionId(edge)),
  );
  $: selectedTransitionOptions = getSelectedTransitionOptions(
    visibleTransitionOptions,
    selectedTransitionIds,
    preservedTransitionOptions,
  );
  $: selectedTransitionActivityCount = getTransitionActivityCount(
    selectedTransitionIds,
  );
  $: visibleTransitionActivityCount = getTransitionActivityCount(
    visibleTransitionOptions.map(getTransitionId),
  );
  $: visibleTransitionRows = visibleTransitionOptions.slice(
    (transitionPage - 1) * transitionsPerPage,
    transitionPage * transitionsPerPage,
  );
  $: if (
    transitionPage >
    Math.ceil(visibleTransitionOptions.length / transitionsPerPage)
  ) {
    transitionPage = Math.max(
      Math.ceil(visibleTransitionOptions.length / transitionsPerPage),
      1,
    );
  }
  $: selectedTransitionExactStats = getSelectedTransitionExactStats(
    selectedTransitionOptions,
    variantOptions,
    graph["executionFrequency"] || 0,
  );
  $: edgesDataToShow =
    graphMode === "transitions"
      ? buildTransitionGraphEdges(selectedTransitionOptions)
      : selectedVariantIds.length
        ? (graph["edges"] || []).filter((edge) => edge.from !== edge.to)
        : [];
  $: nodesDataToShow = getNodesForEdges(graph["nodes"] || [], edgesDataToShow);
  $: visibleNodeIds = new Set(nodesDataToShow.map((node) => node.id));
  $: safeEdgesDataToShow = edgesDataToShow.filter(
    (edge) => visibleNodeIds.has(edge.from) && visibleNodeIds.has(edge.to),
  );
  $: metricEdgesDataToShow = safeEdgesDataToShow.map((edge) => ({
    ...edge,
    transitionMetric,
    metricValue: edgeFrequency(edge, graph["executionFrequency"] || 1),
  }));
  $: topPrograms = (graph["uniquePrograms"] || [])
    .filter((program) => Number(program.ratio) > 0)
    .sort((a, b) => Number(b.ratio) - Number(a.ratio))
    .slice(0, 4);
  $: infoStats =
    graphMode === "transitions"
      ? {
          recordings: selectedTransitionExactStats.count || null,
          activeTime: selectedTransitionExactStats.avg,
          coverage: selectedTransitionExactStats.coverage,
        }
      : {
          recordings: selectedVariantIds.length
            ? selectedVariantOptions.reduce(
                (sum, variant) => sum + (Number(variant.count) || 0),
                0,
              )
            : null,
          activeTime: graph["meantime"],
          coverage: selectedCoverage,
        };
  // Je Aktivitaet liefert das Backend nur Apps mit >= 20 % Zeitanteil (activityKpis.apps);
  // ueber alle Aktivitaeten summiert liesse das die Nebenanwendungen (Outlook, Excel)
  // verschwinden. Solange alle Aktivitaeten sichtbar sind, gelten deshalb die
  // Anteile des ganzen Graphen (uniquePrograms); erst bei Teilansicht die je Knoten.
  $: shownActivityCount = nodesDataToShow.filter(
    (node) => node.id !== "Start" && node.id !== "End",
  ).length;
  $: allActivitiesShown =
    shownActivityCount >=
    ((graph["activities"] || []).length || shownActivityCount);
  $: infoPrograms =
    graphMode === "transitions" && !allActivitiesShown
      ? getProgramsForNodes(nodesDataToShow, graph["activityKpis"] || {})
      : topPrograms;
  $: buildAppTypeMapping(appNameMappings, infoPrograms);
  $: legendItems = getLegendItems(graphColorMetric);
  $: bpmnActivityRows = (graph.activities || [])
    .map((activity) => {
      const label =
        activity.activity_name || activity.activityname || activity.name;
      const id = String(activity.id || label || "");
      const kpi = graph.activityKpis?.[label];
      const occurrenceRate =
        kpi?.occurrence_rate != null
          ? (kpi.occurrence_rate * 100).toFixed(1)
          : null;
      return {
        id,
        activity: label,
        team: activity.team_name || null,
        cases: occurrenceRate,
        include: includesActivities.includes(id) ? 1 : 0,
      };
    })
    .filter((activity) => activity.id && activity.activity);
  $: bpmnEffectiveConnectionMinFrequency = 0;
  $: bpmnBaseConnectionEdges = [...visibleTransitionOptions];
  $: bpmnSortedConnectionEdges = bpmnBaseConnectionEdges
    .filter((edge) => edge.from !== edge.to)
    .sort(
      (a, b) =>
        edgeFrequency(b, graph["executionFrequency"] || 1) -
        edgeFrequency(a, graph["executionFrequency"] || 1),
    );
  $: bpmnTopKPaths = getTopKPaths(bpmnSortedConnectionEdges, 50);
  $: bpmnTopKPathMax =
    graphMode === "variants"
      ? Math.max(variantOptions.length, 1)
      : Math.max(bpmnTopKPaths.length, 1);
  $: if (bpmnTopKPathCount > bpmnTopKPathMax) {
    bpmnTopKPathCount = bpmnTopKPathMax;
  }
  $: bpmnEffectiveTopKPathCount =
    bpmnTopKMode === "simple"
      ? 1
      : bpmnTopKMode === "balanced"
        ? 3
        : Math.min(
            bpmnTopKPathCount,
            graphMode === "variants"
              ? Math.max(variantOptions.length, 1)
              : bpmnTopKPathMax,
          );
  $: bpmnEffectiveTopKCoverage =
    bpmnTopKMode === "simple"
      ? 60
      : bpmnTopKMode === "balanced"
        ? 80
        : bpmnTopKCoverage;
  $: bpmnTopKCoveragePaths = getPathsForCoverage(
    bpmnTopKPaths,
    bpmnEffectiveTopKCoverage,
    bpmnSortedConnectionEdges,
    variantOptions,
    graph["executionFrequency"] || 0,
  );
  $: bpmnTopKPathLimit = Math.min(
    bpmnEffectiveTopKPathCount,
    bpmnTopKCoveragePaths.length,
  );
  $: bpmnTopKConnectionEdges = getEdgesFromPaths(
    bpmnTopKPaths.slice(0, bpmnTopKPathLimit),
    bpmnSortedConnectionEdges,
  );
  $: bpmnSelectedConnectionEdges = bpmnTopKConnectionEdges;
  $: bpmnAllowedActivities = new Set(
    bpmnSelectedConnectionEdges
      .flatMap((edge) => [edge.from, edge.to])
      .filter((activity) => activity !== "Start" && activity !== "End"),
  );
  $: bpmnSelectedActivities = bpmnActivityRows.filter(
    (activity) =>
      includesActivities.includes(activity.id) &&
      bpmnAllowedActivities.has(activity.activity),
  );
  $: bpmnSelectedVariantOptions = variantOptions.filter((variant) =>
    bpmnVariantIds.includes(variant.id),
  );
  $: bpmnTopKVariantOptions = getTopKVariants(
    variantOptions,
    bpmnSelectedVariantOptions,
    bpmnEffectiveTopKPathCount,
    bpmnEffectiveTopKCoverage,
  );
  $: bpmnEffectiveVariantOptions =
    graphMode === "variants"
      ? bpmnTopKVariantOptions
      : bpmnSelectedVariantOptions;
  $: bpmnVariantGroups = variantGroups.map((group) => ({
    ...group,
    open:
      bpmnOpenVariantGroups[group.id] ??
      group.variants.some((variant) => bpmnVariantIds.includes(variant.id)),
    selected: group.variants.every((variant) =>
      bpmnVariantIds.includes(variant.id),
    ),
  }));
  $: bpmnSelectedVariantCoverage = Math.round(
    bpmnEffectiveVariantOptions.reduce(
      (sum, variant) => sum + (variant.coverage || 0),
      0,
    ) * 100,
  );
  $: bpmnSelectedActivityLabels = new Set(
    graphMode === "variants"
      ? bpmnEffectiveVariantOptions.flatMap((variant) => variantSteps(variant))
      : bpmnSelectedActivities.map((activity) => activity.activity),
  );
  $: bpmnVariantConnectionEdges =
    graphMode === "variants"
      ? buildBpmnEdgesFromVariantPaths(
          bpmnSelectedActivityLabels,
          bpmnEffectiveVariantOptions,
        ).map(([from, to, value]) => ({ from, to, value }))
      : [];
  $: bpmnKpiConnectionEdges =
    graphMode === "variants"
      ? bpmnVariantConnectionEdges
      : bpmnSelectedConnectionEdges.filter(
          (edge) =>
            (edge.from === "Start" ||
              bpmnSelectedActivityLabels.has(edge.from)) &&
            (edge.to === "End" || bpmnSelectedActivityLabels.has(edge.to)),
        );
  $: bpmnModalStats = getSelectedTransitionExactStats(
    bpmnKpiConnectionEdges,
    variantOptions,
    graph["executionFrequency"] || 0,
  );
  $: bpmnModalCoverage = Math.round((bpmnModalStats.coverage || 0) * 100);
  $: bpmnPreviewStateKey =
    bpmnModalOpen && currentSubtaskEntry
      ? JSON.stringify({
          graphMode,
          topKMode: bpmnTopKMode,
          topKCount: bpmnEffectiveTopKPathCount,
          topKCoverage: bpmnEffectiveTopKCoverage,
          gatewayBehavior,
          includeDatabases,
          includeDocuments,
          includeAvgTime,
          includeFrequency,
          artifactMode: bpmnArtifactMode,
          systemMin: bpmnEffectiveSystemMinFrequency,
          fileMin: bpmnEffectiveFileMinFrequency,
          activities: bpmnSelectedActivities
            .map((activity) => activity.id)
            .sort(),
          variants: bpmnEffectiveVariantOptions
            .map((variant) => variant.id)
            .sort(),
          edges: bpmnSelectedConnectionEdges.map(
            (edge) =>
              `${edge.from}->${edge.to}:${edge.value ?? edge.weight ?? ""}`,
          ),
        })
      : "";
  $: bpmnEffectiveSystemMinFrequency =
    bpmnArtifactMode === "simple"
      ? 10
      : bpmnArtifactMode === "balanced"
        ? 20
        : systemMinFrequency;
  $: bpmnEffectiveFileMinFrequency =
    bpmnArtifactMode === "simple"
      ? 10
      : bpmnArtifactMode === "balanced"
        ? 20
        : fileMinFrequency;
  $: if (paginationBPMN.pageSize !== 5) {
    paginationBPMN = { ...paginationBPMN, pageSize: 5 };
  }
  $: if (
    paginationBPMN.page >
    Math.max(Math.ceil(bpmnActivityRows.length / paginationBPMN.pageSize), 1)
  ) {
    paginationBPMN = {
      ...paginationBPMN,
      page: Math.max(
        Math.ceil(bpmnActivityRows.length / paginationBPMN.pageSize),
        1,
      ),
    };
  }
  $: graphRenderKey = [
    minFrequency,
    graphMode,
    transitionMetric,
    selectedVariantIds.join("|"),
    selectedTransitionIds.join("|"),
    graph["nodes"]?.length || 0,
    graph["edges"]?.length || 0,
    safeEdgesDataToShow.length,
    graph["executionFrequency"] || 0,
  ].join("-");
  $: minFrequencyMax =
    transitionMetric &&
    getMaxSafeMinFrequency(
      graph["edges"] || [],
      graph["executionFrequency"] || 1,
    );
  $: if (minFrequency > minFrequencyMax) minFrequency = minFrequencyMax;
  $: windowSequenceSelectionKey = [
    currentSubtask,
    graphMode,
    minFrequency,
    selectedTransitionOptions.map(getTransitionId).join("|"),
  ].join("-");
  $: if (
    graphMode === "transitions" &&
    currentSubtask &&
    graph["nodes"]?.length &&
    windowSequenceSelectionKey !== lastWindowSequenceSelectionKey
  ) {
    lastWindowSequenceSelectionKey = windowSequenceSelectionKey;
    scheduleWindowSequenceRefresh();
  }
  $: simulationVariant = variantOptions.find(
    (variant) => variant.id === simulationVariantId,
  );
  $: simulationPaths = getVariantSimulationPaths(simulationVariant);
  $: simulationPath = simulationPaths[simulationCaseIndex] || [];

  $: setFilteredSubtaskList(
    selectedProcess,
    selectedSubprocess,
    selectedTask,
    selectedTeam,
  );

  function resetButtonsValues() {
    expandedNodes = [];
  }

  function setReportToast(kind, title, subtitle) {
    reportToastKind = kind;
    reportToastTitle = title;
    reportToastSubtitle = subtitle;
    reportToastVisible = true;
  }

  function clearReportToast() {
    reportToastVisible = false;
    reportToastTitle = "";
    reportToastSubtitle = "";
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getDownloadFilename(response, fallbackName) {
    const disposition = response.headers.get("content-disposition") || "";
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      try {
        return decodeURIComponent(utf8Match[1]);
      } catch (error) {
        return fallbackName;
      }
    }
    const plainMatch = disposition.match(/filename="?([^"]+)"?/i);
    if (plainMatch?.[1]) return plainMatch[1];
    return fallbackName;
  }

  async function readJsonResponse(response, fallbackMessage) {
    const rawText = await response.text();
    if (!rawText) return {};

    try {
      return JSON.parse(rawText);
    } catch (error) {
      if (!response.ok) {
        throw new Error(`${fallbackMessage} (HTTP ${response.status})`);
      }
      throw error;
    }
  }

  function sanitizeDownloadFilename(filename, fallbackName) {
    const candidate = String(filename || "").trim();
    if (!candidate) return fallbackName;

    const sanitized = candidate
      .replace(/[<>:"/\\|?*\u0000-\u001f]/g, "_")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");

    if (!sanitized || sanitized === "." || sanitized === "..") {
      return fallbackName;
    }

    return sanitized;
  }

  function l4Filename(name) {
    const value = String(name || "").trim();
    const underscored = value
      .replace(/\s+/g, "_")
      .replace(/[^A-Za-z0-9_]/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");
    return `${underscored || "task_report"}.pdf`;
  }

  function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const safeFilename = sanitizeDownloadFilename(filename, "download.pdf");

    try {
      const link = document.createElement("a");
      link.href = url;
      link.download = safeFilename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  function svgToPngDataUrl(svgText, width = 1600, height = 650) {
    return new Promise((resolve, reject) => {
      if (!svgText) {
        resolve("");
        return;
      }
      const svgBlob = new Blob([svgText], {
        type: "image/svg+xml;charset=utf-8",
      });
      const url = URL.createObjectURL(svgBlob);
      const image = new Image();
      image.onload = () => {
        const viewBoxMatch = String(svgText).match(/viewBox=["']([^"']+)["']/i);
        const viewBox = viewBoxMatch
          ? viewBoxMatch[1].split(/\s+/).map(Number)
          : [];
        const sourceWidth = Number(image.width) || Number(viewBox[2]) || width;
        const sourceHeight =
          Number(image.height) || Number(viewBox[3]) || height;
        const ratio = sourceWidth / Math.max(sourceHeight, 1);
        const canvasWidth = width;
        const canvasHeight = Math.max(320, Math.round(canvasWidth / ratio));
        const canvas = document.createElement("canvas");
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        const context = canvas.getContext("2d");
        context.fillStyle = "#ffffff";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL("image/png"));
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("Failed to render BPMN SVG."));
      };
      image.src = url;
    });
  }

  async function generateReportBpmnImageForTask(taskId) {
    if (!bpmnReportRendererElement || !taskId) return "";
    const response = await fetchWithSession(
      `/api/damprojects/generateTaskReportBPMN`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          project_id: idproject,
          subtask_id: taskId,
        }),
      },
    );
    if (!response.ok) {
      throw new Error(`BPMN generation failed for task ${taskId}.`);
    }
    reportBpmnXml = await response.text();
    await tick();
    await sleep(350);
    const svg = await bpmnReportRendererElement.saveSVG();
    return svgToPngDataUrl(svg);
  }

  function getActionPlanL3Options(tasks = [], groupsByLevel = {}) {
    const groups = new Map();
    tasks.forEach((task) => {
      const l3 = groupsByLevel.L3?.[task.task_id] || {
        id: task.task_id,
        name: taskNameById[task.task_id] || "Other Tasks",
      };
      if (!l3?.id) return;
      const group = groups.get(l3.id) || {
        id: l3.id,
        name: l3.name || "Other Tasks",
        tasks: [],
      };
      group.tasks.push({
        id: task.id,
        name: task.name || task.task || task.label || task.id,
        value: Number(task.value ?? task.nrecordings ?? 0) || 0,
        teams: Array.isArray(task.teams) ? task.teams.filter(Boolean) : [],
      });
      groups.set(l3.id, group);
    });
    return [...groups.values()].sort((left, right) =>
      left.name.localeCompare(right.name),
    );
  }

  function filterActionPlanL3Options(options = [], searchTerm = "") {
    const needle = String(searchTerm || "")
      .trim()
      .toLowerCase();
    if (!needle) return options;
    return options
      .map((option) => {
        const groupMatches = option.name.toLowerCase().includes(needle);
        const tasks = groupMatches
          ? option.tasks
          : option.tasks.filter((task) =>
              String(task.name || "")
                .toLowerCase()
                .includes(needle),
            );
        return tasks.length
          ? {
              ...option,
              tasks,
            }
          : null;
      })
      .filter(Boolean);
  }

  function filterReportL3Options(
    options = [],
    searchTerm = "",
    teamFilter = "",
    l3Filter = "",
  ) {
    const needle = String(searchTerm || "")
      .trim()
      .toLowerCase();
    return options
      .filter((option) => !l3Filter || option.id === l3Filter)
      .map((option) => {
        const groupMatches = option.name.toLowerCase().includes(needle);
        const tasks = option.tasks.filter(
          (task) =>
            (!teamFilter || task.teams.includes(teamFilter)) &&
            (!needle ||
              groupMatches ||
              String(task.name || "")
                .toLowerCase()
                .includes(needle)),
        );
        return tasks.length ? { ...option, tasks } : null;
      })
      .filter(Boolean);
  }

  function openActionPlanModal() {
    const currentTask = subtaskList.find((task) => task.id === currentSubtask);
    const currentL3 = currentTask?.task_id || "";
    const initialGroup =
      actionPlanL3Options.find((option) => option.id === currentL3) ||
      actionPlanL3Options[0];
    selectedActionPlanTaskIds = initialGroup
      ? initialGroup.tasks.map((task) => task.id)
      : [];
    openActionPlanL3Groups = initialGroup ? { [initialGroup.id]: true } : {};
    actionPlanSearchTerm = "";
    actionPlanPage = 1;
    actionPlanModalOpen = true;
  }

  function closeActionPlanModal() {
    if (actionPlanGenerating) return;
    actionPlanModalOpen = false;
  }

  function actionPlanGroupSelected(group) {
    return (
      group.tasks.length > 0 &&
      group.tasks.every((task) => selectedActionPlanTaskIds.includes(task.id))
    );
  }

  function actionPlanGroupPartlySelected(group) {
    return group.tasks.some((task) =>
      selectedActionPlanTaskIds.includes(task.id),
    );
  }

  function toggleActionPlanGroupOpen(groupId) {
    openActionPlanL3Groups = {
      ...openActionPlanL3Groups,
      [groupId]: !openActionPlanL3Groups[groupId],
    };
  }

  function toggleActionPlanL3(group) {
    const taskIds = group.tasks.map((task) => task.id);
    const allSelected = taskIds.every((id) =>
      selectedActionPlanTaskIds.includes(id),
    );
    selectedActionPlanTaskIds = allSelected
      ? selectedActionPlanTaskIds.filter((id) => !taskIds.includes(id))
      : [...new Set([...selectedActionPlanTaskIds, ...taskIds])];
  }

  function toggleActionPlanTask(taskId) {
    selectedActionPlanTaskIds = selectedActionPlanTaskIds.includes(taskId)
      ? selectedActionPlanTaskIds.filter((id) => id !== taskId)
      : [...selectedActionPlanTaskIds, taskId];
  }

  function selectAllActionPlanL3() {
    selectedActionPlanTaskIds = filteredActionPlanL3Options.flatMap((option) =>
      option.tasks.map((task) => task.id),
    );
  }

  function clearActionPlanL3() {
    selectedActionPlanTaskIds = [];
  }

  function selectedActionPlanGroups() {
    return actionPlanL3Options
      .map((option) => ({
        id: option.id,
        name: option.name,
        tasks: option.tasks.filter((task) =>
          selectedActionPlanTaskIds.includes(task.id),
        ),
      }))
      .filter((option) => option.tasks.length);
  }

  function openReportModal() {
    const currentTask = subtaskList.find((task) => task.id === currentSubtask);
    const initialTask = currentTask || subtaskList[0];
    const initialL3 = initialTask?.task_id || "";
    reportMode = reportMode || "manager";
    selectedReportTaskIds = initialTask ? [initialTask.id] : [];
    openReportL3Groups = initialL3 ? { [initialL3]: true } : {};
    reportSearchTerm = "";
    reportTeamFilter = "";
    reportL3Filter = "";
    reportPage = 1;
    reportModalOpen = true;
  }

  function closeReportModal() {
    if (reportGenerating) return;
    reportModalOpen = false;
  }

  function reportGroupSelected(group) {
    return (
      group.tasks.length > 0 &&
      group.tasks.every((task) => selectedReportTaskIds.includes(task.id))
    );
  }

  function reportGroupPartlySelected(group) {
    return group.tasks.some((task) => selectedReportTaskIds.includes(task.id));
  }

  function toggleReportGroupOpen(groupId) {
    openReportL3Groups = {
      ...openReportL3Groups,
      [groupId]: !openReportL3Groups[groupId],
    };
  }

  function toggleReportL3(group) {
    const taskIds = group.tasks.map((task) => task.id);
    const allSelected = taskIds.every((id) =>
      selectedReportTaskIds.includes(id),
    );
    selectedReportTaskIds = allSelected
      ? selectedReportTaskIds.filter((id) => !taskIds.includes(id))
      : [...new Set([...selectedReportTaskIds, ...taskIds])];
  }

  function toggleReportTask(taskId) {
    selectedReportTaskIds = selectedReportTaskIds.includes(taskId)
      ? selectedReportTaskIds.filter((id) => id !== taskId)
      : [...selectedReportTaskIds, taskId];
  }

  function selectAllReportTasks() {
    selectedReportTaskIds = filteredReportL3Options.flatMap((option) =>
      option.tasks.map((task) => task.id),
    );
  }

  function clearReportTasks() {
    selectedReportTaskIds = [];
  }

  function selectedReportTasks() {
    return reportL3Options
      .flatMap((option) => option.tasks)
      .filter((task) => selectedReportTaskIds.includes(task.id))
      .map((task) => ({ id: task.id, name: task.name }));
  }

  async function startActionPlanDownload() {
    const selectedGroups = selectedActionPlanGroups();
    if (!selectedGroups.length) return;
    actionPlanGenerating = true;
    reportGenerating = true;
    setReportToast(
      "info",
      "Generating action plan",
      `Generating action plan for ${selectedGroups.length} L3 area${selectedGroups.length === 1 ? "" : "s"}.`,
    );
    try {
      const response = await fetchWithSession(
        `/api/damprojects/generateActionPlan`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            project_id: idproject,
            l3_groups: selectedGroups,
          }),
        },
      );
      if (response.status !== 200) {
        let message = "Failed to generate action plan.";
        try {
          const responseText = await response.text();
          if (responseText) {
            try {
              const data = JSON.parse(responseText);
              message = data?.message || responseText;
            } catch (parseError) {
              message = responseText;
            }
          }
        } catch (error) {
          message = error?.message || message;
        }
        throw new Error(message);
      }
      const blob = await response.blob();
      const filename = getDownloadFilename(response, "action_plan.pdf");
      downloadBlob(blob, filename);
      setReportToast(
        "success",
        "Action plan ready",
        `Downloaded action plan for ${selectedGroups.length} L3 area${selectedGroups.length === 1 ? "" : "s"}.`,
      );
      actionPlanModalOpen = false;
    } catch (error) {
      setReportToast(
        "error",
        "Action plan generation failed",
        error?.message || "Failed to generate action plan.",
      );
    } finally {
      actionPlanGenerating = false;
      reportGenerating = false;
    }
  }

  function selectAllActivities() {
    includesActivities = bpmnActivityRows
      .filter((activity) => bpmnAllowedActivities.has(activity.activity))
      .map((activity) => activity.id);
  }

  function toggleBpmnVariant(variantId) {
    bpmnVariantIds = bpmnVariantIds.includes(variantId)
      ? bpmnVariantIds.filter((id) => id !== variantId)
      : [...bpmnVariantIds, variantId];
  }

  function toggleBpmnVariantGroup(group) {
    const groupIds = group.variants.map((variant) => variant.id);
    const allSelected = groupIds.every((id) => bpmnVariantIds.includes(id));
    bpmnVariantIds = allSelected
      ? bpmnVariantIds.filter((id) => !groupIds.includes(id))
      : [...new Set([...bpmnVariantIds, ...groupIds])];
  }

  function toggleBpmnVariantGroupOpen(group) {
    bpmnOpenVariantGroups = {
      ...bpmnOpenVariantGroups,
      [group.id]: !group.open,
    };
  }

  function selectAllBpmnVariants() {
    bpmnVariantIds = variantOptions.map((variant) => variant.id);
  }

  function selectVisibleActivities() {
    const visibleLabels = new Set(
      activitiesToShow
        .map((activity) => activity.data?.label)
        .filter((label) => label && label !== "Start" && label !== "End"),
    );
    includesActivities = bpmnActivityRows
      .filter((activity) => visibleLabels.has(activity.activity))
      .map((activity) => activity.id);
  }

  function openBpmnModal() {
    bpmnVariantIds = selectedVariantIds.length
      ? [...selectedVariantIds]
      : variantOptions[0]
        ? [variantOptions[0].id]
        : [];
    bpmnOpenVariantGroups = {};
    selectVisibleActivities();
    bpmnPreviewXml = "";
    bpmnPreviewError = "";
    lastBpmnPreviewSignature = "";
    if (!bicChangeLog.trim()) bicChangeLog = defaultChangeLog();
    bpmnModalOpen = true;
  }

  /**
   * Erster Eintrag fuers Aenderungsprotokoll: Datum und Herkunft des Modells.
   * Damit steht in BIC nachvollziehbar, worauf der Stand beruht. Der Nutzer
   * kann den Text jederzeit ueberschreiben; einmal Geaendertes bleibt stehen.
   */
  function defaultChangeLog() {
    const today = new Date().toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const recordings = Number(infoStats?.recordings) || 0;
    const basis = recordings
      ? `${recordings} recording${recordings === 1 ? "" : "s"}`
      : "process mining data";
    return `${today} Initial release. Derived from ${basis}.`;
  }

  function closeBpmnModal() {
    bpmnModalOpen = false;
    clearTimeout(bpmnPreviewTimer);
    bpmnPreviewRequestSeq += 1;
  }

  async function startTaskReportDownload() {
    const selectedTasks = selectedReportTasks();
    if (!selectedTasks.length) return;
    const reportModeLabel = reportMode === "analyst" ? "Analyst" : "Manager";
    setReportToast(
      "info",
      "Generating report",
      `Generating ${reportModeLabel} report${selectedTasks.length === 1 ? "" : "s"} for ${selectedTasks.length} task${selectedTasks.length === 1 ? "" : "s"}. This may take a few moments.`,
    );
    reportGenerating = true;
    try {
      const bpmnImages = {};
      for (const task of selectedTasks) {
        const bpmnImage = await generateReportBpmnImageForTask(task.id);
        if (bpmnImage) bpmnImages[task.id] = bpmnImage;
      }
      const downloadResponse = await fetchWithSession(
        `/api/damprojects/generateReport`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            project_id: idproject,
            report_type: reportMode,
            tasks: selectedTasks,
            bpmn_images: bpmnImages,
          }),
        },
      );
      if (downloadResponse.status !== 200) {
        let message = "Failed to generate report.";
        const responseText = await downloadResponse.text();
        if (responseText) {
          try {
            const data = JSON.parse(responseText);
            message = data?.message || responseText;
          } catch (parseError) {
            message = responseText;
          }
        }
        throw new Error(message);
      }
      const blob = await downloadResponse.blob();
      const filename = getDownloadFilename(
        downloadResponse,
        selectedTasks.length === 1
          ? `${reportModeLabel}_${l4Filename(selectedTasks[0].name)}`
          : `${reportModeLabel}_task_reports.zip`,
      );
      downloadBlob(blob, filename);
      setReportToast(
        "success",
        "Report ready",
        `Downloaded ${selectedTasks.length} report${selectedTasks.length === 1 ? "" : "s"}.`,
      );
      reportModalOpen = false;
    } catch (error) {
      setReportToast(
        "error",
        "Report generation failed",
        error?.message || "Failed to generate report.",
      );
    } finally {
      reportGenerating = false;
    }
  }

  function setFilteredSubtaskList(
    selectedProcess,
    selectedSubprocess,
    selectedTask,
    selectedTeam,
  ) {
    let availableSubprocess = listOfSubprocesses.filter(
      (subprocess) =>
        (!selectedProcess || subprocess.process_id === selectedProcess) &&
        (!selectedSubprocess || selectedSubprocess === subprocess.id),
    );

    filteredSubtaskList = subtaskList.filter(
      (subtask) =>
        ((!selectedProcess && !selectedSubprocess) ||
          availableSubprocess.some((subprocess) =>
            subprocess.tasks.some((task) => task.id === subtask.task_id),
          )) &&
        (!selectedTask || subtask.task_id === selectedTask),
    );

    if (selectedTeam) {
      let selectedTeamName = listOfTeams.find(
        (team) => team.teamid === selectedTeam,
      )?.team;
      filteredSubtaskList = filteredSubtaskList.filter((subtask) =>
        subtask.teams.includes(selectedTeamName),
      );
    }
  }

  function formatedTime(totalSec) {
    if (!totalSec || !Number.isFinite(totalSec)) return "";
    const minutes = Math.floor(totalSec / 60);
    const seconds = Math.floor(totalSec % 60);

    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  function formatActivityAvgTime(totalSec) {
    const formatted = formatedTime(Number(totalSec));
    return formatted ? `${formatted} min` : "-";
  }

  function openActivityEditorFromNode(activityId, activityName) {
    activityEditorElement?.openEditorForActivity?.(activityId, activityName);
  }

  function formatRuns(value) {
    const number = Number(value) || 0;
    const abs = Math.abs(number);
    if (abs >= 1_000_000) return `${(number / 1_000_000).toFixed(2)} M`;
    if (abs >= 10_000) return `${(number / 1_000).toFixed(1)} k`;
    return new Intl.NumberFormat("de-DE", {
      maximumFractionDigits: 0,
    }).format(number);
  }

  function formatCurrency(value) {
    const number = Number(value) || 0;
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(number);
  }

  function formatActivityLabel(label) {
    return String(label || "").replace(/__run_\d+$/i, "");
  }

  function setExplorerMode(mode) {
    explorerMode = mode;
    if (explorerMode === "optimization" && currentSubtask) {
      loadOptimizationData(currentSubtask);
    }
  }

  function opportunityToCard(opportunity, index) {
    return {
      id: opportunity.id,
      title: opportunity.title,
      tags: opportunity.tags || [],
      steps: opportunity.steps || [],
      stepImpacts: opportunity.stepImpacts || [],
      savingSeconds: opportunity.savingSeconds || 0,
      impactPercent: opportunity.impactPercent || 0,
      color: OPTIMIZATION_COLORS[index % OPTIMIZATION_COLORS.length],
    };
  }

  async function loadOptimizationData(subtaskId) {
    if (!subtaskId || optimizationLoadedSubtask === subtaskId) {
      return;
    }
    const requestSeq = optimizationRequestSeq + 1;
    optimizationRequestSeq = requestSeq;
    optimizationLoading = true;
    optimizationError = "";
    optimizationLoadedSubtask = subtaskId;
    optimizationData = null;
    selectedOpportunityIds = [];
    openOpportunityDetails = {};
    try {
      const response = await fetchWithSession(
        `/api/damprojects/taskOptimization?idproject=${idproject}&subtaskid=${subtaskId}`,
      );
      const data = await response.json();
      if (!response.ok || data.status === "error") {
        throw new Error(data.message || "Failed to load optimization data.");
      }
      if (
        requestSeq !== optimizationRequestSeq ||
        subtaskId !== currentSubtask
      ) {
        return;
      }
      optimizationData = data;
      selectedOpportunityIds = (data.opportunities || [])
        .slice(0, 2)
        .map((opportunity) => opportunity.id);
    } catch (error) {
      if (requestSeq !== optimizationRequestSeq) {
        return;
      }
      optimizationError = error?.message || "Failed to load optimization data.";
      optimizationLoadedSubtask = "";
    } finally {
      if (requestSeq === optimizationRequestSeq) {
        optimizationLoading = false;
      }
    }
  }

  function getOptimizationTotals(data, opportunities) {
    const selected = opportunities || [];
    const current = Number(data?.currentAvgTimeSeconds) || 0;
    const yearlyFrequency =
      data?.yearlyFrequency ??
      data?.monthlyFrequency ??
      currentSubtaskEntry?.monthly_frequency ??
      100;
    const costPerHour = Number(data?.costPerHour ?? 100) || 0;
    const saved = selected.reduce(
      (sum, opportunity) =>
        sum + getOpportunitySavingSeconds(opportunity, current),
      0,
    );
    const yearlySaved = (saved * Number(yearlyFrequency || 0)) / 3600;
    const yearlySavedCost = yearlySaved * costPerHour;
    return {
      currentAvgTimeSeconds: current,
      optimizedTimeSeconds: Math.max(current - saved, 0),
      reductionPercent: current ? Math.round((saved / current) * 1000) / 10 : 0,
      yearlyFrequency,
      costPerHour,
      yearlyHours: data?.yearlyHours ?? data?.monthlyHours ?? 0,
      yearlySavedHours: Math.round(yearlySaved * 10) / 10,
      yearlySavedCost: Math.round(yearlySavedCost),
      selectedCount: selected.length,
    };
  }

  function toggleOpportunity(opportunityId) {
    selectedOpportunityIds = selectedOpportunityIds.includes(opportunityId)
      ? selectedOpportunityIds.filter((id) => id !== opportunityId)
      : [...selectedOpportunityIds, opportunityId];
  }

  function selectAllOpportunities() {
    const opportunities = optimizationData?.opportunities || [];
    if (!opportunities.length) return;
    selectedOpportunityIds = opportunities.map((opportunity) => opportunity.id);
  }

  function clearOpportunities() {
    selectedOpportunityIds = [];
  }

  function getOpportunityStats(opportunities) {
    const selected = opportunities || [];
    return {
      count: selected.length,
      impact: selected.reduce(
        (sum, opportunity) => sum + (Number(opportunity.impactPercent) || 0),
        0,
      ),
      potential: selected.reduce(
        (sum, opportunity) => sum + getOpportunityYearlyCost(opportunity),
        0,
      ),
    };
  }

  function toggleOpportunityDetails(opportunityId) {
    openOpportunityDetails = {
      ...openOpportunityDetails,
      [opportunityId]: !openOpportunityDetails[opportunityId],
    };
  }

  function getOpportunityColor(opportunityId) {
    return (
      optimizationOpportunityCards.find(
        (opportunity) => opportunity.id === opportunityId,
      )?.color || "#d8ecff"
    );
  }

  function getOpportunityYearlyHours(opportunity) {
    const yearlyFrequency = Number(optimizationTotals.yearlyFrequency) || 0;
    const savingSeconds = getOpportunitySavingSeconds(
      opportunity,
      optimizationTotals.currentAvgTimeSeconds,
    );
    return (savingSeconds * yearlyFrequency) / 3600;
  }

  function getOpportunityYearlyCost(opportunity) {
    return (
      getOpportunityYearlyHours(opportunity) *
      (Number(optimizationTotals.costPerHour) || 0)
    );
  }

  function getOpportunitySavingSeconds(opportunity, currentAvgTimeSeconds) {
    const impactPercent = Number(opportunity?.impactPercent);
    if (Number.isFinite(impactPercent)) {
      return ((Number(currentAvgTimeSeconds) || 0) * impactPercent) / 100;
    }
    return Number(opportunity?.savingSeconds) || 0;
  }

  async function refreshOptimizationFrequency() {
    const updateKey = `taskFrequencyUpdated:${idproject}`;
    const currentUpdate = localStorage.getItem(updateKey) || "";
    if (!currentUpdate || currentUpdate === lastTaskFrequencyUpdate) {
      return;
    }
    lastTaskFrequencyUpdate = currentUpdate;

    const previousFrequency =
      optimizationData?.yearlyFrequency ??
      optimizationData?.monthlyFrequency ??
      currentSubtaskEntry?.monthly_frequency;
    const tasks = await getSubtasks();
    const updatedTask = tasks.find((task) => task.id === currentSubtask);
    const nextFrequency = updatedTask?.monthly_frequency;

    if (
      explorerMode === "optimization" &&
      currentSubtask &&
      Number(previousFrequency) !== Number(nextFrequency)
    ) {
      optimizationLoadedSubtask = "";
      await loadOptimizationData(currentSubtask);
    }
  }

  async function getSubtasks() {
    loadingSubtaskList = true;
    try {
      const applicableFilters = getApplicableFilters($damfilters[idproject]);
      const filterString = JSON.stringify(applicableFilters);

      let response = await fetchWithSession(
        `/api/damprojects/get-relevant-subtasks?project_id=${idproject}&filter=${filterString}&source=${dataSource()}`,
      );
      if (!response.ok && response.status >= 500) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        response = await fetchWithSession(
          `/api/damprojects/get-relevant-subtasks?project_id=${idproject}&filter=${filterString}&source=${dataSource()}`,
        );
      }
      if (!response.ok) {
        throw new Error(`Failed to load subtasks (${response.status})`);
      }
      const data = await response.json();
      const tasks = Array.isArray(data) ? data : [];
      subtaskList = tasks.map(({ nrecordings: value, ...res }) => ({
        value,
        ...res,
      }));
      filteredSubtaskList = subtaskList;
      return subtaskList;
    } catch (err) {
      console.error("Failed to load subtasks", err);
      return subtaskList;
    } finally {
      loadingSubtaskList = false;
    }
  }

  function getTaskNameById(subprocesses = []) {
    const taskNames = {};
    subprocesses.forEach((subprocess) => {
      (subprocess.tasks || []).forEach((task) => {
        taskNames[task.id] = task.name;
      });
    });
    return taskNames;
  }

  function getTaskGroupsByLevel(processes = [], subprocesses = []) {
    const processNameById = Object.fromEntries(
      processes.map((process) => [process.id, process.name]),
    );
    const groupsByLevel = { L1: {}, L2: {}, L3: {} };
    subprocesses.forEach((subprocess) => {
      (subprocess.tasks || []).forEach((task) => {
        groupsByLevel.L1[task.id] = {
          id: subprocess.process_id || "unknown",
          name:
            processNameById[subprocess.process_id] ||
            subprocess.process ||
            "Other Processes",
        };
        groupsByLevel.L2[task.id] = {
          id: subprocess.id || "unknown",
          name: subprocess.name || "Other Subprocesses",
        };
        groupsByLevel.L3[task.id] = {
          id: task.id || "unknown",
          name: task.name || "Other Tasks",
        };
      });
    });
    return groupsByLevel;
  }

  function openTaskFrequencyMapping() {
    window.open(
      `${ROUTES.dam.taskfrequencymapping}?idproject=${idproject}`,
      "_blank",
    );
  }

  async function getTaskGraph(
    subtaskid,
    requestedVariantIds = selectedVariantIds,
  ) {
    showBpmnViewer = false;
    if (toastMsg === null) return;
    // Die Datenquelle gehoert zum Geltungsbereich: beim Wechsel Registrations <-> Main
    // wird die Varianten-/Uebergangsauswahl wie beim Aufgabenwechsel zurueckgesetzt.
    const graphScope = `${subtaskid}-${selectedProcess}-${selectedSubprocess}-${selectedTeam}-${dataSource()}`;
    const graphContext = `${graphScope}-${graphMode}`;
    const contextChanged =
      lastSubtask !== subtaskid || lastGraphContext !== graphContext;
    if (contextChanged) {
      requestedVariantIds = [];
      const scopeChanged = lastGraphScope !== graphScope;
      if (scopeChanged || graphMode !== "variants") {
        selectedVariantIds = [];
      }
      appliedVariantIds = [];
      preservedTransitionOptions = [];
      openVariantGroups = {};
      contextualWindowSequences = {};
    }
    const applicableFilters = getApplicableFilters($damfilters[idproject]);
    const filterString = JSON.stringify(applicableFilters);
    const selectedWindowRecordings =
      getSelectedWindowRecordingIds(requestedVariantIds);
    const graphRequestKey = JSON.stringify({
      subtaskid,
      source: dataSource(),
      graphContext,
      graphMode,
      requestedVariantIds,
      expandedNodes,
      filterString,
      graphRefreshSeq,
    });
    if (
      graphRequestKey === inFlightGraphRequestKey ||
      graphRequestKey === lastGraphRequestKey
    ) {
      return;
    }
    inFlightGraphRequestKey = graphRequestKey;
    if (controller) controller.abort();
    controller = new AbortController();
    const requestSeq = ++graphRequestSeq;
    loading = true;
    try {
      // The lists go in the body: many expanded activities made the URL too long (414/431).
      const graphUrl = `/api/damprojects/getProcessGraph?project_id=${idproject}&subtaskid=${subtaskid}&source=${dataSource()}&filter=${filterString}`;
      const response = await fetchWithSession(graphUrl, {
        method: "POST",
        body: JSON.stringify({
          expandedNodes,
          selectedVariants: requestedVariantIds,
          selectedWindowRecordings,
        }),
        suppressSuccessToast: true,
        signal: controller.signal,
      });
      if (!response.ok) {
        throw new Error(`Failed to load process graph (${response.status})`);
      }
      const data = await response.json();
      if (requestSeq !== graphRequestSeq) return;
      toastMsg = "";
      if (data.status == "error") {
        toastMsg = data.message;
        selectedVariantIds = appliedVariantIds;
        loading = false;
        return;
      }
      const variants = (data.variants || []).filter(
        (variant) =>
          variant &&
          typeof variant === "object" &&
          !Array.isArray(variant) &&
          variant.id,
      );
      if (!data.nodes || !data.edges || !data.activities || !variants.length) {
        selectedVariantIds = appliedVariantIds;
        loading = false;
        return;
      }
      lastSubtask = subtaskid;
      lastGraphContext = graphContext;
      lastGraphScope = graphScope;
      if (graphMode === "variants" && contextChanged && variants.length) {
        const initialVariantIds = getInitialVariantIds(
          variants.filter(variantHasSteps),
        );
        selectedVariantIds = initialVariantIds;
        await getTaskGraph(subtaskid, initialVariantIds);
        return;
      }
      resetGraph();
      graph = data;
      lastGraphRequestKey = graphRequestKey;
      selectedVariantIds = requestedVariantIds;
      appliedVariantIds = requestedVariantIds;
      if (
        graphMode === "transitions" &&
        (contextChanged || initializeTransitions)
      ) {
        selectedTransitionIds = getGreedyTransitionIds(
          data.edges || [],
          data.executionFrequency || 1,
          data.variants || [],
        );
        preservedTransitionOptions = [];
        initializeTransitions = false;
      }
      if (graphMode === "transitions") {
        // Fenstersequenzen VOR dem ersten Zeichnen holen: sonst erscheint der
        // Graph und zeichnet 250 ms spaeter noch einmal (Nutzerbefund 03.09.).
        await tick();
        // der Reaktivblock hat denselben Aufruf gerade eingeplant - abbestellen
        clearTimeout(windowSequenceRefreshTimer);
        lastWindowSequenceSelectionKey = windowSequenceSelectionKey;
        await refreshWindowSequences();
        if (requestSeq !== graphRequestSeq) return;
      }
      loading = false;
      triggerUpdate = false;
      activities = data.activities.map((activity) => ({
        ...activity,
        activity_name: activity.activityname,
        avg_time: data.activityKpis?.[activity.activityname]?.time_per_case,
      }));
      graphActivities = activities;
    } catch (err) {
      if (err.name === "AbortError") {
        return;
      }
      loading = false;
      console.error(err);
    } finally {
      if (inFlightGraphRequestKey === graphRequestKey) {
        inFlightGraphRequestKey = "";
      }
    }
  }

  function toggleVariant(variantId) {
    if (loading) return;
    toggleVariants([variantId]);
  }

  function setGraphMode(mode) {
    if (graphMode === mode) return;
    stopVariantSimulation();
    graphMode = mode;
    minFrequency = 0;
    contextualWindowSequences = {};
    variantPage = 1;
    transitionPage = 1;
    if (mode === "transitions") {
      selectedTransitionIds = [];
      initializeTransitions = true;
    }
    if (mode === "variants") {
      selectedVariantIds = getInitialVariantIds(variantOptions);
      appliedVariantIds = selectedVariantIds;
    }
    if (currentSubtask) {
      getTaskGraph(
        currentSubtask,
        mode === "variants" ? selectedVariantIds : [],
      );
    }
  }

  function variantSteps(variant) {
    return Array.isArray(variant.steps) ? variant.steps.map(String) : [];
  }

  function variantHasSteps(variant) {
    return (
      variantSteps(variant).length > 0 ||
      (Array.isArray(variant.paths) &&
        variant.paths.some(
          (path) => Array.isArray(path?.steps) && path.steps.length > 0,
        ))
    );
  }

  function getInitialVariant(variants) {
    const firstGroup = createVariantGroups(variants)[0];
    if (!firstGroup) return variants[0];

    return firstGroup.variants.find(variantHasSteps) || firstGroup.variants[0];
  }

  function getInitialVariantIds(variants) {
    const initialVariant = getInitialVariant(variants);
    if (!initialVariant) return [];

    return [initialVariant.id];
  }

  function getVariantRecordingIds(variant) {
    if (!Array.isArray(variant?.paths)) return [];
    return variant.paths
      .map((path) => path?.recording_id)
      .filter(Boolean)
      .map(String);
  }

  function stepTransitionIds(steps) {
    const path = ["Start", ...(steps || []), "End"];
    return path
      .slice(0, -1)
      .map((from, index) => getTransitionId({ from, to: path[index + 1] }));
  }

  function getSelectedWindowRecordingIds(
    requestedVariantIds = selectedVariantIds,
  ) {
    if (graphMode === "variants") {
      const requestedIds = new Set(requestedVariantIds || []);
      return [
        ...new Set(
          variantOptions
            .filter((variant) => requestedIds.has(variant.id))
            .flatMap(getVariantRecordingIds),
        ),
      ];
    }

    const selectedIds = new Set(selectedTransitionOptions.map(getTransitionId));
    if (!selectedIds.size) return [];

    const recordingIds = [];
    variantOptions.forEach((variant) => {
      if (Array.isArray(variant.paths) && variant.paths.length) {
        variant.paths.forEach((path) => {
          const pathIds = stepTransitionIds(path.steps || []);
          if (pathIds.some((id) => selectedIds.has(id)) && path.recording_id) {
            recordingIds.push(String(path.recording_id));
          }
        });
        return;
      }

      const pathIds = variantTransitionIds(variant);
      if (pathIds.some((id) => selectedIds.has(id))) {
        recordingIds.push(...getVariantRecordingIds(variant));
      }
    });
    return [...new Set(recordingIds)];
  }

  async function refreshWindowSequences() {
    const selectedWindowRecordings = getSelectedWindowRecordingIds([]);
    if (!currentSubtask) return;
    if (!selectedWindowRecordings.length) {
      contextualWindowSequences = {};
      if (flowPlotterElement?.updateWindowSequences) {
        flowPlotterElement.updateWindowSequences({});
      }
      return;
    }
    if (windowSequenceController) windowSequenceController.abort();
    windowSequenceController = new AbortController();
    const applicableFilters = getApplicableFilters($damfilters[idproject]);
    const filterString = JSON.stringify(applicableFilters);

    try {
      const response = await fetchWithSession(
        `/api/damprojects/getProcessGraph?project_id=${idproject}&subtaskid=${currentSubtask}&source=${dataSource()}&windowSequencesOnly=true&filter=${filterString}`,
        {
          method: "POST",
          body: JSON.stringify({ expandedNodes, selectedWindowRecordings }),
          suppressSuccessToast: true,
          signal: windowSequenceController.signal,
        },
      );
      const data = await response.json();
      const windowSequences = data.windowSequences || {};
      contextualWindowSequences = windowSequences;
      if (flowPlotterElement?.updateWindowSequences) {
        flowPlotterElement.updateWindowSequences(windowSequences);
      }
    } catch (err) {
      if (err.name !== "AbortError") console.error(err);
    }
  }

  function scheduleWindowSequenceRefresh() {
    if (graphMode !== "transitions" || !currentSubtask) return;
    clearTimeout(windowSequenceRefreshTimer);
    windowSequenceRefreshTimer = setTimeout(() => {
      if (loading || graphMode !== "transitions" || !currentSubtask) return;
      refreshWindowSequences();
    }, 250);
  }

  function longestCommonSubsequenceLength(aSteps, bSteps) {
    const previous = Array(bSteps.length + 1).fill(0);
    const current = Array(bSteps.length + 1).fill(0);

    aSteps.forEach((aStep) => {
      for (let index = 1; index <= bSteps.length; index += 1) {
        current[index] =
          aStep === bSteps[index - 1]
            ? previous[index - 1] + 1
            : Math.max(previous[index], current[index - 1]);
      }
      previous.splice(0, previous.length, ...current);
      current.fill(0);
    });

    return previous[bSteps.length];
  }

  function activitySimilarity(aSteps, bSteps) {
    const aSet = new Set(aSteps);
    const bSet = new Set(bSteps);
    const shared = [...aSet].filter((step) => bSet.has(step)).length;
    const sequenceOverlap =
      longestCommonSubsequenceLength(aSteps, bSteps) /
      Math.max(aSteps.length, bSteps.length, 1);

    return {
      lengthRatio:
        Math.min(aSteps.length, bSteps.length) /
        Math.max(aSteps.length, bSteps.length, 1),
      sequenceOverlap,
      activityOverlap: shared / Math.max(aSet.size + bSet.size - shared, 1),
    };
  }

  function variantSimilarityScore(a, b) {
    const similarity = activitySimilarity(variantSteps(a), variantSteps(b));
    return (
      similarity.sequenceOverlap * 0.5 +
      similarity.activityOverlap * 0.35 +
      similarity.lengthRatio * 0.15
    );
  }

  function averageVariantSimilarity(variant, compareVariants) {
    if (!compareVariants.length) return 0;
    return (
      compareVariants.reduce(
        (sum, compareVariant) =>
          sum + variantSimilarityScore(variant, compareVariant),
        0,
      ) / compareVariants.length
    );
  }

  function getTopKVariants(
    variants,
    _selectedVariants,
    variantLimit,
    coveragePercent,
  ) {
    const targetCoverage = Number(coveragePercent) / 100;
    const orderedCandidates = [...variants].sort((a, b) => {
      const countDiff = variantCount(b) - variantCount(a);
      if (countDiff !== 0) return countDiff;
      return (a.activeTime || 0) - (b.activeTime || 0);
    });

    const selected = [];
    for (const variant of orderedCandidates) {
      if (selected.length >= variantLimit) break;
      if (
        selected.reduce((sum, item) => sum + (item.coverage || 0), 0) >=
        targetCoverage
      ) {
        break;
      }
      selected.push(variant);
    }

    return selected;
  }

  function variantCount(variant) {
    return Number(variant?.count) || 0;
  }

  function variantGroupStats(variants) {
    const count = variants.reduce((sum, variant) => sum + variant.count, 0);
    return {
      count,
      coverage: variants.reduce((sum, variant) => sum + variant.coverage, 0),
      activeTime:
        variants.reduce(
          (sum, variant) => sum + variant.activeTime * variant.count,
          0,
        ) / Math.max(count, 1),
    };
  }

  function variantStepCounts(variant) {
    const counts = new Map();
    variantSteps(variant).forEach((step) => {
      counts.set(step, (counts.get(step) || 0) + 1);
    });
    return counts;
  }

  function variantStepMultisetKey(variant) {
    const counts = variantStepCounts(variant);

    return [...counts.entries()]
      .sort(([stepA], [stepB]) => stepA.localeCompare(stepB))
      .map(([step, count]) => `${step}:${count}`)
      .join("|");
  }

  function variantStepOverlap(a, b) {
    const aCounts = variantStepCounts(a);
    const bCounts = variantStepCounts(b);
    const allSteps = new Set([...aCounts.keys(), ...bCounts.keys()]);
    let sharedOccurrences = 0;
    let totalOccurrences = 0;
    let sharedStepTypes = 0;

    allSteps.forEach((step) => {
      const aCount = aCounts.get(step) || 0;
      const bCount = bCounts.get(step) || 0;
      sharedOccurrences += Math.min(aCount, bCount);
      totalOccurrences += Math.max(aCount, bCount);
      if (aCount > 0 && bCount > 0) sharedStepTypes += 1;
    });

    return {
      multiset: totalOccurrences > 0 ? sharedOccurrences / totalOccurrences : 0,
      stepSet: allSteps.size > 0 ? sharedStepTypes / allSteps.size : 0,
      lengthRatio:
        Math.min(variantSteps(a).length, variantSteps(b).length) /
        Math.max(variantSteps(a).length, variantSteps(b).length, 1),
    };
  }

  function areStepSimilarVariants(anchor, candidate) {
    const overlap = variantStepOverlap(anchor, candidate);
    return (
      overlap.stepSet >= 0.72 &&
      overlap.multiset >= 0.62 &&
      overlap.lengthRatio >= 0.55
    );
  }

  function createVariantGroups(variants) {
    const orderedVariants = [...variants].sort((a, b) => {
      const countDiff = variantCount(b) - variantCount(a);
      if (countDiff !== 0) return countDiff;
      return (a.activeTime || 0) - (b.activeTime || 0);
    });
    const used = new Set();
    const groups = [];

    orderedVariants.forEach((anchor) => {
      if (used.has(anchor.id)) return;

      const members = orderedVariants.filter(
        (candidate) =>
          !used.has(candidate.id) &&
          (candidate.id === anchor.id ||
            areStepSimilarVariants(anchor, candidate)),
      );
      members.forEach((member) => used.add(member.id));
      groups.push({
        id: `stepset:${anchor.id}:${variantStepMultisetKey(anchor)}`,
        anchor,
        variants: members,
        ...variantGroupStats(members),
      });
    });

    return groups
      .sort((a, b) => {
        const countDiff = b.count - a.count;
        if (countDiff !== 0) return countDiff;
        return (a.activeTime || 0) - (b.activeTime || 0);
      })
      .map((group, index) => ({
        ...group,
        name: `Variant Group ${String.fromCharCode(65 + index)}`,
      }));
  }

  function setTransitionMinFrequency(event) {
    minFrequency = Math.max(
      0,
      Math.min(minFrequencyMax, Number(event.target.value) || 0),
    );
  }

  function setTransitionMinCount(event) {
    transitionMinCount = Math.max(0, Number(event.target.value) || 0);
  }

  function edgeFrequency(edge, executionFrequency) {
    if (transitionMetric === "occurrences") return Number(edge.value) || 0;
    if (transitionMetric === "caseCoverage") {
      return edgeCaseCoverage(edge, executionFrequency);
    }
    return (
      ((edge.outgoingTransitionRate ??
        edge.transitionRate ??
        edge.value / executionFrequency) ||
        0) * 100
    );
  }

  function edgeCaseCoverage(edge, executionFrequency) {
    return (
      ((edge.caseCoverage ??
        edge.transitionRate ??
        edge.value / executionFrequency) ||
        0) * 100
    );
  }

  function setTransitionMetric(metric) {
    transitionMetric = metric;
    minFrequency = 0;
    transitionPage = 1;
    triggerUpdate = true;
  }

  function transitionMetricLabel() {
    if (transitionMetric === "caseCoverage") return "Case coverage";
    if (transitionMetric === "occurrences") return "Occurrences";
    return "Next-step probability";
  }

  function formatTransitionMetric(edge) {
    const value = edgeFrequency(edge, graph["executionFrequency"] || 1);
    return transitionMetric === "occurrences"
      ? `${Math.round(value)}x`
      : `${Math.round(value)}%`;
  }

  function visibleTransitionIds() {
    return visibleTransitionOptions.map(getTransitionId);
  }

  function getSelectedTransitionOptions(
    visibleOptions,
    selectedIds,
    preservedOptions,
  ) {
    const selectedIdSet = new Set(selectedIds);
    const visibleSelected = visibleOptions.filter((edge) =>
      selectedIdSet.has(getTransitionId(edge)),
    );
    const visibleIds = new Set(visibleSelected.map(getTransitionId));
    const preservedSelected = preservedOptions.filter((edge) => {
      const id = getTransitionId(edge);
      return selectedIdSet.has(id) && !visibleIds.has(id);
    });
    return [...visibleSelected, ...preservedSelected];
  }

  function getGreedyTransitionIds(edges, executionFrequency, variants = []) {
    const usableEdges = edges
      .filter(
        (edge) =>
          edge.from !== edge.to &&
          edgeFrequency(edge, executionFrequency) >= minFrequency &&
          (Number(edge.value) || 0) >= transitionMinCount,
      )
      .sort(
        (a, b) =>
          edgeFrequency(b, executionFrequency) -
          edgeFrequency(a, executionFrequency),
      );
    const outgoing = new Map();
    usableEdges.forEach((edge) => {
      if (!outgoing.has(edge.from)) outgoing.set(edge.from, []);
      outgoing.get(edge.from).push(edge);
    });

    const transitionIds = [];
    const visits = {};
    let current = "Start";
    for (
      let guard = 0;
      current !== "End" && guard < usableEdges.length;
      guard += 1
    ) {
      const nextEdges = outgoing.get(current) || [];
      if (!nextEdges.length) break;

      const visitIndex = visits[current] || 0;
      const edge = nextEdges[visitIndex] || nextEdges[nextEdges.length - 1];
      transitionIds.push(getTransitionId(edge));
      visits[current] = visitIndex + 1;
      current = edge.to;
    }

    const chosen = transitionIds.length
      ? [...new Set(transitionIds)]
      : usableEdges.slice(0, 1).map(getTransitionId);
    // Der wahrscheinlichste Pfad muss keiner tatsaechlich gelaufenen Variante
    // entsprechen (bei den Main-Laeufen: 20 Laeufe, 48 Uebergaenge, kein Treffer ->
    // Quantifizierung zeigt "-"). Dann kommt die haeufigste Variante dazu.
    const chosenSet = new Set(chosen);
    const fitsAny = variants.some((variant) => {
      const path = variantTransitionIds(variant);
      return path.length && path.every((id) => chosenSet.has(id));
    });
    if (!fitsAny && variants.length) {
      const top = [...variants].sort(
        (a, b) => (Number(b.count) || 0) - (Number(a.count) || 0),
      )[0];
      variantTransitionIds(top).forEach((id) => chosenSet.add(id));
    }
    return [...chosenSet];
  }

  function toggleTransition(edge) {
    const id = getTransitionId(edge);
    preservedTransitionOptions = selectedTransitionOptions;
    if (selectedTransitionIds.includes(id)) {
      selectedTransitionIds = selectedTransitionIds.filter(
        (transition) => transition !== id,
      );
    } else {
      selectedTransitionIds = [...selectedTransitionIds, id];
    }
    scheduleWindowSequenceRefresh();
  }

  function selectAllTransitions() {
    preservedTransitionOptions = [];
    selectedTransitionIds = visibleTransitionIds();
    scheduleWindowSequenceRefresh();
  }

  function clearTransitions() {
    preservedTransitionOptions = [];
    selectedTransitionIds = [];
    scheduleWindowSequenceRefresh();
  }

  function buildBridgeEdge(from, to) {
    return {
      from,
      to,
      value: graph["executionFrequency"] || 1,
      transitionRate: 1,
      outgoingTransitionRate: 1,
      caseCoverage: 1,
      dashed: true,
    };
  }

  function buildTransitionGraphEdges(selectedEdges) {
    if (!selectedEdges.length) return [];

    const edgesById = new Map();
    selectedEdges.forEach((edge) => {
      resolveTransitionDisplayEdges(edge).forEach((displayEdge) => {
        edgesById.set(getTransitionId(displayEdge), displayEdge);
      });
    });
    const edges = Array.from(edgesById.values());
    const selectedNodes = new Set();
    edges.forEach((edge) => {
      if (edge.from !== "Start" && edge.from !== "End")
        selectedNodes.add(edge.from);
      if (edge.to !== "Start" && edge.to !== "End") selectedNodes.add(edge.to);
    });

    selectedNodes.forEach((nodeId) => {
      const hasIncoming = edges.some((edge) => edge.to === nodeId);
      const hasOutgoing = edges.some((edge) => edge.from === nodeId);
      if (!hasIncoming) edges.push(buildBridgeEdge("Start", nodeId));
      if (!hasOutgoing) edges.push(buildBridgeEdge(nodeId, "End"));
    });

    return edges;
  }

  function buildVariantGraphEdges(variants) {
    if (!variants.length) return [];

    const graphEdgesById = new Map(
      (graph["edges"] || []).map((edge) => [getTransitionId(edge), edge]),
    );
    const edgeRecords = new Map();
    const edgeCaseRecords = new Map();
    const addEdgeWeight = (from, to, weight) => {
      if (!from || !to || from === to) return;
      const id = getTransitionId({ from, to });
      const record = edgeRecords.get(id) || { from, to, weight: 0 };
      record.weight += weight;
      edgeRecords.set(id, record);
    };

    variants.forEach((variant) => {
      const rawPaths =
        Array.isArray(variant.paths) && variant.paths.length
          ? variant.paths.map((path) => ({
              steps: path.steps || [],
              weight: 1,
            }))
          : [{ steps: variantSteps(variant), weight: variant.count || 1 }];

      rawPaths.forEach(({ steps, weight }) => {
        const path = resolveSimulationPath(steps);
        const seenEdges = new Set();
        path.slice(0, -1).forEach((from, index) => {
          const to = path[index + 1];
          addEdgeWeight(from, to, weight);
          const id = getTransitionId({ from, to });
          if (from && to && from !== to && !seenEdges.has(id)) {
            edgeCaseRecords.set(id, (edgeCaseRecords.get(id) || 0) + weight);
            seenEdges.add(id);
          }
        });
      });
    });

    const outgoingTotals = new Map();
    const incomingTotals = new Map();
    edgeRecords.forEach(({ from, to, weight }) => {
      outgoingTotals.set(from, (outgoingTotals.get(from) || 0) + weight);
      incomingTotals.set(to, (incomingTotals.get(to) || 0) + weight);
    });

    return [...edgeRecords.entries()].map(([id, { from, to, weight }]) => {
      const originalEdge = graphEdgesById.get(id) || {};
      return {
        ...originalEdge,
        from,
        to,
        value: weight,
        transitionRate: weight / Math.max(graph["executionFrequency"] || 0, 1),
        caseCoverage:
          (edgeCaseRecords.get(id) || 0) /
          Math.max(graph["executionFrequency"] || 0, 1),
        outgoingTransitionRate:
          weight / Math.max(outgoingTotals.get(from) || 0, 1),
        incomingTransitionRate:
          weight / Math.max(incomingTotals.get(to) || 0, 1),
      };
    });
  }

  function getTransitionActivityCount(transitionIds) {
    const transitionIdSet = new Set(transitionIds || []);
    const selectedEdges = visibleTransitionOptions.filter((edge) =>
      transitionIdSet.has(getTransitionId(edge)),
    );
    const activityIds = new Set();
    selectedEdges.forEach((edge) => {
      resolveTransitionDisplayEdges(edge).forEach((displayEdge) => {
        if (displayEdge.from !== "Start" && displayEdge.from !== "End") {
          activityIds.add(displayEdge.from);
        }
        if (displayEdge.to !== "Start" && displayEdge.to !== "End") {
          activityIds.add(displayEdge.to);
        }
      });
    });
    return activityIds.size;
  }

  function getActivityLabelForNode(nodeId) {
    if (nodeId === "Start" || nodeId === "End") return nodeId;

    const node = (graph["nodes"] || []).find((item) => item.id === nodeId);
    if (!node?.parentNode) return nodeId;

    const cluster = (graph["activityMappingCluster"] || []).find(
      (item) => item.clusterid === node.parentNode,
    );
    return getClusterLabel(cluster) || node.parentNode.replace(/_cluster$/, "");
  }

  function resolveTransitionDisplayEdges(edge) {
    const nodeIds = new Set((graph["nodes"] || []).map((node) => node.id));
    if (nodeIds.has(edge.from) && nodeIds.has(edge.to)) return [edge];

    const selectedActivities = new Set(
      [edge.from, edge.to].filter(
        (nodeId) => nodeId !== "Start" && nodeId !== "End",
      ),
    );
    const mappedEdges = (graph["edges"] || []).filter((candidate) => {
      const fromActivity = getActivityLabelForNode(candidate.from);
      const toActivity = getActivityLabelForNode(candidate.to);
      const matchesSelectedTransition =
        fromActivity === edge.from && toActivity === edge.to;
      const isSelectedActivityDetail =
        fromActivity === toActivity && selectedActivities.has(fromActivity);
      return matchesSelectedTransition || isSelectedActivityDetail;
    });

    return mappedEdges.length ? mappedEdges : [edge];
  }

  function variantTransitionIds(variant) {
    const path = ["Start", ...variantSteps(variant), "End"];
    return path
      .slice(0, -1)
      .map((from, index) => getTransitionId({ from, to: path[index + 1] }));
  }

  function getSelectedTransitionExactStats(
    edges,
    variants,
    executionFrequency,
  ) {
    const selectedIds = new Set(edges.map(getTransitionId));
    if (!selectedIds.size)
      return {
        count: 0,
        avg: null,
        median: null,
        longest: null,
        coverage: null,
        recordingIds: [],
      };

    const consideredTotal = variants.reduce(
      (sum, variant) => sum + (Number(variant.count) || 0),
      0,
    );
    const matchingVariants = variants.filter((variant) => {
      const path = variantTransitionIds(variant);
      return path.length && path.every((id) => selectedIds.has(id));
    });
    const count = matchingVariants.reduce(
      (sum, variant) => sum + variant.count,
      0,
    );
    if (!count)
      return {
        count: 0,
        avg: null,
        median: null,
        longest: null,
        coverage: null,
        recordingIds: [],
      };

    const sortedVariants = [...matchingVariants].sort(
      (a, b) => (a.activeTime || 0) - (b.activeTime || 0),
    );
    let cumulative = 0;
    let median = null;

    for (const variant of sortedVariants) {
      cumulative += variant.count;
      if (cumulative >= count / 2) {
        median = variant.activeTime || 0;
        break;
      }
    }

    return {
      count,
      avg:
        matchingVariants.reduce(
          (sum, variant) => sum + variant.activeTime * variant.count,
          0,
        ) / count,
      median,
      longest: matchingVariants.reduce(
        (max, variant) => Math.max(max, variant.activeTime || 0),
        0,
      ),
      coverage: Math.min(count / Math.max(consideredTotal, 1), 1),
      recordingIds: [
        ...new Set(matchingVariants.flatMap(getVariantRecordingIds)),
      ],
    };
  }

  function getEdgesForCoverage(
    edges,
    coveragePercent,
    variants,
    executionFrequency,
  ) {
    const targetCoverage = Number(coveragePercent) / 100;
    if (!edges.length || targetCoverage <= 0) return [];
    if (targetCoverage >= 1) return edges;

    for (let index = 1; index <= edges.length; index += 1) {
      const selectedEdges = edges.slice(0, index);
      const stats = getSelectedTransitionExactStats(
        selectedEdges,
        variants,
        executionFrequency,
      );
      if ((stats.coverage || 0) >= targetCoverage) return selectedEdges;
    }

    return edges;
  }

  function getTopKPaths(edges, maxPaths = 50) {
    const outgoing = new Map();
    edges.forEach((edge) => {
      if (!outgoing.has(edge.from)) outgoing.set(edge.from, []);
      outgoing.get(edge.from).push(edge);
    });
    outgoing.forEach((items) =>
      items.sort((a, b) => Number(b.value || 0) - Number(a.value || 0)),
    );

    const paths = [];
    const queue = [{ node: "Start", nodes: ["Start"], edgeIds: [], score: 1 }];

    while (queue.length && paths.length < maxPaths) {
      queue.sort((a, b) => b.score - a.score);
      const current = queue.shift();
      if (current.node === "End") {
        paths.push(current);
        continue;
      }

      (outgoing.get(current.node) || []).forEach((edge, index) => {
        if (edge.to !== "End" && current.nodes.includes(edge.to)) return;
        queue.push({
          node: edge.to,
          nodes: [...current.nodes, edge.to],
          edgeIds: [...current.edgeIds, getTransitionId(edge)],
          score:
            (current.score * (Number(edge.value || 0) + 1)) /
            Math.max(index + 1, 1),
        });
      });
    }

    return paths;
  }

  function getEdgesFromPaths(paths, edges) {
    const edgeById = new Map(
      edges.map((edge) => [getTransitionId(edge), edge]),
    );
    const selectedIds = new Set(paths.flatMap((path) => path.edgeIds));
    return [...selectedIds].map((id) => edgeById.get(id)).filter(Boolean);
  }

  function getPathsForCoverage(
    paths,
    coveragePercent,
    edges,
    variants,
    executionFrequency,
  ) {
    const targetCoverage = Number(coveragePercent) / 100;
    if (!paths.length || targetCoverage <= 0) return [];
    if (targetCoverage >= 1) return paths;

    for (let index = 1; index <= paths.length; index += 1) {
      const selectedEdges = getEdgesFromPaths(paths.slice(0, index), edges);
      const stats = getSelectedTransitionExactStats(
        selectedEdges,
        variants,
        executionFrequency,
      );
      if ((stats.coverage || 0) >= targetCoverage) return paths.slice(0, index);
    }

    return paths;
  }

  function getVariantTimeStats(variants) {
    const count = variants.reduce((sum, variant) => sum + variant.count, 0);
    const sortedVariants = [...variants].sort(
      (a, b) => (a.activeTime || 0) - (b.activeTime || 0),
    );
    let cumulative = 0;
    let median = 0;

    for (const variant of sortedVariants) {
      cumulative += variant.count;
      if (cumulative >= count / 2) {
        median = variant.activeTime || 0;
        break;
      }
    }

    return {
      avg:
        variants.reduce(
          (sum, variant) => sum + variant.activeTime * variant.count,
          0,
        ) / Math.max(count, 1),
      median,
      longest: variants.reduce(
        (max, variant) => Math.max(max, variant.activeTime || 0),
        0,
      ),
    };
  }

  function getProgramsForNodes(nodes, activityKpis) {
    const programs = {};

    nodes.forEach((node) => {
      if (node.id === "Start" || node.id === "End") return;
      const apps =
        activityKpis[node.id]?.apps_all || activityKpis[node.id]?.apps;
      if (!apps) return;
      Object.entries(apps).forEach(([name, ratio]) => {
        programs[name] = (programs[name] || 0) + Number(ratio || 0);
      });
    });

    const total = Object.values(programs).reduce(
      (sum, value) => sum + value,
      0,
    );
    return Object.entries(programs)
      .map(([clearname, ratio]) => ({
        clearname,
        ratio: ratio / Math.max(total, 1),
      }))
      .sort((a, b) => Number(b.ratio) - Number(a.ratio))
      .slice(0, 4);
  }

  function normalizeAppName(name) {
    return `${name || ""}`.trim().toLowerCase();
  }

  function normalizeAppType(type) {
    const normalizedType = `${type || ""}`.trim().toLowerCase();
    return normalizedType === "supportive" ? "support" : normalizedType;
  }

  function addAppTypeKey(target, name, type) {
    const key = normalizeAppName(name);
    if (key) target[key] = type;
  }

  function getAppTypeCandidates(item) {
    return [
      item.id,
      item.applicationname,
      item.appname,
      item.name,
      item.clearname,
      item.windowtitle,
    ];
  }

  function buildAppTypeMapping(mappings, apps = []) {
    const nextAppTypesByName = {};
    mappings.forEach((mapping) => {
      const type = normalizeAppType(mapping.apptype);
      if (!type) return;
      getAppTypeCandidates(mapping).forEach((name) => {
        addAppTypeKey(nextAppTypesByName, name, type);
      });
    });

    apps.forEach((app) => {
      const type = getAppTypeCandidates(app)
        .map((name) => nextAppTypesByName[normalizeAppName(name)])
        .find(Boolean);
      if (!type) return;
      getAppTypeCandidates(app).forEach((name) => {
        addAppTypeKey(nextAppTypesByName, name, type);
      });
    });

    appTypesByName = nextAppTypesByName;
  }

  function loadAppnameMapping() {
    fetchWithSession(`/api/damprojects/getAppnameMapping`)
      .then((res) => res.json())
      .then((data) => {
        appNameMappings = data || [];
      });
  }

  function getLegendItems(metric) {
    if (metric === "appType") return APP_TYPE_DEFINITIONS;
    if (metric === "text" || metric === "copy" || metric === "time") {
      return TRAFFIC_LIGHT_LEGEND;
    }
    if (metric === "optimization:classification") return CLASSIFICATION_LEGEND;
    if (metric === "optimization:savings") return SAVINGS_LEGEND;
    return [];
  }

  function getNodesForEdges(nodes, edges) {
    if (!edges.length) return [];
    const nodeIds = new Set();
    const nodesById = new Map(nodes.map((node) => [node.id, node]));
    edges.forEach((edge) => {
      nodeIds.add(edge.from);
      nodeIds.add(edge.to);
      const fromNode = nodesById.get(edge.from);
      const toNode = nodesById.get(edge.to);
      if (fromNode?.parentNode) nodeIds.add(fromNode.parentNode);
      if (toNode?.parentNode) nodeIds.add(toNode.parentNode);
    });
    const visibleNodes = nodes.filter((node) => nodeIds.has(node.id));
    ["Start", "End"].forEach((terminalId) => {
      if (nodeIds.has(terminalId) && !nodesById.has(terminalId)) {
        visibleNodes.push({
          id: terminalId,
          label: terminalId,
          shortlabel: terminalId,
        });
      }
    });
    return visibleNodes;
  }

  function hasStartEndPath(edgeList) {
    const forward = new Map();
    edgeList.forEach((edge) => {
      if (!forward.has(edge.from)) forward.set(edge.from, []);
      forward.get(edge.from).push(edge.to);
    });

    const seen = new Set(["Start"]);
    const queue = ["Start"];
    while (queue.length) {
      const current = queue.shift();
      if (current === "End") return true;
      (forward.get(current) || []).forEach((next) => {
        if (!seen.has(next)) {
          seen.add(next);
          queue.push(next);
        }
      });
    }
    return false;
  }

  function getMaxSafeMinFrequency(edges, executionFrequency) {
    const rawEdges = edges.filter((edge) => edge.from !== edge.to);
    if (!rawEdges.length) return 0;

    const thresholds = [
      ...new Set(
        rawEdges.map((edge) =>
          Math.floor(edgeFrequency(edge, executionFrequency)),
        ),
      ),
    ].sort((a, b) => b - a);
    for (const threshold of thresholds) {
      const filteredEdges = rawEdges.filter(
        (edge) => edgeFrequency(edge, executionFrequency) >= threshold,
      );
      if (hasStartEndPath(filteredEdges)) return threshold;
    }

    return 0;
  }

  function normalizeLabel(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function getClusterLabel(cluster) {
    return (
      cluster?.label ||
      cluster?.activityname ||
      cluster?.activity ||
      cluster?.clusterid?.replace(/_cluster$/, "") ||
      ""
    );
  }

  function getActivityClusterId(activityLabel) {
    const normalizedActivity = normalizeLabel(activityLabel);
    return (graph["activityMappingCluster"] || []).find(
      (cluster) =>
        normalizeLabel(getClusterLabel(cluster)) === normalizedActivity,
    )?.clusterid;
  }

  function getActivityDetailPath(activityLabel) {
    const clusterId = getActivityClusterId(activityLabel);
    if (!clusterId) return [];

    const childIds = (graph["nodes"] || [])
      .filter((node) => node.parentNode === clusterId)
      .map((node) => node.id);
    if (!childIds.length) return [];

    const childIdSet = new Set(childIds);
    const internalEdges = (graph["edges"] || []).filter(
      (edge) => childIdSet.has(edge.from) && childIdSet.has(edge.to),
    );
    if (!internalEdges.length) return childIds;

    const incomingCount = {};
    internalEdges.forEach((edge) => {
      incomingCount[edge.to] = (incomingCount[edge.to] || 0) + 1;
    });

    const entryNodes = (graph["edges"] || [])
      .filter((edge) => !childIdSet.has(edge.from) && childIdSet.has(edge.to))
      .sort((a, b) => (b.value || 0) - (a.value || 0))
      .map((edge) => edge.to);
    const startNodes = entryNodes.length
      ? entryNodes
      : childIds.filter((id) => !incomingCount[id]);

    const orderedIds = [];
    const visited = new Set();
    const walkFrom = (startId) => {
      let current = startId;
      for (let guard = 0; current && guard < childIds.length; guard += 1) {
        if (visited.has(current)) return;
        orderedIds.push(current);
        visited.add(current);
        current = internalEdges
          .filter((edge) => edge.from === current && !visited.has(edge.to))
          .sort((a, b) => (b.value || 0) - (a.value || 0))[0]?.to;
      }
    };

    [...new Set(startNodes)].forEach(walkFrom);
    childIds.forEach((id) => {
      if (!visited.has(id)) walkFrom(id);
    });

    return orderedIds;
  }

  function getVariantSimulationPaths(variant) {
    if (!variant) return [];
    const rawPaths =
      Array.isArray(variant.paths) && variant.paths.length
        ? variant.paths.map((path) => path.steps || [])
        : [variantSteps(variant)];
    const paths = rawPaths
      .map((steps) => resolveSimulationPath(steps))
      .filter((path) => path.length);
    const uniquePaths = [];
    const seen = new Set();
    paths.forEach((path) => {
      const key = path.join("->");
      if (!seen.has(key)) {
        seen.add(key);
        uniquePaths.push(path);
      }
    });
    return uniquePaths;
  }

  function resolveSimulationPath(steps) {
    const nodeIds = new Set((graph["nodes"] || []).map((node) => node.id));
    const labelToNodeId = new Map(
      (graph["nodes"] || []).map((node) => [
        normalizeLabel(node.shortlabel || node.label || node.id),
        node.id,
      ]),
    );
    const resolvedSteps = steps.flatMap((step) => {
      if (nodeIds.has(step)) return [step];

      const nodeId = labelToNodeId.get(normalizeLabel(step));
      if (nodeId) return [nodeId];

      return getActivityDetailPath(step);
    });

    if (resolvedSteps.length) return ["Start", ...resolvedSteps, "End"];

    return getVisibleStartEndPath(graph["edges"] || []);
  }

  function getVisibleStartEndPath(edges) {
    const forward = new Map();
    edges.forEach((edge) => {
      if (!forward.has(edge.from)) forward.set(edge.from, []);
      forward.get(edge.from).push(edge);
    });

    const queue = [["Start"]];
    const seen = new Set(["Start"]);
    while (queue.length) {
      const path = queue.shift();
      const current = path[path.length - 1];
      if (current === "End") return path;

      (forward.get(current) || [])
        .sort((a, b) => (b.value || 0) - (a.value || 0))
        .forEach((edge) => {
          if (!seen.has(edge.to)) {
            seen.add(edge.to);
            queue.push([...path, edge.to]);
          }
        });
    }
    return [];
  }

  function stopVariantSimulation() {
    if (simulationTimer) clearInterval(simulationTimer);
    simulationSlate = "";
    simulationTimer = null;
    simulationVariantId = "";
    simulationStep = 0;
    simulationCaseIndex = 0;
  }

  function playVariantSimulation(variant) {
    if (simulationVariantId === variant.id) {
      stopVariantSimulation();
      return;
    }

    if (simulationTimer) clearInterval(simulationTimer);
    simulationVariantId = variant.id;
    simulationStep = 0;
    simulationCaseIndex = 0;
    playSimulationCase(variant, 0);
  }

  function playSimulationCase(variant, caseIndex) {
    const paths = getVariantSimulationPaths(variant);
    if (!paths.length || caseIndex >= paths.length) {
      stopVariantSimulation();
      return;
    }

    simulationCaseIndex = caseIndex;
    simulationStep = 0;
    simulationSlate = `${caseIndex + 1}/${paths.length}`;

    setTimeout(() => {
      if (simulationVariantId !== variant.id) return;
      simulationSlate = "";
      const maxStep = Math.max(paths[caseIndex].length * 2 - 2, 0);
      simulationTimer = setInterval(() => {
        if (simulationStep >= maxStep) {
          clearInterval(simulationTimer);
          simulationTimer = null;
          playSimulationCase(variant, caseIndex + 1);
          return;
        }
        simulationStep += 1;
      }, 1000);
    }, 1000);
  }

  function toggleVariantGroupOpen(group, index) {
    const isOpen = openVariantGroups[group.id] ?? index === 0;
    openVariantGroups = {
      ...openVariantGroups,
      [group.id]: !isOpen,
    };
  }

  function toggleVariantGroup(group) {
    if (loading) return;
    triggerUpdate = false;
    const groupIds = group.variants.map((variant) => variant.id);
    const allSelected = groupIds.every((id) => selectedVariantIds.includes(id));
    let nextVariantIds = allSelected
      ? selectedVariantIds.filter((id) => !groupIds.includes(id))
      : [...new Set([...selectedVariantIds, ...groupIds])];

    selectedVariantIds = nextVariantIds;
    appliedVariantIds = nextVariantIds;
    if (nextVariantIds.length) getTaskGraph(currentSubtask, nextVariantIds);
  }

  function toggleVariants(variantIds) {
    if (loading) return;
    triggerUpdate = false;
    const allSelected = variantIds.every((id) =>
      selectedVariantIds.includes(id),
    );
    let nextVariantIds;
    if (allSelected) {
      nextVariantIds = selectedVariantIds.filter(
        (id) => !variantIds.includes(id),
      );
    } else {
      nextVariantIds = [...new Set([...selectedVariantIds, ...variantIds])];
    }
    selectedVariantIds = nextVariantIds;
    appliedVariantIds = nextVariantIds;
    if (nextVariantIds.length) getTaskGraph(currentSubtask, nextVariantIds);
  }

  function selectAllVariants() {
    if (loading) return;
    triggerUpdate = false;
    const nextVariantIds = variantOptions.map((variant) => variant.id);
    selectedVariantIds = nextVariantIds;
    getTaskGraph(currentSubtask, nextVariantIds);
  }

  function deselectAllVariants() {
    if (loading) return;
    triggerUpdate = false;
    selectedVariantIds = [];
    appliedVariantIds = [];
  }

  function addNextVariant() {
    if (loading) return selectedVariantIds.length;
    triggerUpdate = false;
    const selectedVariants = variantOptions.filter((variant) =>
      selectedVariantIds.includes(variant.id),
    );
    const candidateVariants = variantOptions.filter(
      (variant) => !selectedVariantIds.includes(variant.id),
    );
    const nextVariant = candidateVariants.sort((a, b) => {
      if (!selectedVariants.length) return variantCount(b) - variantCount(a);
      const similarityDiff =
        averageVariantSimilarity(b, selectedVariants) -
        averageVariantSimilarity(a, selectedVariants);
      if (similarityDiff !== 0) return similarityDiff;
      return variantCount(b) - variantCount(a);
    })[0];
    if (!nextVariant) return selectedVariantIds.length;
    const nextVariantIds = [...selectedVariantIds, nextVariant.id];
    selectedVariantIds = nextVariantIds;
    getTaskGraph(currentSubtask, nextVariantIds);
    return selectedVariantIds.length;
  }

  function removeLastVariant() {
    if (loading) return selectedVariantIds.length;
    triggerUpdate = false;
    const selectedVariants = variantOptions.filter((variant) =>
      selectedVariantIds.includes(variant.id),
    );
    const removeVariant = selectedVariants.sort((a, b) => {
      const aOthers = selectedVariants.filter((variant) => variant.id !== a.id);
      const bOthers = selectedVariants.filter((variant) => variant.id !== b.id);
      const similarityDiff =
        averageVariantSimilarity(a, aOthers) -
        averageVariantSimilarity(b, bOthers);
      if (similarityDiff !== 0) return similarityDiff;
      return variantCount(a) - variantCount(b);
    })[0];
    const nextVariantIds = removeVariant
      ? selectedVariantIds.filter((id) => id !== removeVariant.id)
      : selectedVariantIds.slice(0, -1);
    selectedVariantIds = nextVariantIds;
    appliedVariantIds = nextVariantIds;
    if (nextVariantIds.length) getTaskGraph(currentSubtask, nextVariantIds);
    return selectedVariantIds.length;
  }

  function addNextTransition() {
    if (loading) return selectedTransitionIds.length;
    const nextTransition = visibleTransitionOptions.find(
      (edge) => !selectedTransitionIds.includes(getTransitionId(edge)),
    );
    if (!nextTransition) return selectedTransitionIds.length;
    selectedTransitionIds = [
      ...selectedTransitionIds,
      getTransitionId(nextTransition),
    ];
    scheduleWindowSequenceRefresh();
    return selectedTransitionIds.length;
  }

  function removeLowestTransition() {
    if (loading) return selectedTransitionIds.length;
    const selectedIdsByFrequency = selectedTransitionOptions
      .map(getTransitionId)
      .reverse();
    const transitionToRemove = selectedIdsByFrequency[0];
    if (!transitionToRemove) return selectedTransitionIds.length;
    selectedTransitionIds = selectedTransitionIds.filter(
      (id) => id !== transitionToRemove,
    );
    scheduleWindowSequenceRefresh();
    return selectedTransitionIds.length;
  }

  function addNextTransitionActivity() {
    if (loading) return selectedTransitionActivityCount;
    const currentCount = getTransitionActivityCount(selectedTransitionIds);
    const nextTransitionIds = [...selectedTransitionIds];

    for (const edge of visibleTransitionOptions) {
      const id = getTransitionId(edge);
      if (nextTransitionIds.includes(id)) continue;
      nextTransitionIds.push(id);
      if (getTransitionActivityCount(nextTransitionIds) > currentCount) {
        selectedTransitionIds = nextTransitionIds;
        scheduleWindowSequenceRefresh();
        return getTransitionActivityCount(selectedTransitionIds);
      }
    }

    selectedTransitionIds = nextTransitionIds;
    scheduleWindowSequenceRefresh();
    return getTransitionActivityCount(selectedTransitionIds);
  }

  function removeLastTransitionActivity() {
    if (loading) return selectedTransitionActivityCount;
    const currentCount = getTransitionActivityCount(selectedTransitionIds);
    if (!currentCount) return currentCount;

    let nextTransitionIds = selectedTransitionOptions.map(getTransitionId);
    const idsByLowestPriority = [...nextTransitionIds].reverse();

    for (const id of idsByLowestPriority) {
      nextTransitionIds = nextTransitionIds.filter(
        (transitionId) => transitionId !== id,
      );
      if (getTransitionActivityCount(nextTransitionIds) < currentCount) {
        selectedTransitionIds = nextTransitionIds;
        scheduleWindowSequenceRefresh();
        return getTransitionActivityCount(selectedTransitionIds);
      }
    }

    selectedTransitionIds = nextTransitionIds;
    scheduleWindowSequenceRefresh();
    return getTransitionActivityCount(selectedTransitionIds);
  }

  function toggleFullscreen() {
    fullscreen = !fullscreen;
  }

  function togglePaxbot() {
    paxbotVisible = !paxbotVisible;
  }

  function closePaxbot() {
    paxbotVisible = false;
  }

  function getPaxbotContext() {
    const executionFrequency = graph["executionFrequency"] || 1;
    const isOptimizationMode = explorerMode === "optimization";
    const transitionMetricContext = {
      active: transitionMetric,
      activeLabel: transitionMetricLabel(),
      displayedUnit: transitionMetric === "occurrences" ? "count" : "percent",
      definitions: {
        caseCoverage:
          "Share of recordings containing the transition at least once. It answers how widespread the path is.",
        nextStep:
          "Share of all outgoing transitions from the source activity that lead to the target activity. It answers what typically happens next.",
        occurrences:
          "Absolute number of observed transition occurrences, including repetitions. It highlights loops, rework, and frequent switching.",
      },
      instruction:
        "Interpret edge labels, sorting, and the minimum-frequency filter using the active transition metric. Explicitly name the active metric when explaining an edge value.",
    };
    const compactApps = (apps) => {
      if (!apps) return [];
      const entries = Array.isArray(apps)
        ? apps.map((app) => [
            app?.name || app?.application || app?.program || "",
            Number(app?.value ?? app?.ratio ?? app?.share ?? 0),
          ])
        : Object.entries(apps).map(([name, value]) => [
            name,
            Number(value) || 0,
          ]);
      return entries
        .filter(([name]) => name)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 3)
        .map(([name, value]) => ({ name, value }));
    };
    const compactOpportunity = (opportunity) => ({
      id: opportunity.id,
      title: opportunity.title,
      impactPercent: opportunity.impactPercent,
      savingsHours: opportunity.savingsHours,
      yearlySavings: opportunity.yearlySavings,
      steps: (opportunity.steps || []).slice(0, 6),
      problem: String(opportunity.problem || "").slice(0, 220),
      solution: String(opportunity.solution || "").slice(0, 220),
    });
    const nodeNames = (nodesDataToShow || [])
      .slice(0, 20)
      .map(
        (node) =>
          node?.data?.label || node?.data?.title || node?.label || node?.id,
      )
      .filter(Boolean);
    const edgeSummaries = (safeEdgesDataToShow || [])
      .slice(0, 24)
      .map((edge) => ({
        from: edge?.source || edge?.from,
        to: edge?.target || edge?.to,
        label: edge?.label || edge?.data?.label,
        occurrences: Number(edge?.value) || 0,
        caseCoveragePercent: Math.round(
          edgeCaseCoverage(edge, executionFrequency),
        ),
        nextStepProbabilityPercent: Math.round(
          ((edge.outgoingTransitionRate ?? edge.transitionRate ?? 0) || 0) *
            100,
        ),
        displayedValue: Math.round(edgeFrequency(edge, executionFrequency)),
        displayedUnit: transitionMetricContext.displayedUnit,
        isBridgeEdge: Boolean(edge?.dashed),
      }))
      .filter((edge) => edge.from || edge.to);
    const topTransitions = (visibleTransitionOptions || [])
      .slice(0, 6)
      .map((edge) => ({
        from: edge.from,
        to: edge.to,
        occurrences: Number(edge.value) || 0,
        caseCoveragePercent: edgeCaseCoverage(edge, executionFrequency),
        nextStepProbabilityPercent:
          ((edge.outgoingTransitionRate ?? edge.transitionRate ?? 0) || 0) *
          100,
        displayedValue: edgeFrequency(edge, executionFrequency),
        displayedUnit: transitionMetricContext.displayedUnit,
      }));
    const topVariants = (variantOptions || []).slice(0, 5).map((variant) => ({
      id: variant.id,
      name: variant.name,
      variantCoveragePercent: Math.round(Number(variant.coverage || 0) * 100),
      count: variant.count,
      steps: variantSteps(variant).slice(0, 12),
    }));
    const activityMetrics = Object.entries(graph.activityKpis || {})
      .map(([activity, kpi]) => {
        const occurrenceRate = Number(kpi?.occurrence_rate) || 0;
        const weightedTimeSeconds = Number(kpi?.time_per_case) || 0;
        return {
          activity,
          weightedTimeSeconds,
          avgDurationWhenOccursSeconds:
            occurrenceRate > 0
              ? weightedTimeSeconds / occurrenceRate
              : weightedTimeSeconds,
          occurrencePercent: Math.round(occurrenceRate * 100),
          textSharePercent: Math.round((Number(kpi?.text_share) || 0) * 100),
          copyPasteTimeSharePercent: Math.round(
            (Number(kpi?.copy_paste_time_share) || 0) * 100,
          ),
          copyPasteRatePercent: Math.round(
            (Number(kpi?.copy_paste_rate) || 0) * 100,
          ),
          clicks: Number(kpi?.clicks) || 0,
          textCount: Number(kpi?.text_count) || 0,
          shortcutCount: Number(kpi?.shortcut_count) || 0,
          apps: compactApps(kpi?.apps),
        };
      })
      .filter((item) => item.activity && item.weightedTimeSeconds >= 0);
    const topBy = (metric) =>
      [...activityMetrics]
        .sort((a, b) => Number(b[metric] || 0) - Number(a[metric] || 0))
        .slice(0, 5);
    const activityKpiContext = {
      longestWeightedTime: topBy("weightedTimeSeconds"),
      longestAverageDuration: topBy("avgDurationWhenOccursSeconds"),
      highestTextShare: topBy("textSharePercent"),
      highestCopyPasteShare: topBy("copyPasteTimeSharePercent"),
      mostFrequent: topBy("occurrencePercent"),
    };
    const currentVisibleGraphKpis = {
      recordings: infoStats.recordings,
      avgTimeSeconds: infoStats.activeTime,
      coveragePercent:
        infoStats.coverage == null
          ? null
          : Math.round(infoStats.coverage * 100),
      note:
        graphMode === "transitions"
          ? "These are the visible Quantification KPI cards on the left for the currently selected transition graph."
          : "These are the visible Quantification KPI cards on the left for the currently selected variants graph.",
    };
    const sidebarTransitionKpis = {
      avgTimeSeconds: globalTaskTimeStats.avg,
      medianTimeSeconds: globalTaskTimeStats.median,
      longestTimeSeconds: globalTaskTimeStats.longest,
      note: "These are the global KPI cards shown in the right Transitions accordion.",
    };
    const exactSelectedTransitionPathKpis = {
      avgTimeSeconds: selectedTransitionExactStats.avg,
      medianTimeSeconds: selectedTransitionExactStats.median,
      longestTimeSeconds: selectedTransitionExactStats.longest,
      note: "Internal exact-path calculation for selected transitions. Do not use this for simple UI KPI questions unless the user explicitly asks for exact selected-path statistics.",
    };
    const visibleUiKpis = {
      leftQuantification: currentVisibleGraphKpis,
      rightTransitionsAccordion: sidebarTransitionKpis,
    };

    const baseContext = {
      projectId: idproject,
      subtaskId: currentSubtask,
      taskName:
        currentSubtaskEntry?.name ||
        currentSubtaskEntry?.task ||
        currentSubtaskEntry?.label ||
        "",
      paxbotMode: isOptimizationMode ? "optimization" : "exploration",
      graphMode,
      explorerMode,
      transitionMetric: transitionMetricContext,
      selectedNode,
      selectedNodes: (selectedNodes || []).slice(0, 10),
      expandedNodes: (expandedNodes || []).slice(0, 20),
      minFrequency,
      endpointContext: {
        sourceEndpoint: "/api/damprojects/getProcessGraph",
        sourceParams: {
          idproject,
          subtaskid: currentSubtask,
          graphMode,
          transitionMetric,
          expandedNodes,
          selectedVariants: graphMode === "variants" ? selectedVariantIds : [],
          minFrequency,
        },
      },
      graph: {
        nodeCount: graph["nodes"]?.length || 0,
        edgeCount: graph["edges"]?.length || 0,
        visibleNodes: nodeNames,
        visibleEdges: edgeSummaries,
        currentVisibleGraphKpis,
        visibleUiKpis,
      },
      focusedStep: paxbotFocusedStepContext,
    };

    if (isOptimizationMode) {
      return {
        ...baseContext,
        focus: "optimization",
        instructionContext:
          "Use this context to discuss bottlenecks, automation potential, selected opportunities, effort, impact, and next optimization actions. Do not summarize the graph unless the user asks.",
        optimizationContext: {
          loaded: Boolean(optimizationData),
          totals: optimizationTotals,
          selectedOpportunities: optimizationOpportunityCards
            .slice(0, 5)
            .map(compactOpportunity),
          allOpportunityCount: optimizationData?.opportunities?.length || 0,
        },
        processSummary: {
          executionFrequency,
          activitiesCount: graph["activities"]?.length || 0,
          applications: (infoPrograms || []).slice(0, 5),
          currentVisibleGraphKpis,
          sidebarTransitionKpis,
          exactSelectedTransitionPathKpis,
          visibleUiKpis,
          activityMetrics: activityKpiContext,
        },
      };
    }

    return {
      ...baseContext,
      focus: "exploration",
      instructionContext:
        "Use this context to help users understand the lived process descriptively: actual flow, variants, frequencies, durations, applications, transitions, and quantification. Do not recommend optimizations unless the user asks.",
      explorationContext: {
        activeGraphMode: graphMode,
        stats: infoStats,
        applications: (infoPrograms || []).slice(0, 6),
        selectedVariants: selectedVariantIds,
        selectedTransitions: selectedTransitionIds,
        displayedTransitions:
          graphMode === "transitions"
            ? edgeSummaries.filter((edge) => !edge.isBridgeEdge)
            : [],
        responseSummary: {
          executionFrequency,
          activitiesCount: graph["activities"]?.length || 0,
          variantsCount: variantOptions.length,
          transitionsDetected: visibleTransitionOptions.length,
          transitionsSelected: selectedTransitionOptions.length,
          selectedTransitionActivityCount,
          currentVisibleGraphKpis,
          sidebarTransitionKpis,
          exactSelectedTransitionPathKpis,
          visibleUiKpis,
          topTransitions,
          topVariantsByVariantCoverage: topVariants,
        },
        activityMetrics: activityKpiContext,
      },
    };
  }

  function plainTextFromHtml(html) {
    const element = document.createElement("div");
    element.innerHTML = html || "";
    return (element.textContent || "").replace(/\s+/g, " ").trim();
  }

  function truncateContextText(value, maxLength) {
    const text = String(value || "")
      .replace(/\s+/g, " ")
      .trim();
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength - 3).trim()}...`;
  }

  function compactStepSequenceContext(nodeId) {
    const node =
      (graph.nodes || []).find((item) => item.id === nodeId) ||
      (nodesDataToShow || []).find((item) => item.id === nodeId) ||
      {};
    const sequence =
      contextualWindowSequences[nodeId] || node.windowSequence || [];
    const windows = [];
    const uiElements = [];
    const windowCodes = new Map();
    const uiCodes = new Map();
    const rows = [];

    const getWindowCode = (item) => {
      const key = `${item.app || ""}\u0000${item.windowTitle || ""}`;
      if (!windowCodes.has(key)) {
        const code = `w${windowCodes.size + 1}`;
        windowCodes.set(key, code);
        const window = { code };
        if (item.app) window.app = truncateContextText(item.app, 40);
        if (item.windowTitle) {
          window.title = truncateContextText(item.windowTitle, 80);
        }
        windows.push(window);
      }
      return windowCodes.get(key);
    };

    const getUiCode = (element) => {
      const key = element.name || "";
      if (!key) return "";
      if (!uiCodes.has(key)) {
        const code = `u${uiCodes.size + 1}`;
        uiCodes.set(key, code);
        uiElements.push({
          code,
          name: truncateContextText(key, 60),
        });
      }
      return uiCodes.get(key);
    };

    sequence.slice(0, 5).forEach((item) => {
      const windowCode = getWindowCode(item);
      const elementCodes = (item.elements || []).map(getUiCode).filter(Boolean);
      rows.push(
        [
          elementCodes.length
            ? `${windowCode}:${elementCodes.join(",")}`
            : windowCode,
          `x${item.occurrences || 1}`,
          `c${item.count || 0}`,
        ].join(" "),
      );
    });

    return {
      activityId: nodeId,
      activityName: plainTextFromHtml(node.label || node.shortlabel || nodeId),
      note: "Main windows/elements only; filtered gaps are bridged.",
      instruction:
        "Explain focused step via sequenceMatrix; resolve codes with windows/uiElements.",
      windows,
      uiElements,
      sequenceMatrix: rows,
    };
  }

  function getFocusedStepQuestion(activityName) {
    const name = activityName || "this step";
    if (paxbotLanguage === "de") {
      return `Bitte beschreibe mir kurz, was in ${name} passiert.`;
    }
    if (paxbotLanguage === "es") {
      return `Descríbeme brevemente qué ocurre en ${name}.`;
    }
    if (paxbotLanguage === "it") {
      return `Descrivimi brevemente cosa succede in ${name}.`;
    }
    return `Please briefly describe what happens in ${name}.`;
  }

  function explainActivityWithPaxbot(nodeId) {
    if (!PAXBOT_ENABLED || paxbotLoading || paxbotTyping) return;
    paxbotFocusedStepContext = compactStepSequenceContext(nodeId);
    paxbotVisible = true;
    paxbotTitle = `Pax AI: ${paxbotFocusedStepContext.activityName}`;
    handlePaxbotQuestion(
      getFocusedStepQuestion(paxbotFocusedStepContext.activityName),
    );
  }

  async function handlePaxbotQuestion(questionText = paxbotInput) {
    const question = String(questionText || "").trim();
    if (!question || paxbotLoading || paxbotTyping) return;

    const history = paxbotChatMessages;
    paxbotChatMessages = [
      ...paxbotChatMessages,
      { role: "user", text: question },
    ];
    paxbotInput = "";
    paxbotLoading = true;

    try {
      const response = await fetchWithSession(`/api/damprojects/paxbot/chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          question,
          history,
          context: {
            ...getPaxbotContext(),
            responseLanguage:
              paxbotLanguages.find(
                (language) => language.key === paxbotLanguage,
              )?.name || "English",
          },
        }),
      });
      const responseText = await response.text();
      let result = {};
      try {
        result = responseText ? JSON.parse(responseText) : {};
      } catch (parseError) {
        throw new Error(
          `Paxbot endpoint returned ${response.status || "an invalid response"}`,
        );
      }
      if (!response.ok || result.status === "error") {
        throw new Error(result.message || "Paxbot request failed");
      }
      paxbotLoading = false;
      animatePaxbotAnswer(result.answer);
    } catch (error) {
      clearPaxbotTyping();
      paxbotChatMessages = [
        ...paxbotChatMessages,
        {
          role: "assistant",
          text: `Pax AI could not retrieve an answer right now: ${error.message}`,
        },
      ];
    } finally {
      paxbotLoading = false;
    }
  }

  async function handlePaxbotSubmit() {
    await handlePaxbotQuestion();
  }

  function handleStarterQuestion(question) {
    paxbotInput = question;
    handlePaxbotQuestion(question);
  }

  function handlePaxbotLanguageChange() {
    if (
      paxbotChatMessages.length === 1 &&
      paxbotChatMessages[0]?.role === "assistant"
    ) {
      paxbotChatMessages = [{ role: "assistant", text: paxbotLocale.hello }];
    }
  }

  function resetPaxbotChat() {
    clearPaxbotTyping();
    paxbotLoading = false;
    paxbotInput = "";
    paxbotFocusedStepContext = null;
    paxbotChatMessages = [{ role: "assistant", text: paxbotLocale.hello }];
  }

  function handlePaxbotKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handlePaxbotSubmit();
    }
  }

  async function incrementZoom() {
    if (showBpmnViewer && bpmnViewerElement) {
      bpmnViewerElement.zoomIn();
    } else {
      await zoomIn();
    }
    updateZoomLevel();
  }

  async function decrementZoom() {
    if (showBpmnViewer && bpmnViewerElement) {
      bpmnViewerElement.zoomOut();
    } else {
      await zoomOut();
    }
    updateZoomLevel();
  }

  async function updateZoomLevel() {
    zoomLevel.set((getZoom() * 100).toFixed(0));
  }

  function expandAllActivities() {
    const nodesToExpand = graph["nodes"]
      .map((node) => {
        if (node.isSubProcess) return node.id;
      })
      .filter((node) => node !== undefined);
    expandedNodes = [...expandedNodes, ...nodesToExpand];
    if (graphMode === "transitions") initializeTransitions = true;
    getTaskGraph(
      currentSubtask,
      graphMode === "variants" ? appliedVariantIds : [],
    );
  }

  function collapseAllActivities() {
    expandedNodes = [];
    if (graphMode === "transitions") initializeTransitions = true;
    getTaskGraph(
      currentSubtask,
      graphMode === "variants" ? appliedVariantIds : [],
    );
  }

  function resetGraph() {
    graph = {
      activityMappingCluster: [],
      // allactivitymapping: [],
      edges: [],
      // executionFrequency: 0,
      // nactivities: 0,
      nodes: [],
      // nusers: 0,
      // timepercase: 0,
      // totaltime: 0,
      uniquePrograms: [],
      //uniqueActivities: 0,
      variants: [],
      maxtime: 0,
      meantime: 0,
      mintime: 0,
      activities: [],
    };
  }

  function buildProcessArtifacts(
    selectedActivities = bpmnSelectedActivities,
    {
      includeSystems = includeDatabases,
      includeFiles = includeDocuments,
      systemMinFrequency = bpmnEffectiveSystemMinFrequency,
      fileMinFrequency = bpmnEffectiveFileMinFrequency,
      includeAllFiles = false,
    } = {},
  ) {
    const artifacts = [];
    const kpis = graph.activityKpis || {};

    for (const activity of selectedActivities) {
      const label = activity.activity;
      if (!label || !kpis[label]) continue;
      const actKpi = kpis[label];

      if (includeSystems && actKpi.apps && typeof actKpi.apps === "object") {
        Object.entries(actKpi.apps)
          .map(([name, share]) => ({ name, share: Number(share) || 0 }))
          .filter(
            (system) => system.name && system.share * 100 >= systemMinFrequency,
          )
          .sort((a, b) => b.share - a.share)
          .forEach((system) => {
            artifacts.push({
              task: label,
              type: "database",
              name: system.name,
            });
          });
      }

      if (
        includeFiles &&
        actKpi.top_windowtitles &&
        typeof actKpi.top_windowtitles === "object"
      ) {
        const matchingFiles = Object.entries(actKpi.top_windowtitles)
          .map(([windowTitle, share]) => ({
            name: getFileArtifactName(windowTitle),
            share: Number(share) || 0,
          }))
          .filter((file) => file.name && file.share * 100 >= fileMinFrequency)
          .sort((a, b) => b.share - a.share);
        const filesToInclude = includeAllFiles
          ? matchingFiles
          : matchingFiles.slice(0, 1);
        const uniqueFileNames = new Set();
        filesToInclude.forEach((file) => {
          if (uniqueFileNames.has(file.name)) return;
          uniqueFileNames.add(file.name);
          artifacts.push({ task: label, type: "document", name: file.name });
        });
      }
    }
    return artifacts;
  }

  function buildPddProcessArtifacts(visibleActivityLabels) {
    return buildProcessArtifacts(
      bpmnActivityRows.filter((activity) =>
        visibleActivityLabels.has(activity.activity),
      ),
      {
        includeSystems: true,
        includeFiles: true,
        systemMinFrequency: 10,
        fileMinFrequency: 0,
        includeAllFiles: true,
      },
    );
  }

  function buildBpmnNodeNotes() {
    if (!includeAvgTime && !includeFrequency) return null;
    const nodeNotes = {};
    const kpis = graph.activityKpis || {};

    for (const activity of bpmnSelectedActivities) {
      const label = activity.activity;
      if (!label) continue;
      const actKpi = kpis[label] || {};
      const details = [];

      if (includeAvgTime) {
        const occurrenceRate = Number(actKpi.occurrence_rate);
        const timePerCase = Number(actKpi.time_per_case);
        const avgTime =
          Number.isFinite(timePerCase) &&
          Number.isFinite(occurrenceRate) &&
          occurrenceRate > 0
            ? formatBpmnNoteTime(timePerCase / occurrenceRate)
            : "";
        details.push(`Avg. Time: ${avgTime || "-"}`);
      }

      if (includeFrequency) {
        const frequency = Number(actKpi.occurrence_rate);
        details.push(
          `Frequency: ${Number.isFinite(frequency) ? `${Math.round(frequency * 100)}%` : "-"}`,
        );
      }

      if (details.length) nodeNotes[label] = details.join("\n");
    }

    return nodeNotes;
  }

  function buildBpmnActivityMetrics() {
    const kpis = graph.activityKpis || {};
    return bpmnSelectedActivities
      .map((activity) => {
        const label = activity.activity;
        const occurrenceRate = Number(kpis[label]?.occurrence_rate);
        const weightedTime = Number(kpis[label]?.time_per_case);
        if (
          !label ||
          !Number.isFinite(occurrenceRate) ||
          occurrenceRate <= 0 ||
          !Number.isFinite(weightedTime)
        ) {
          return null;
        }
        return {
          activity: label,
          avg_time_seconds: weightedTime / occurrenceRate,
          frequency: occurrenceRate,
        };
      })
      .filter(Boolean);
  }

  function formatBpmnNoteTime(totalSec) {
    if (!totalSec || !Number.isFinite(totalSec)) return "";
    const minutes = Math.floor(totalSec / 60);
    const seconds = Math.floor(totalSec % 60);
    if (minutes > 0) return `${minutes}min ${seconds}sec`;
    return `${seconds}sec`;
  }

  function getFileArtifactName(windowTitle) {
    const title = String(windowTitle || "").trim();
    const fileMatch = title.match(
      /([^\\/:*?"<>|\r\n]+?\.(docx|doc|xlsx|xlsm|xls|pptx|ppt|pdf|txt|csv|rtf|odt|ods|odp|msg|eml|zip|rar|7z|xml|json))/i,
    );
    if (fileMatch) {
      return `${getFileTypeLabel(fileMatch[2])}: ${cleanFileTitle(fileMatch[1], true)}`;
    }

    const appType = getFileTypeFromWindowTitle(title);
    if (!appType) return "";
    return `${appType}: ${cleanFileTitle(title)}`;
  }

  function getFileTypeLabel(extension) {
    const ext = String(extension || "").toLowerCase();
    if (["doc", "docx", "rtf", "odt"].includes(ext)) return "Doc";
    if (["xls", "xlsx", "xlsm", "csv", "ods"].includes(ext)) return "Excel";
    if (ext === "pdf") return "PDF";
    if (["ppt", "pptx", "odp"].includes(ext)) return "PPT";
    if (["msg", "eml"].includes(ext)) return "Mail";
    if (["zip", "rar", "7z"].includes(ext)) return "Archive";
    return ext.toUpperCase();
  }

  function getFileTypeFromWindowTitle(windowTitle) {
    const title = String(windowTitle || "").toLowerCase();
    if (/\b(adobe|acrobat|pdf)\b/.test(title)) return "PDF";
    if (/\b(excel|spreadsheet|arbeitsmappe)\b/.test(title)) return "Excel";
    if (/\b(powerpoint|presentation|präsentation)\b/.test(title)) return "PPT";
    if (/\b(word|document|dokument|sharepoint|onedrive)\b/.test(title)) {
      return "Doc";
    }
    return "";
  }

  function cleanFileTitle(value, preserveExtension = false) {
    const appWords = preserveExtension
      ? /(microsoft\s+word|microsoft\s+excel|microsoft\s+powerpoint|word|excel|powerpoint|adobe\s+acrobat|acrobat|adobe|sharepoint|onedrive)/gi
      : /(microsoft\s+word|microsoft\s+excel|microsoft\s+powerpoint|word|excel|powerpoint|adobe\s+acrobat|acrobat|adobe|sharepoint|onedrive|pdf)/gi;
    const cleaned = String(value || "")
      .split(" - ")
      .map((part) => part.replace(appWords, "").trim())
      .filter(Boolean)
      .pop()
      ?.slice(0, 50)
      .trim();
    return (
      cleaned ||
      String(value || "")
        .slice(0, 50)
        .trim()
    );
  }

  function getBpmnEdgeParts(edge) {
    if (Array.isArray(edge)) return edge;
    return [
      edge.from ?? edge.source,
      edge.to ?? edge.target,
      edge.value ?? edge.weight ?? edge.data?.value ?? 1,
    ];
  }

  function bridgeExcludedActivities(edges, includedActivityLabels) {
    const allowedNodes = new Set(["Start", "End", ...includedActivityLabels]);
    const outgoingByNode = new Map();
    const edgeWeights = new Map();

    const addEdge = (from, to, weight) => {
      if (!from || !to || from === to) return;
      const key = `${from}\u0000${to}`;
      edgeWeights.set(key, (edgeWeights.get(key) || 0) + Number(weight || 0));
    };

    edges.map(getBpmnEdgeParts).forEach(([from, to, weight]) => {
      if (!from || !to || from === to) return;
      if (!outgoingByNode.has(from)) outgoingByNode.set(from, []);
      outgoingByNode.get(from).push({ to, weight: Number(weight || 0) });
    });

    allowedNodes.forEach((source) => {
      (outgoingByNode.get(source) || []).forEach((edge) => {
        if (allowedNodes.has(edge.to)) {
          addEdge(source, edge.to, edge.weight);
          return;
        }

        const queue = [
          { node: edge.to, weight: edge.weight, visited: new Set([source]) },
        ];
        while (queue.length) {
          const current = queue.shift();
          if (current.visited.has(current.node)) continue;
          const visited = new Set(current.visited);
          visited.add(current.node);

          if (allowedNodes.has(current.node)) {
            addEdge(source, current.node, current.weight);
            continue;
          }

          (outgoingByNode.get(current.node) || []).forEach((next) => {
            if (visited.has(next.to)) return;
            queue.push({
              node: next.to,
              weight: Math.min(current.weight, Number(next.weight || 0)),
              visited,
            });
          });
        }
      });
    });

    return [...edgeWeights.entries()]
      .map(([key, weight]) => [...key.split("\u0000"), weight])
      .filter(([from, to]) => allowedNodes.has(from) && allowedNodes.has(to));
  }

  function buildBpmnEdgesFromVariantPaths(includedActivityLabels, variants) {
    const edgeWeights = new Map();
    const addEdge = (from, to, weight = 1) => {
      if (!from || !to || from === to) return;
      const key = `${from}\u0000${to}`;
      edgeWeights.set(key, (edgeWeights.get(key) || 0) + Number(weight || 0));
    };

    const addPath = (steps, weight = 1) => {
      const filteredSteps = (steps || [])
        .map(String)
        .filter((step) => includedActivityLabels.has(step));
      const sequence = ["Start", ...filteredSteps, "End"].filter(
        (step, index, list) => index === 0 || step !== list[index - 1],
      );
      sequence.slice(0, -1).forEach((from, index) => {
        addEdge(from, sequence[index + 1], weight);
      });
    };

    variants.forEach((variant) => {
      if (Array.isArray(variant.paths) && variant.paths.length) {
        variant.paths.forEach((path) => addPath(path.steps, 1));
      } else {
        addPath(variant.steps, variant.count || 1);
      }
    });

    return [...edgeWeights.entries()].map(([key, weight]) => [
      ...key.split("\u0000"),
      weight,
    ]);
  }

  function buildBpmnRequestBody({ disableLlm = false } = {}) {
    const processArtifacts = buildProcessArtifacts();
    const laneByActivity = Object.fromEntries(
      bpmnSelectedActivities
        .filter((activity) => activity.activity && activity.team)
        .map((activity) => [activity.activity, activity.team]),
    );
    const includedActivityLabels = new Set(
      bpmnSelectedActivities.map((activity) => activity.activity),
    );
    const bpmnEdges =
      graphMode === "variants" && bpmnEffectiveVariantOptions.length
        ? buildBpmnEdgesFromVariantPaths(
            includedActivityLabels,
            bpmnEffectiveVariantOptions,
          )
        : bridgeExcludedActivities(
            buildTransitionGraphEdges(bpmnSelectedConnectionEdges),
            includedActivityLabels,
          );

    return {
      edges: bpmnEdges,
      task_name: currentSubtaskEntry?.name || "Generated Task",
      team_name: currentSubtaskEntry?.teams?.[0] || null,
      lane_by_activity:
        Object.keys(laneByActivity).length > 0 ? laneByActivity : null,
      add_xor_labels_via_llm: !disableLlm,
      insert_gateways_on_split_and_merge: false,
      process_artifacts: processArtifacts.length > 0 ? processArtifacts : null,
      node_notes: buildBpmnNodeNotes(),
      connection_min_frequency: bpmnEffectiveConnectionMinFrequency,
    };
  }

  async function generateBpmnXml({ disableLlm = false } = {}) {
    const response = await fetchWithSession(`/api/damprojects/generateBPMN`, {
      method: "POST",
      body: JSON.stringify(buildBpmnRequestBody({ disableLlm })),
    });
    if (!response.ok) {
      throw new Error(`BPMN generation failed with status ${response.status}`);
    }
    return response.text();
  }

  async function downloadBPMN({ disableLlm = false } = {}) {
    if (bpmnGenerating) return;
    bpmnGenerating = true;
    bpmnSaved = false;
    try {
      generatedBpmnXml = await generateBpmnXml({ disableLlm });
      generatedBpmnActivityMetrics = buildBpmnActivityMetrics();
      generatedBpmnConnectionMetrics = buildBpmnRequestBody({
        disableLlm,
      }).edges;
    } finally {
      bpmnGenerating = false;
    }
  }

  function currentBpmnFrameworkPath() {
    const taskId =
      currentSubtaskEntry?.task_id || currentSubtaskEntry?.id || currentSubtask;
    const levels = [
      taskGroupsByLevel.L1?.[taskId]?.name,
      taskGroupsByLevel.L2?.[taskId]?.name,
      taskGroupsByLevel.L3?.[taskId]?.name,
      currentSubtaskEntry?.name,
    ].filter(Boolean);
    return levels.length === 4 ? levels : [];
  }

  async function saveBpmnToFramework(event) {
    if (bpmnSaving) return;
    const levels = currentBpmnFrameworkPath();
    if (levels.length !== 4) {
      setReportToast(
        "error",
        "BPMN could not be saved",
        "The selected task has no complete L1–L4 framework assignment.",
      );
      return;
    }

    bpmnSaving = true;
    bpmnSaved = false;
    try {
      const response = await fetchWithSession(
        "/api/pman/saveFrameworkProcessModel",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            levels,
            name: currentSubtaskEntry?.name || "Generated Task",
            bpmnstring: event.detail.xml,
            activity_metrics: generatedBpmnActivityMetrics,
          }),
        },
      );
      const responseText = await response.text();
      let result;
      try {
        result = JSON.parse(responseText);
      } catch {
        throw new Error(
          `The server returned an invalid response (${response.status}).`,
        );
      }
      if (!response.ok || result.status !== "success") {
        throw new Error(result.message || "Saving the BPMN model failed.");
      }
      bpmnSaved = true;
      setReportToast(
        "success",
        "BPMN saved",
        `${result.process.name} was saved under ${levels.join(" / ")}.`,
      );
    } catch (error) {
      setReportToast(
        "error",
        "BPMN could not be saved",
        error.message || "Saving the BPMN model failed.",
      );
    } finally {
      bpmnSaving = false;
    }
  }

  function scheduleBpmnPreviewRefresh() {
    clearTimeout(bpmnPreviewTimer);
    bpmnPreviewTimer = setTimeout(refreshBpmnPreview, 450);
  }

  async function refreshBpmnPreview() {
    if (!bpmnModalOpen || !currentSubtaskEntry) return;
    const requestSeq = ++bpmnPreviewRequestSeq;
    bpmnPreviewLoading = true;
    bpmnPreviewError = "";
    try {
      const xml = await generateBpmnXml({ disableLlm: true });
      if (requestSeq === bpmnPreviewRequestSeq) {
        bpmnPreviewXml = xml;
      }
    } catch (error) {
      if (requestSeq === bpmnPreviewRequestSeq) {
        bpmnPreviewError = error?.message || "Failed to generate BPMN preview.";
      }
    } finally {
      if (requestSeq === bpmnPreviewRequestSeq) {
        bpmnPreviewLoading = false;
      }
    }
  }

  $: {
    if (
      bpmnPreviewStateKey &&
      bpmnPreviewStateKey !== lastBpmnPreviewSignature
    ) {
      lastBpmnPreviewSignature = bpmnPreviewStateKey;
      scheduleBpmnPreviewRefresh();
    }
  }

  onMount(() => {
    if (toastMsg) toastMsg = "";
    lastTaskFrequencyUpdate =
      localStorage.getItem(`taskFrequencyUpdated:${idproject}`) || "";
    loadAppnameMapping();
    getSubtasks();
    window.addEventListener("focus", refreshOptimizationFrequency);
  });

  onDestroy(() => {
    window.removeEventListener("focus", refreshOptimizationFrequency);
    clearTimeout(bpmnPreviewTimer);
    clearTimeout(windowSequenceRefreshTimer);
    if (windowSequenceController) windowSequenceController.abort();
    clearPaxbotTyping();
    stopVariantSimulation();
  });
</script>

<div class="task-Explorer-header-wrapper">
  <Header
    paddingRight={false}
    section="Workflow Analysis"
    area="Workflow Analysis"
    breadcrumb="Process Explorer"
    tooltipText="The Process Explorer visualizes process flows across tasks, variants, and applications."
  >
    <AppDrilldownSourceMenu bind:selected={selectedSourceIndex} />
    <div class="hidden_header_filters">
      <LFilters
        {idproject}
        showL4={false}
        showAssignedFilter={false}
        bind:selectedProcess
        bind:selectedSubprocess
        bind:selectedTask
        bind:selectedTeam
      ></LFilters>
    </div>
    <Filter />
  </Header>
</div>
<SectionWrapper
  fullscreen={fullscreen && !noTasksAvailable}
  fitScreen={true}
  loading={loading && !noTasksAvailable}
  loadingTitle="Loading process data."
  loadingHint="Please wait while the Process Explorer is prepared."
  emptyState={noTasksAvailable}
>
  <div class="main_wrapper" slot="main">
    {#if !showBpmnViewer}
      <div class="info_overlay">
        {#if explorerMode === "optimization"}
          <section class="info_card">
            <button class="info_header">
              <span>Optimization Summary</span>
            </button>
            <div class="quant_summary">
              <div>
                <strong
                  >{optimizationReady
                    ? formatedTime(optimizationTotals.currentAvgTimeSeconds) ||
                      "-"
                    : "-"}</strong
                >
                <span>Current avg.</span>
              </div>
              <div>
                <strong class="optimization_positive"
                  >{optimizationReady
                    ? formatedTime(optimizationTotals.optimizedTimeSeconds) ||
                      "-"
                    : "-"}</strong
                >
                <span>Optimized</span>
              </div>
              <div>
                <strong class="optimization_positive"
                  >{optimizationReady
                    ? `${optimizationTotals.reductionPercent}%`
                    : "-"}</strong
                >
                <span>Reduction</span>
              </div>
            </div>
          </section>
          <section class="info_card">
            <button class="info_header">
              <span>Yearly Potential</span>
            </button>
            <div class="quant_summary">
              <div>
                <strong
                  >{optimizationReady
                    ? formatRuns(optimizationTotals.yearlyFrequency)
                    : "-"}</strong
                >
                <span>Runs p.a.</span>
              </div>
              <div>
                <strong class="optimization_positive"
                  >{optimizationReady
                    ? formatCurrency(optimizationTotals.yearlySavedCost)
                    : "-"}</strong
                >
                <span>Potential p.a.</span>
              </div>
              <div>
                <strong
                  >{optimizationReady
                    ? optimizationTotals.selectedCount
                    : "-"}</strong
                >
                <span>Selected</span>
              </div>
            </div>
          </section>
        {:else}
          <section class="info_card">
            <button
              class="info_header"
              on:click={() => (quantificationOpen = !quantificationOpen)}
            >
              <span>Quantification</span>
              <svg
                class="arrow"
                height="0.5rem"
                viewBox="0 0 17 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {#if quantificationOpen}
                  <path
                    d="M8.5 9.36707e-05L17 8.50009L16.11 9.39014L8.5 1.77093L0.890041 9.38089L7.86186e-08 8.49084L8.5 9.36707e-05Z"
                    fill="currentColor"
                  />
                {:else}
                  <path
                    d="M8.5 9.39004L0 0.890042L0.890045 0L8.5 7.6192L16.11 0.00924664L17 0.899292L8.5 9.39004Z"
                    fill="currentColor"
                  />
                {/if}
              </svg>
            </button>
            {#if quantificationOpen}
              <div class="quant_summary">
                <div>
                  <strong>{infoStats.recordings ?? "-"}</strong>
                  <span>Recordings</span>
                </div>
                <div>
                  <strong
                    >{infoStats.activeTime == null
                      ? "-"
                      : formatedTime(infoStats.activeTime)}</strong
                  >
                  <span>Avg. time</span>
                </div>
                <div>
                  <strong
                    >{infoStats.coverage == null
                      ? "-"
                      : `${Math.round(infoStats.coverage * 100) || 0}%`}</strong
                  >
                  <span>Coverage</span>
                </div>
              </div>
            {/if}
          </section>
          <section class="info_card">
            <button
              class="info_header"
              on:click={() => (applicationsOpen = !applicationsOpen)}
            >
              <span>Applications</span>
              <svg
                class="arrow"
                height="0.5rem"
                viewBox="0 0 17 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {#if applicationsOpen}
                  <path
                    d="M8.5 9.36707e-05L17 8.50009L16.11 9.39014L8.5 1.77093L0.890041 9.38089L7.86186e-08 8.49084L8.5 9.36707e-05Z"
                    fill="currentColor"
                  />
                {:else}
                  <path
                    d="M8.5 9.39004L0 0.890042L0.890045 0L8.5 7.6192L16.11 0.00924664L17 0.899292L8.5 9.39004Z"
                    fill="currentColor"
                  />
                {/if}
              </svg>
            </button>
            {#if applicationsOpen}
              <div class="app_list">
                {#each infoPrograms as program}
                  <div class="app_row">
                    <span title={program.clearname}>{program.clearname}</span>
                    <span class="app_bar">
                      <span
                        style={`width: ${Math.round(Number(program.ratio) * 100)}%;`}
                      ></span>
                    </span>
                    <strong>{Math.round(Number(program.ratio) * 100)}%</strong>
                  </div>
                {/each}
              </div>
            {/if}
          </section>
        {/if}
        {#if legendItems.length}
          <section class="info_card">
            <button
              class="info_header"
              on:click={() => (legendOpen = !legendOpen)}
            >
              <span>Legend</span>
              <svg
                class="arrow"
                height="0.5rem"
                viewBox="0 0 17 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {#if legendOpen}
                  <path
                    d="M8.5 9.36707e-05L17 8.50009L16.11 9.39014L8.5 1.77093L0.890041 9.38089L7.86186e-08 8.49084L8.5 9.36707e-05Z"
                    fill="currentColor"
                  />
                {:else}
                  <path
                    d="M8.5 9.39004L0 0.890042L0.890045 0L8.5 7.6192L16.11 0.00924664L17 0.899292L8.5 9.39004Z"
                    fill="currentColor"
                  />
                {/if}
              </svg>
            </button>
            {#if legendOpen}
              <div class="app_type_legend">
                {#each legendItems as item}
                  <div class="app_type_row">
                    <span
                      class="app_type_swatch"
                      style="background-color: {item.color}"
                    ></span>
                    <span>{item.label}</span>
                  </div>
                {/each}
              </div>
            {/if}
          </section>
        {/if}
      </div>
    {/if}
    {#if !showBpmnViewer}
      <div class="graph_left_toolbar">
        <OverflowMenu style="width: auto;">
          <div slot="menu">
            <Button
              icon={explorerMode === "optimization" ? SPEED_ICON : EXPLORE_ICON}
              iconDescription={explorerModeLabels[explorerMode]}
              kind="secondary"
            />
          </div>
          <OverflowMenuItem
            class={explorerMode === "exploration" ? "active_color_option" : ""}
            text="Explore"
            on:click={() => setExplorerMode("exploration")}
            primaryFocus={explorerMode === "exploration"}
          />
          <OverflowMenuItem
            class={explorerMode === "optimization" ? "active_color_option" : ""}
            text="Optimize"
            on:click={() => setExplorerMode("optimization")}
            primaryFocus={explorerMode === "optimization"}
          />
        </OverflowMenu>

        <OverflowMenu style="width: auto;">
          <div slot="menu">
            <Button
              kind="secondary"
              icon={graphMode === "transitions"
                ? TRANSITIONS_ICON
                : VARIANTS_ICON}
              iconDescription={graphModeLabels[graphMode]}
            />
          </div>
          <OverflowMenuItem
            class={graphMode === "transitions" ? "active_color_option" : ""}
            text="Transitions"
            on:click={() => setGraphMode("transitions")}
            primaryFocus={graphMode === "transitions"}
          />
          <OverflowMenuItem
            class={graphMode === "variants" ? "active_color_option" : ""}
            text="Variants"
            on:click={() => setGraphMode("variants")}
            primaryFocus={graphMode === "variants"}
          />
        </OverflowMenu>

        <OverflowMenu
          style="width: auto;"
          menuOptionsClass="transition_metric_menu"
        >
          <div slot="menu">
            <Button
              kind="secondary"
              icon={transitionMetricIcons[transitionMetric]}
              iconDescription={transitionMetricLabels[transitionMetric]}
            />
          </div>
          <OverflowMenuItem
            class={transitionMetric === "caseCoverage"
              ? "active_color_option"
              : ""}
            text="Case coverage"
            on:click={() => setTransitionMetric("caseCoverage")}
            primaryFocus={transitionMetric === "caseCoverage"}
          />
          <OverflowMenuItem
            class={transitionMetric === "nextStep" ? "active_color_option" : ""}
            text="Next-step probability"
            on:click={() => setTransitionMetric("nextStep")}
            primaryFocus={transitionMetric === "nextStep"}
          />
          <OverflowMenuItem
            class={transitionMetric === "occurrences"
              ? "active_color_option"
              : ""}
            text="Occurrences"
            on:click={() => setTransitionMetric("occurrences")}
            primaryFocus={transitionMetric === "occurrences"}
          />
        </OverflowMenu>

        <!-- <OverflowMenu>
          <img
            slot="menu"
            src="/img/assistant/icons/treemap.svg"
            alt="Color graph"
          />
          <OverflowMenuItem
            class={graphColorMetric === "none" ? "active_color_option" : ""}
            text="None"
            on:click={() => (graphColorMetric = "none")}
          />
          <OverflowMenuItem
            class={graphColorMetric === "text" ? "active_color_option" : ""}
            text="Text"
            on:click={() => (graphColorMetric = "text")}
          />
          <OverflowMenuItem
            class={graphColorMetric === "copy" ? "active_color_option" : ""}
            text="Copy & Paste"
            on:click={() => (graphColorMetric = "copy")}
          />
          <OverflowMenuItem
            class={graphColorMetric === "time" ? "active_color_option" : ""}
            text="Time"
            on:click={() => (graphColorMetric = "time")}
          />
        </OverflowMenu> -->

        <OverflowMenu style="width: auto;">
          <div slot="menu">
            <Button
              kind="secondary"
              icon={graphColorMetric === "none"
                ? LAYERS_CLEAR_ICON
                : graphColorMetric === "optimization:classification"
                  ? CATEGORY_ICON
                  : graphColorMetric === "optimization:savings"
                    ? SAVINGS_ICON
                    : graphColorMetric === "text"
                      ? TEXT_FIELDS_ICON
                      : graphColorMetric === "copy"
                        ? CONTENT_PASTE_ICON
                        : graphColorMetric === "time"
                          ? SCHEDULE_ICON
                          : graphColorMetric === "appType"
                            ? APPS_DARK_ICON
                            : WARNING_ICON}
              iconDescription={graphColorMetricLabels[graphColorMetric]}
            />
          </div>

          <OverflowMenuItem
            class={graphColorMetric === "none" ? "active_color_option" : ""}
            text="None"
            on:click={() => (graphColorMetric = "none")}
          />
          {#if explorerMode === "optimization"}
            <OverflowMenuItem
              class={graphColorMetric === "optimization:classification"
                ? "active_color_option"
                : ""}
              text="Classification"
              on:click={() =>
                (graphColorMetric = "optimization:classification")}
            />
            <OverflowMenuItem
              class={graphColorMetric === "optimization:savings"
                ? "active_color_option"
                : ""}
              text="Savings"
              on:click={() => (graphColorMetric = "optimization:savings")}
            />
          {:else}
            <OverflowMenuItem
              class={graphColorMetric === "text" ? "active_color_option" : ""}
              text="Text"
              on:click={() => (graphColorMetric = "text")}
            />
            <OverflowMenuItem
              class={graphColorMetric === "copy" ? "active_color_option" : ""}
              text="Copy & Paste"
              on:click={() => (graphColorMetric = "copy")}
            />
            <OverflowMenuItem
              class={graphColorMetric === "time" ? "active_color_option" : ""}
              text="Time"
              on:click={() => (graphColorMetric = "time")}
            />
            <OverflowMenuItem
              class={graphColorMetric === "appType"
                ? "active_color_option"
                : ""}
              text="App Type"
              on:click={() => (graphColorMetric = "appType")}
            />
          {/if}
        </OverflowMenu>
      </div>
      <div class="graph_top_right_toolbar">
        {#if Object.values($uiFeatureStore.exports).some(Boolean)}
          <OverflowMenu flipped menuOptionsClass="task_explorer_export_menu">
            <div slot="menu">
              {#if reportGenerating || pddGenerating}
                <Loading small withOverlay={false} active={true} />
              {:else}
                <Button
                  kind="primary"
                  iconDescription="Export"
                  aria-label="Export"
                  icon={DOWNLOAD_ICON}
                />
              {/if}
            </div>
            {#if $uiFeatureStore.exports.image}
              <OverflowMenuItem
                text="Image SVG"
                on:click={() => {
                  if (flowPlotterElement)
                    flowPlotterElement.downloadSVG(selectedProcesses);
                }}
              />
            {/if}
            {#if $uiFeatureStore.exports.bpmn}
              <OverflowMenuItem
                text={bpmnGenerating ? "BPMN (Generating...)" : "BPMN 2.0"}
                disabled={bpmnGenerating}
                on:click={openBpmnModal}
              />
            {/if}
            {#if $uiFeatureStore.exports.reportPdf}
              <OverflowMenuItem
                text={reportGenerating
                  ? "Report (Generating...)"
                  : "Report PDF"}
                disabled={!reportL3Options.length || reportGenerating}
                on:click={openReportModal}
              />
            {/if}
            {#if $uiFeatureStore.exports.actionPlan}
              <OverflowMenuItem
                text={actionPlanGenerating
                  ? "Action Plan (Generating...)"
                  : "Action Plan"}
                disabled={!actionPlanL3Options.length || reportGenerating}
                on:click={openActionPlanModal}
              />
            {/if}
            {#if $uiFeatureStore.exports.pdd}
              <PddExportMenuItem
                {currentSubtask}
                on:select={() => (pddTemplateModalOpen = true)}
              />
            {/if}
            {#if $uiFeatureStore.exports.sop}
              <OverflowMenuItem text="SOP (upcoming)" disabled />
            {/if}
            {#if $uiFeatureStore.exports.createWorkflowN8n}
              <OverflowMenuItem
                text={pddGenerating
                  ? "Prepare Workflow (n8n) (Preparing...)"
                  : "Prepare Workflow (n8n)"}
                disabled={!currentSubtask || pddGenerating}
                on:click={() => pddExportElement?.openN8nPrepareModal()}
              />
            {/if}
            {#if $uiFeatureStore.exports.bpmn && showBpmnViewer}
              <OverflowMenuItem
                text={bpmnExportFormat === "bic"
                  ? "Download BIC BPMN"
                  : "Download BPMN"}
                on:click={() => {
                  if (bpmnViewerElement) bpmnViewerElement.downloadBPMNFile();
                }}
              />
              <OverflowMenuItem
                text="Download BPMN as SVG"
                on:click={() => {
                  if (bpmnViewerElement) bpmnViewerElement.downloadSVG();
                }}
              />
            {/if}
          </OverflowMenu>
        {/if}
        {#if PAXBOT_ENABLED}
          <Button
            kind={paxbotVisible ? "primary" : "secondary"}
            iconDescription="Pax AI"
            aria-label="Open Paxbot"
            icon={BOT_WHITE_ICON}
            on:click={togglePaxbot}
          />
        {/if}
      </div>
    {/if}
    <div class="canvas">
      {#if bpmnGenerating && showBpmnViewer}
        <div class="loading_wrapper">
          <Loading withOverlay={false} />
        </div>
      {:else if showBpmnViewer}
        <BpmnViewer
          bind:this={bpmnViewerElement}
          bpmnXml={generatedBpmnXml}
          filenameBase={currentSubtaskEntry?.name || "process"}
          exportFormat={bpmnExportFormat}
          orientation={bpmnExportOrientation}
          {bicIdentifier}
          {bicValidTo}
          {bicChangeLog}
          {bicGenerateTexts}
          activityMetrics={generatedBpmnActivityMetrics}
          connectionMetrics={generatedBpmnConnectionMetrics}
          processTimeUnit={bicProcessTimeUnit}
          saving={bpmnSaving}
          saved={bpmnSaved}
          on:save={saveBpmnToFramework}
          on:download-error={(event) =>
            setReportToast(
              "error",
              "BPMN could not be downloaded",
              event.detail.message,
            )}
          on:close={() => {
            showBpmnViewer = false;
            generatedBpmnXml = null;
            generatedBpmnActivityMetrics = [];
            generatedBpmnConnectionMetrics = [];
            bpmnSaved = false;
          }}
        />
      {:else if casesSelected}
        {#if loadingCases}
          <div class="loading_wrapper">
            <Loading withOverlay={false} />
          </div>
        {/if}
      {:else if !currentSubtask}
        <div class="no_process">Select Task</div>
      {:else if loading}
        <div class="loading_wrapper">
          <Loading withOverlay={false} />
        </div>
      {:else}
        {#if simulationSlate}
          <div class="simulation_slate">{simulationSlate}</div>
        {/if}
        {#key graphRenderKey}
          <FlowPlotter
            bind:this={flowPlotterElement}
            nodesData={nodesDataToShow}
            edgesData={metricEdgesDataToShow}
            variants={graph["variants"]}
            subgraphs={graph["activityMappingCluster"]}
            kpis={graph["activityKpis"]}
            width="100%"
            height="100%"
            bind:selectedNode
            bind:selectedNodes
            bind:expandedNodes
            {fullGraphView}
            {fullNodeInfo}
            bind:zoomLevel={$zoomLevel}
            bind:triggerUpdate
            nnodes={graph["nodes"]?.length || 0}
            nedges={graph["edges"]?.length || 0}
            {minFrequency}
            {updateZoomLevel}
            executionFrequency={graph["executionFrequency"]}
            {transitionMetric}
            {seeMinimap}
            colorMetric={graphColorMetric}
            {appTypesByName}
            windowSequences={contextualWindowSequences}
            opportunitySteps={selectedOpportunitySteps}
            opportunityCards={explorerMode === "optimization"
              ? graphColorMetric === "optimization:savings"
                ? allOptimizationOpportunityCards
                : optimizationOpportunityCards
              : []}
            {simulationPath}
            {simulationStep}
            clearOnEmpty
            bind:activitiesToShow
            bind:edgesToShow
            explainActivity={explainActivityWithPaxbot}
            paxbotVisible={PAXBOT_ENABLED ? paxbotVisible : false}
            paxbotMessage={PAXBOT_ENABLED ? paxbotMessage : ""}
            paxbotTitle={PAXBOT_ENABLED ? paxbotTitle : ""}
            bind:graphActivities
            editActivity={openActivityEditorFromNode}
          />
        {/key}
      {/if}
    </div>
    {#if PAXBOT_ENABLED && paxbotVisible && !showBpmnViewer}
      <section class="paxbot_chat_window" aria-label="Paxbot chat">
        <header class="paxbot_chat_header">
          <div>
            <strong>{paxbotHeading}</strong>
            <span>Task Explorer Assistant</span>
          </div>
          <div class="paxbot_header_actions">
            <select
              class="paxbot_language_select"
              bind:value={paxbotLanguage}
              aria-label="Pax AI language"
              on:change={handlePaxbotLanguageChange}
            >
              {#each paxbotLanguages as language}
                <option value={language.key}>{language.label}</option>
              {/each}
            </select>
            <button
              type="button"
              class="paxbot_reset_button"
              aria-label="Start new chat"
              title="Start new chat"
              on:click={resetPaxbotChat}
            >
              +
            </button>
            <button
              type="button"
              class="paxbot_close_button"
              aria-label="Close Paxbot"
              title="Close Paxbot"
              on:click={closePaxbot}
            >
              <img src="/img/assistant/icons/close.svg" alt="" />
            </button>
          </div>
        </header>
        <div class="paxbot_chat_messages" bind:this={paxbotMessagesElement}>
          {#if paxbotAnnotations.length || paxbotText}
            <div class="paxbot_context_message">
              <strong>Graph context</strong>
              {#if paxbotAnnotations.length}
                {#each paxbotAnnotations as annotation}
                  <div class="paxbot_context_item">
                    {#if annotation.task}
                      <span>{annotation.task}</span>
                    {/if}
                    <p>
                      {annotation.description || annotation.text || annotation}
                    </p>
                  </div>
                {/each}
              {:else}
                <p>{paxbotText}</p>
              {/if}
            </div>
          {/if}
          {#each paxbotChatMessages as message}
            <div
              class:paxbot_user_message={message.role === "user"}
              class="paxbot_message_row"
            >
              {#if message.role === "assistant"}
                <img src="/img/assistant/paxbot_chatsymbol.svg" alt="" />
              {/if}
              <div class="paxbot_message_bubble">
                <span>{message.role === "user" ? "You" : "Paxbot"}</span>
                <p>{message.text}</p>
              </div>
            </div>
          {/each}
          {#if paxbotLoading}
            <div class="paxbot_message_row">
              <img src="/img/assistant/paxbot_chatsymbol.svg" alt="" />
              <div class="paxbot_message_bubble">
                <span>Pax AI</span>
                <p>Thinking...</p>
              </div>
            </div>
          {/if}
        </div>
        <div class="paxbot_starter_chips">
          {#each paxbotLocale.starterQuestions as question}
            <button
              type="button"
              disabled={paxbotLoading || paxbotTyping}
              on:click={() => handleStarterQuestion(question)}
            >
              {question}
            </button>
          {/each}
        </div>
        <form
          class="paxbot_chat_input"
          on:submit|preventDefault={handlePaxbotSubmit}
        >
          <textarea
            bind:value={paxbotInput}
            rows="1"
            placeholder={paxbotLoading
              ? paxbotLocale.thinking
              : paxbotTyping
                ? paxbotLocale.replying
                : paxbotLocale.placeholder}
            aria-label="Ask Paxbot"
            on:keydown={handlePaxbotKeydown}
          ></textarea>
          <button
            type="submit"
            aria-label="Send message"
            title="Send message"
            disabled={!paxbotInput.trim() || paxbotLoading || paxbotTyping}
          >
            <img src="/img/assistant/icons/arrow_right.svg" alt="" />
          </button>
        </form>
        <div class="paxbot_disclaimer">
          {paxbotLocale.disclaimer}
        </div>
      </section>
      <img
        class="paxbot_chat_mascot"
        src="/img/assistant/paxbot_portrait.png"
        alt="Paxbot"
      />
    {/if}
    <div class="menu_overlay bottom">
      <div class="button_wrapper">
        {#if graphMode === "variants"}
          <Button
            kind="plus-minus"
            text="Variants"
            value={selectedVariantIds.length}
            unit=""
            defaultValue={variantOptions.length}
            minValue={1}
            maxValue={variantOptions.length}
            increment={addNextVariant}
            decrement={removeLastVariant}
            reset={selectAllVariants}
            disabled={loading || variantOptions.length <= 1}
          />
        {:else}
          <Button
            kind="plus-minus"
            text="Transitions"
            value={selectedTransitionOptions.length}
            unit=""
            defaultValue={visibleTransitionOptions.length}
            minValue={1}
            maxValue={visibleTransitionOptions.length}
            increment={addNextTransition}
            decrement={removeLowestTransition}
            reset={selectAllTransitions}
            disabled={loading || !visibleTransitionOptions.length}
          />
          <Button
            kind="plus-minus"
            text="Activities"
            value={selectedTransitionActivityCount}
            unit=""
            defaultValue={visibleTransitionActivityCount}
            minValue={0}
            maxValue={visibleTransitionActivityCount}
            increment={addNextTransitionActivity}
            decrement={removeLastTransitionActivity}
            reset={selectAllTransitions}
            disabled={loading || !visibleTransitionOptions.length}
          />
        {/if}
        <Button
          kind="plus-minus"
          text={transitionMetric === "occurrences" ? "Min Occ." : "Min Freq"}
          bind:value={minFrequency}
          unit={transitionMetric === "occurrences" ? "" : "%"}
          defaultvalue={0}
          minValue={0}
          maxValue={minFrequencyMax}
          increment={(value) =>
            Math.min(
              Number(value) + (transitionMetric === "occurrences" ? 1 : 5),
              minFrequencyMax,
            )}
          decrement={(value) =>
            Math.max(
              Number(value) - (transitionMetric === "occurrences" ? 1 : 5),
              0,
            )}
          disabled={loading || !graph["edges"]?.length}
        />
      </div>
      <div class="button_wrapper">
        <Button
          kind="plus-minus"
          text="Zoom"
          bind:value={$zoomLevel}
          showValue={false}
          unit=""
          reset={() => {
            if (showBpmnViewer && bpmnViewerElement) {
              bpmnViewerElement.resetZoom();
            } else {
              fitView();
            }
            fitView();
            updateZoomLevel();
          }}
          increment={incrementZoom}
          decrement={decrementZoom}
        />
        {#if !showBpmnViewer}
          <Button
            kind="secondary"
            icon={FIT_SCREEN_ICON}
            iconDescription="Fit graph to view"
            tooltipPosition="top"
            on:click={() => {
              fitView();
              updateZoomLevel();
            }}
          />
        {/if}
        <Button
          kind="secondary"
          tooltipPosition="top"
          icon={fullscreen ? FULLSCREEN_OFF_ICON : FULLSCREEN_ICON}
          iconDescription={fullscreen ? "Exit fullscreen" : "Fullscreen"}
          on:click={toggleFullscreen}
        />
      </div>
    </div>
  </div>
  <div class="menu" slot="menu">
    <!-- @Jonas Auskommentierter Contentswitcher zwischen Transitions und Variants. Wird aktuell nicht benötigt, da die Auswahl über das OverflowMenu erfolgt. -->
    <!-- <div class="graph_mode_switch">
      <button
        type="button"
        class:active={graphMode === "transitions"}
        on:click={() => setGraphMode("transitions")}
      >
        Transitions
      </button>
      <button
        type="button"
        class:active={graphMode === "variants"}
        on:click={() => setGraphMode("variants")}
      >
        Variants
      </button>
    </div> -->
    <Accordion
      heading={"Task Selection"}
      tooltipText="Select a task to display its process graph. Only tasks with at least 5 registrations are shown here."
      open={true}
    >
      <TaskSelection
        subtaskList={explorerMode === "optimization"
          ? optimizationSubtaskList
          : filteredSubtaskList}
        {taskNameById}
        {taskGroupsByLevel}
        bind:currentSubtask
        enableDeselection={false}
        loading={loadingSubtaskList}
        enableSorter
        valueLabel={explorerMode === "optimization" ? "hours" : "number"}
        valueSuffix={explorerMode === "optimization" ? "h" : "Rec."}
        disableThreshold={explorerMode === "optimization"
          ? 0
          : MIN_TASK_EXECUTIONS}
        showSelectedTaskName
        showFrequencyMapping={$uiFeatureStore.kpiMatrix.taskKpiSetup}
        on:frequencyclick={openTaskFrequencyMapping}
      />
    </Accordion>
    <Accordion
      heading={graphMode === "variants"
        ? "Variant Selection"
        : "Transition Selection"}
      tooltipText={graphMode === "variants"
        ? "Select the variants that should be shown in the process graph."
        : "Select the transitions that should be shown in the process graph."}
      open={true}
    >
      <div class="variants_wrapper">
        {#if loading}
          <SideKPI loading></SideKPI>
        {:else if graphMode === "transitions"}
          <div class="variant_topline">
            <span>
              <bold class="black"
                >{selectedTransitionOptions.length} / {visibleTransitionOptions.length}</bold
              >
              selected</span
            >
            <!-- Transition filter temporarily hidden from the selection panel.
            <button
              type="button"
              class="variant_settings_button"
              title="Transition settings"
              on:click={() =>
                (transitionSettingsOpen = !transitionSettingsOpen)}
            >
              <img src="/img/assistant/icons/filter.svg" alt="" />
            </button>
            -->
          </div>
          <!--
          {#if transitionSettingsOpen}
            <div class="variant_settings transition_settings">
              <label>
                <span>Min {transitionMetricLabel().toLowerCase()}</span>
                <input
                  type="number"
                  min="0"
                  max={minFrequencyMax}
                  value={minFrequency}
                  on:input={setTransitionMinFrequency}
                />
              </label>
              {#if transitionMetric !== "occurrences"}
                <label>
                  <span>Min occurrences</span>
                  <input
                    type="number"
                    min="0"
                    value={transitionMinCount}
                    on:input={setTransitionMinCount}
                  />
                </label>
              {/if}
            </div>
          {/if}
          -->
          <div class="variant_actions">
            <button disabled={loading} on:click={selectAllTransitions}
              >Select all</button
            >
            <button disabled={loading} on:click={clearTransitions}
              >Deselect all</button
            >
          </div>
          <div class="variant_stats">
            <div>
              <span>Average (Total)</span>
              <strong>{formatActivityAvgTime(globalTaskTimeStats.avg)}</strong>
            </div>
            <div>
              <span>Median (Total)</span>
              <strong
                >{formatActivityAvgTime(globalTaskTimeStats.median)}</strong
              >
            </div>
            <div>
              <span>Longest (Total)</span>
              <strong
                >{formatActivityAvgTime(globalTaskTimeStats.longest)}</strong
              >
            </div>
          </div>
          <div class="transition_header">
            <span></span>
            <span>From</span>
            <span>To</span>
            <span>{transitionMetricLabel()}</span>
          </div>
          {#each visibleTransitionRows as edge}
            <label
              class="transition_row"
              class:selected={selectedTransitionIds.includes(
                getTransitionId(edge),
              )}
            >
              <input
                type="checkbox"
                checked={selectedTransitionIds.includes(getTransitionId(edge))}
                disabled={loading}
                on:change={() => toggleTransition(edge)}
              />
              <span title={edge.from}>{formatActivityLabel(edge.from)}</span>
              <span title={edge.to}>{formatActivityLabel(edge.to)}</span>
              <strong
                title={`${edge.value} occurrences · ${Math.round(
                  edgeCaseCoverage(edge, graph["executionFrequency"] || 1),
                )}% case coverage`}>{formatTransitionMetric(edge)}</strong
              >
            </label>
          {/each}
          <Pagination
            basic
            totalItems={visibleTransitionOptions.length}
            bind:page={transitionPage}
            pageSize={transitionsPerPage}
          />
        {:else if !graph["variants"]?.length}
          <div class="empty_variants">No variants</div>
        {:else if !variantOptions.length}
          <div class="empty_variants">
            Variant metrics unavailable. Reload backend.
          </div>
        {:else}
          <div class="variant_topline">
            <span
              ><bold class="black"
                >{selectedVariantIds.length} / {variantOptions.length}</bold
              > selected</span
            >
          </div>
          <div class="variant_actions">
            <button disabled={loading} on:click={selectAllVariants}
              >Select all</button
            >
            <button disabled={loading} on:click={deselectAllVariants}
              >Deselect all</button
            >
          </div>
          <div class="variant_stats">
            <div>
              <span>Avg. (Total)</span>
              <strong>{formatActivityAvgTime(globalTaskTimeStats.avg)}</strong>
            </div>
            <div>
              <span>Median (Total)</span>
              <strong
                >{formatActivityAvgTime(globalTaskTimeStats.median)}</strong
              >
            </div>
            <div>
              <span>Longest (Total)</span>
              <strong
                >{formatActivityAvgTime(globalTaskTimeStats.longest)}</strong
              >
            </div>
          </div>
          {#each visibleVariantGroups as group, index}
            <div class="variant_group">
              <div class="variant_group_row" class:selected={group.selected}>
                <button
                  type="button"
                  class="variant_group_toggle"
                  on:click|stopPropagation={() =>
                    toggleVariantGroupOpen(group, index)}
                >
                  <img
                    src="/img/assistant/icons/chevron_{group.open
                      ? 'down'
                      : 'right'}_black.svg"
                    alt=""
                  />
                </button>
                <input
                  type="checkbox"
                  checked={group.selected}
                  disabled={loading}
                  on:click|stopPropagation={() => {}}
                  on:change={() => toggleVariantGroup(group)}
                />
                <strong>{group.name}</strong>
                <small>{group.count} Rec.</small>
                <small>{Math.round(group.coverage * 100)}%</small>
                <small>{formatedTime(group.activeTime)} Avg.</small>
              </div>
              {#if group.open}
                <div class="variant_group_items">
                  {#each group.variants as variant}
                    <label
                      class="variant_row"
                      class:selected={selectedVariantIds.includes(variant.id)}
                    >
                      <input
                        type="checkbox"
                        checked={selectedVariantIds.includes(variant.id)}
                        disabled={loading}
                        on:change={() => toggleVariant(variant.id)}
                      />
                      <span class="variant_name">
                        {variant.name}
                        <small
                          >- {variant.count} Registrations - {Math.round(
                            variant.coverage * 100,
                          )}% coverage - {formatedTime(
                            variant.activeTime,
                          )}</small
                        >
                      </span>
                      {#if selectedVariantIds.includes(variant.id)}
                        <button
                          type="button"
                          class="variant_play_button"
                          class:active={simulationVariantId === variant.id}
                          title="Play variant path"
                          on:click|preventDefault|stopPropagation={() =>
                            playVariantSimulation(variant)}
                        >
                          <span
                            class:stop_icon={simulationVariantId === variant.id}
                            class:play_icon={simulationVariantId !== variant.id}
                          ></span>
                        </button>
                      {/if}
                    </label>
                  {/each}
                </div>
              {/if}
            </div>
          {/each}
          <Pagination
            basic
            totalItems={variantGroups.length}
            bind:page={variantPage}
            pageSize={variantsPerPage}
          />
        {/if}
      </div>
    </Accordion>
    {#if explorerMode === "optimization"}
      <Accordion heading="Opportunities" open={true}>
        <div class="opportunities_wrapper">
          {#if optimizationLoading}
            <SideKPI loading></SideKPI>
          {:else if optimizationError}
            <div class="empty_variants">{optimizationError}</div>
          {:else if !(optimizationData?.opportunities || []).length}
            <div class="empty_variants">No opportunities found</div>
          {:else}
            <div class="variant_topline">
              <span
                ><bold class="black"
                  >{selectedOpportunityIds.length} / {(
                    optimizationData?.opportunities || []
                  ).length}</bold
                > selected</span
              >
            </div>
            <div class="variant_actions">
              <button disabled={loading} on:click={selectAllOpportunities}
                >Select all</button
              >
              <button disabled={loading} on:click={clearOpportunities}
                >Deselect all</button
              >
            </div>
            <div class="variant_stats">
              <div>
                <span>Count</span>
                <strong>{opportunityStats.count}</strong>
              </div>
              <div>
                <span>Impact</span>
                <strong>{Math.round(opportunityStats.impact * 10) / 10}%</strong
                >
              </div>
              <div>
                <span>Potential</span>
                <strong>{formatCurrency(opportunityStats.potential)}</strong>
              </div>
            </div>
            {#each optimizationData.opportunities as opportunity}
              <div
                class="opportunity_item"
                class:selected={selectedOpportunityIds.includes(opportunity.id)}
              >
                <div class="opportunity_card_header">
                  <label class="opportunity_selection">
                    <input
                      type="checkbox"
                      checked={selectedOpportunityIds.includes(opportunity.id)}
                      on:change={() => toggleOpportunity(opportunity.id)}
                    />
                  </label>
                  <span
                    class="opportunity_color_swatch"
                    style={`background: ${getOpportunityColor(
                      opportunity.id,
                    )};`}
                  ></span>
                  <div class="opportunity_summary">
                    <strong title={opportunity.title}
                      >{opportunity.title}</strong
                    >
                    <div class="opportunity_tags">
                      {#each opportunity.tags || [] as tag}
                        <span>{tag}</span>
                      {/each}
                    </div>
                  </div>
                  <button
                    type="button"
                    class="opportunity_details_toggle"
                    on:click|preventDefault|stopPropagation={() =>
                      toggleOpportunityDetails(opportunity.id)}
                  >
                    <img
                      src="/img/assistant/icons/chevron_{openOpportunityDetails[
                        opportunity.id
                      ]
                        ? 'down'
                        : 'right'}_black.svg"
                      alt=""
                    />
                  </button>
                </div>
                <div class="opportunity_metrics">
                  <div>
                    <span>Impact</span>
                    <strong>{opportunity.impactPercent}%</strong>
                  </div>
                  <div>
                    <span>Savings</span>
                    <strong
                      >{formatCurrency(
                        getOpportunityYearlyCost(opportunity),
                      )}</strong
                    >
                  </div>
                </div>
                {#if openOpportunityDetails[opportunity.id]}
                  <div class="opportunity_details">
                    {#if opportunity.problem}
                      <div class="opportunity_detail_item">
                        <span class="opportunity_detail_icon problem">
                          <img
                            src="/img/assistant/icons/problem_black.svg"
                            alt=""
                          />
                        </span>
                        <div>
                          <strong>Problem</strong>
                          <p>{opportunity.problem}</p>
                        </div>
                      </div>
                    {/if}
                    {#if opportunity.evidence}
                      <div class="opportunity_detail_item">
                        <span class="opportunity_detail_icon evidence">
                          <img
                            src="/img/assistant/icons/evidence_black.svg"
                            alt=""
                          />
                        </span>
                        <div>
                          <strong>Evidence</strong>
                          <p>{opportunity.evidence}</p>
                        </div>
                      </div>
                    {/if}
                    {#if opportunity.targetState}
                      <div class="opportunity_detail_item">
                        <span class="opportunity_detail_icon target">
                          <img
                            src="/img/assistant/icons/target_black.svg"
                            alt=""
                          />
                        </span>
                        <div>
                          <strong>Target</strong>
                          <p>{opportunity.targetState}</p>
                        </div>
                      </div>
                    {/if}
                  </div>
                {/if}
              </div>
            {/each}
          {/if}
        </div>
      </Accordion>
    {/if}
    <Accordion
      heading="Activities"
      tooltipText="Manage the activities associated with the selected task."
      open={false}
    >
      <AddToActivity
        {idproject}
        {activities}
        {activitiesToShow}
        {loading}
        formatAvgTime={formatActivityAvgTime}
        showModal={false}
        editActivity={openActivityEditorFromNode}
      />
    </Accordion>
  </div>
  <div slot="emptyState" class="empty_state_text">
    {#if allTasksHidden}
      <div class="empty_state_title">
        At least {MIN_TASK_EXECUTIONS} registrations per task are needed.
      </div>
      <div class="empty_state_hint">
        {hiddenTaskCount}
        {hiddenTaskCount === 1 ? "task is" : "tasks are"} hidden because they have fewer registrations.
      </div>
    {:else}
      <div class="empty_state_title">
        No tasks are available for this view with the selected filters.
      </div>
      <div class="empty_state_hint">
        Remove or adjust the filters to update the results.
      </div>
    {/if}
  </div>
</SectionWrapper>

<PddExport
  bind:this={pddExportElement}
  {idproject}
  {currentSubtask}
  {currentSubtaskEntry}
  {activitiesToShow}
  {edgesToShow}
  {bpmnActivityRows}
  getProcessArtifacts={buildPddProcessArtifacts}
  bind:pddGenerating
  bind:open={pddTemplateModalOpen}
/>

<AddToActivity
  bind:this={activityEditorElement}
  {idproject}
  {activities}
  {activitiesToShow}
  {loading}
  showList={false}
/>

<div class="bpmn_report_renderer" aria-hidden="true">
  <BpmnInlinePreview
    bind:this={bpmnReportRendererElement}
    bpmnXml={reportBpmnXml}
  />
</div>

<div class="Report-modal-wrapper">
  <Modal
    open={reportModalOpen}
    modalHeading="Report PDF"
    subtitle="Select one or more tasks for the generated report."
    fitcontent
    preventCloseOnClickOutside
    width={1120}
    actions
    primaryButtonText={reportGenerating ? "Generating..." : "Generate"}
    secondaryButtonText="Cancel"
    primaryButtonValidations={!selectedReportTaskIds.length || reportGenerating}
    secondaryButtonAction={closeReportModal}
    primaryButtonAction={startTaskReportDownload}
    on:close={closeReportModal}
  >
    <div class="team-modal-divider divider-margin" />
    <div class="modal_content action_plan_modal">
      <div class="report_mode_toggle" aria-label="Report type">
        <button
          type="button"
          class:active={reportMode === "manager"}
          disabled={reportGenerating}
          on:click={() => (reportMode = "manager")}>Manager</button
        >
        <button
          type="button"
          class:active={reportMode === "analyst"}
          disabled={reportGenerating}
          on:click={() => (reportMode = "analyst")}>Analyst</button
        >
      </div>
      <div class="variant_topline">
        <span
          >{filteredReportL3Options.length} of {reportL3Options.length} L3 detected
          -
          {selectedReportTaskIds.length} Tasks selected</span
        >
      </div>
      <div class="report_filters">
        <input
          type="text"
          placeholder="Search L3 or task..."
          bind:value={reportSearchTerm}
          disabled={reportGenerating}
        />
        <select
          bind:value={reportTeamFilter}
          disabled={reportGenerating}
          aria-label="Filter reports by team"
        >
          <option value="">All teams</option>
          {#each reportTeamOptions as team}
            <option value={team}>{team}</option>
          {/each}
        </select>
        <select
          bind:value={reportL3Filter}
          disabled={reportGenerating}
          aria-label="Filter reports by L3"
        >
          <option value="">All L3</option>
          {#each reportL3Options as option}
            <option value={option.id}>{option.name}</option>
          {/each}
        </select>
      </div>
      <div class="variant_actions">
        <button
          type="button"
          disabled={reportGenerating}
          on:click={selectAllReportTasks}>Select all</button
        >
        <button
          type="button"
          disabled={reportGenerating}
          on:click={clearReportTasks}>Clear</button
        >
      </div>
      <div class="action_plan_l3_list">
        {#each pagedReportL3Options as option}
          <div class="action_plan_group">
            <button
              type="button"
              class="action_plan_group_row"
              class:selected={reportGroupPartlySelected(option)}
              on:click={() => toggleReportGroupOpen(option.id)}
            >
              <img
                class="task_group_icon"
                src="/img/assistant/icons/chevron_{openReportL3Groups[option.id]
                  ? 'down'
                  : 'right'}_black.svg"
                alt=""
              />
              <input
                type="checkbox"
                checked={reportGroupSelected(option)}
                disabled={reportGenerating}
                on:click|stopPropagation={() => {}}
                on:change={() => toggleReportL3(option)}
              />
              <strong>{option.name}</strong>
              <small>{option.tasks.length} Tasks</small>
              <small
                >{option.tasks.reduce(
                  (sum, task) => sum + Number(task.value || 0),
                  0,
                )} Rec.</small
              >
            </button>
            {#if openReportL3Groups[option.id]}
              <div class="action_plan_task_items">
                {#each option.tasks as task}
                  <label
                    class="action_plan_task_row"
                    class:selected={selectedReportTaskIds.includes(task.id)}
                  >
                    <input
                      type="checkbox"
                      checked={selectedReportTaskIds.includes(task.id)}
                      disabled={reportGenerating}
                      on:change={() => toggleReportTask(task.id)}
                    />
                    <span>{task.name}</span>
                    <strong>{task.value} Rec.</strong>
                  </label>
                {/each}
              </div>
            {/if}
          </div>
        {/each}
      </div>
      {#if !filteredReportL3Options.length}
        <div class="empty_variants">No matching tasks</div>
      {:else}
        <Pagination
          basic
          totalItems={filteredReportL3Options.length}
          bind:page={reportPage}
          pageSize={reportItemsPerPage}
        />
      {/if}
    </div>
  </Modal>
</div>

<div class="ActionPlan-modal-wrapper">
  <Modal
    open={actionPlanModalOpen}
    modalHeading="Action Plan"
    subtitle="Select one or more L3 areas for the generated action plan."
    fitcontent
    preventCloseOnClickOutside
    width={1120}
    actions
    primaryButtonText={actionPlanGenerating ? "Generating..." : "Generate"}
    secondaryButtonText="Cancel"
    primaryButtonValidations={!selectedActionPlanTaskIds.length ||
      actionPlanGenerating}
    secondaryButtonAction={closeActionPlanModal}
    primaryButtonAction={startActionPlanDownload}
    on:close={closeActionPlanModal}
  >
    <div class="team-modal-divider divider-margin" />
    <div class="modal_content action_plan_modal">
      <div class="variant_topline">
        <span
          >{filteredActionPlanL3Options.length} of {actionPlanL3Options.length} L3
          detected -
          {selectedActionPlanTaskIds.length} Tasks selected</span
        >
      </div>
      <div class="action_plan_search">
        <input
          type="text"
          placeholder="Search L3 or task"
          bind:value={actionPlanSearchTerm}
          disabled={actionPlanGenerating}
        />
      </div>
      <div class="variant_actions">
        <button
          type="button"
          disabled={actionPlanGenerating}
          on:click={selectAllActionPlanL3}>Select all</button
        >
        <button
          type="button"
          disabled={actionPlanGenerating}
          on:click={clearActionPlanL3}>Clear</button
        >
      </div>
      <div class="action_plan_l3_list">
        {#each pagedActionPlanL3Options as option}
          <div class="action_plan_group">
            <button
              type="button"
              class="action_plan_group_row"
              class:selected={actionPlanGroupPartlySelected(option)}
              on:click={() => toggleActionPlanGroupOpen(option.id)}
            >
              <img
                class="task_group_icon"
                src="/img/assistant/icons/chevron_{openActionPlanL3Groups[
                  option.id
                ]
                  ? 'down'
                  : 'right'}_black.svg"
                alt=""
              />
              <input
                type="checkbox"
                checked={actionPlanGroupSelected(option)}
                disabled={actionPlanGenerating}
                on:click|stopPropagation={() => {}}
                on:change={() => toggleActionPlanL3(option)}
              />
              <strong>{option.name}</strong>
              <small>{option.tasks.length} Tasks</small>
              <small
                >{option.tasks.reduce(
                  (sum, task) => sum + Number(task.value || 0),
                  0,
                )} Rec.</small
              >
            </button>
            {#if openActionPlanL3Groups[option.id]}
              <div class="action_plan_task_items">
                {#each option.tasks as task}
                  <label
                    class="action_plan_task_row"
                    class:selected={selectedActionPlanTaskIds.includes(task.id)}
                  >
                    <input
                      type="checkbox"
                      checked={selectedActionPlanTaskIds.includes(task.id)}
                      disabled={actionPlanGenerating}
                      on:change={() => toggleActionPlanTask(task.id)}
                    />
                    <span>{task.name}</span>
                    <strong>{task.value} Rec.</strong>
                  </label>
                {/each}
              </div>
            {/if}
          </div>
        {/each}
      </div>
      {#if !filteredActionPlanL3Options.length}
        <div class="empty_variants">No matching tasks</div>
      {:else}
        <Pagination
          basic
          totalItems={filteredActionPlanL3Options.length}
          bind:page={actionPlanPage}
          pageSize={actionPlanItemsPerPage}
        />
      {/if}
    </div>
  </Modal>
</div>

<div class="BPMN-modal-wrapper">
  <Modal
    open={bpmnModalOpen}
    modalHeading="BPMN Export"
    subtitle="Configure how the BPMN model should be generated."
    fitcontent
    preventCloseOnClickOutside
    width={1400}
    on:click:button--secondary={closeBpmnModal}
    on:open
    on:close={closeBpmnModal}
    primaryButtonAction={() => {
      downloadBPMN();
    }}
  >
    <div class="team-modal-divider divider-margin" />
    <div class="modal_content bpmn_modal_layout">
      <div class="bpmn_settings_column">
        <section class="bpmn_collapse_section bpmn_format_section">
          <span class="bpmn_collapse_title bpmn_format_title">
            <span>Export format</span>
            <Tooltip
              text="Choose a standard BPMN file or a BIC/GBTEC-compatible BPMN file with additional metadata."
            />
          </span>
          <div class="bpmn_segmented bpmn_segmented_compact">
            <button
              type="button"
              class:active={bpmnExportFormat === "standard"}
              on:click={() => (bpmnExportFormat = "standard")}
              >Standard BPMN 2.0</button
            >
            <button
              type="button"
              class:active={bpmnExportFormat === "bic"}
              on:click={() => (bpmnExportFormat = "bic")}
              >BIC/GBTEC (Beta)</button
            >
          </div>
          {#if bpmnExportFormat === "bic"}
            <div class="bpmn_format_details">
              <span class="bpmn_format_label">
                Identifier
                <Tooltip
                  text="Short process key as used in BIC, for example PU."
                />
              </span>
              <input
                class="bpmn_format_input"
                type="text"
                maxlength="60"
                placeholder="e.g. PU"
                bind:value={bicIdentifier}
              />
              <span class="bpmn_format_label">
                Valid until
                <Tooltip text="Validity date of the process in BIC." />
              </span>
              <input
                class="bpmn_format_input"
                type="date"
                bind:value={bicValidTo}
              />
              <span class="bpmn_format_label">
                Change log
                <Tooltip
                  text="Release notes for BIC, one entry per line. Prefilled from the recordings this model is based on; edit as needed."
                />
              </span>
              <textarea
                class="bpmn_format_input bpmn_format_textarea"
                rows="3"
                placeholder="27.05.2026 Initial release."
                bind:value={bicChangeLog}
              />
              <label class="bpmn_format_check">
                <input type="checkbox" bind:checked={bicGenerateTexts} />
                <span>
                  Generate descriptions and keywords
                  <Tooltip
                    text="Rewrites activity notes into repository wording and derives keywords from the process. Takes a few seconds."
                  />
                </span>
              </label>
              <span class="bpmn_format_label">Process time unit</span>
              <div class="bpmn_segmented bpmn_segmented_compact">
                <button
                  type="button"
                  class:active={bicProcessTimeUnit === "minutes"}
                  on:click={() => (bicProcessTimeUnit = "minutes")}
                  >Minutes</button
                >
                <button
                  type="button"
                  class:active={bicProcessTimeUnit === "seconds"}
                  on:click={() => (bicProcessTimeUnit = "seconds")}
                  >Seconds</button
                >
              </div>
            </div>
          {/if}
        </section>

        <section class="bpmn_collapse_section bpmn_format_section">
          <span class="bpmn_collapse_title bpmn_format_title">
            <span>Orientation</span>
            <Tooltip
              text="Horizontal follows the BPMN standard. Vertical mirrors the finished layout, as used by BIC."
            />
          </span>
          <div class="bpmn_segmented bpmn_segmented_compact">
            <button
              type="button"
              class:active={bpmnExportOrientation === "horizontal"}
              on:click={() => (bpmnExportOrientation = "horizontal")}
              >Horizontal</button
            >
            <button
              type="button"
              class:active={bpmnExportOrientation === "vertical"}
              on:click={() => (bpmnExportOrientation = "vertical")}
              >Vertical</button
            >
          </div>
        </section>

        <section class="bpmn_collapse_section">
          <button
            type="button"
            class="bpmn_collapse_header"
            on:click={() =>
              (bpmnSectionsOpen = {
                ...bpmnSectionsOpen,
                topK: !bpmnSectionsOpen.topK,
              })}
          >
            <span class="bpmn_collapse_title">
              <span>Path Selection</span>
              <Tooltip
                text={`Define how top ${graphMode === "variants" ? "variants" : "paths"} are selected for the model.`}
              />
            </span>
            <span>{bpmnSectionsOpen.topK ? "^" : "v"}</span>
          </button>
          {#if bpmnSectionsOpen.topK}
            <div class="bpmn_collapse_body">
              <div class="bpmn_segmented bpmn_segmented_compact">
                <button
                  type="button"
                  class:active={bpmnTopKMode === "simple"}
                  on:click={() => {
                    bpmnTopKMode = "simple";
                  }}>Simple</button
                >
                <button
                  type="button"
                  class:active={bpmnTopKMode === "balanced"}
                  on:click={() => {
                    bpmnTopKMode = "balanced";
                  }}>Balanced</button
                >
                <button
                  type="button"
                  class:active={bpmnTopKMode === "custom"}
                  on:click={() => {
                    bpmnTopKMode = "custom";
                  }}>Custom</button
                >
              </div>
              {#if bpmnTopKMode === "custom"}
                <div class="bpmn_stepper_grid bpmn_stepper_grid_two">
                  <div
                    class="bpmn_stepper"
                    class:disabled={bpmnTopKMode !== "custom"}
                  >
                    <button
                      type="button"
                      disabled={bpmnTopKMode !== "custom" ||
                        bpmnTopKPathCount <= 0}
                      on:click={() =>
                        (bpmnTopKPathCount = Math.max(
                          Number(bpmnTopKPathCount) - 1,
                          0,
                        ))}>-</button
                    >
                    <div class="bpmn_stepper_value">
                      <span
                        >{graphMode === "variants" ? "Variants" : "Paths"}</span
                      >
                      <strong>{bpmnEffectiveTopKPathCount}</strong>
                    </div>
                    <button
                      type="button"
                      disabled={bpmnTopKMode !== "custom" ||
                        bpmnTopKPathCount >= bpmnTopKPathMax}
                      on:click={() =>
                        (bpmnTopKPathCount = Math.min(
                          Number(bpmnTopKPathCount) + 1,
                          bpmnTopKPathMax,
                        ))}>+</button
                    >
                  </div>
                  <div
                    class="bpmn_stepper"
                    class:disabled={bpmnTopKMode !== "custom"}
                  >
                    <button
                      type="button"
                      disabled={bpmnTopKMode !== "custom" ||
                        bpmnTopKCoverage <= 0}
                      on:click={() =>
                        (bpmnTopKCoverage = Math.max(
                          Number(bpmnTopKCoverage) - 5,
                          0,
                        ))}>-</button
                    >
                    <div class="bpmn_stepper_value">
                      <span>Coverage</span>
                      <strong>{bpmnEffectiveTopKCoverage}%</strong>
                    </div>
                    <button
                      type="button"
                      disabled={bpmnTopKMode !== "custom" ||
                        bpmnTopKCoverage >= 100}
                      on:click={() =>
                        (bpmnTopKCoverage = Math.min(
                          Number(bpmnTopKCoverage) + 5,
                          100,
                        ))}>+</button
                    >
                  </div>
                </div>
              {/if}
            </div>
          {/if}
        </section>

        <section class="bpmn_collapse_section">
          <button
            type="button"
            class="bpmn_collapse_header"
            on:click={() =>
              (bpmnSectionsOpen = {
                ...bpmnSectionsOpen,
                selection: !bpmnSectionsOpen.selection,
              })}
          >
            <span class="bpmn_collapse_title">
              <span>Activity Selection</span>
              <Tooltip
                text={graphMode === "variants"
                  ? "Choose the variants that should be part of the BPMN model."
                  : "Choose the activities that should be part of the BPMN model."}
              />
            </span>
            <span>{bpmnSectionsOpen.selection ? "^" : "v"}</span>
          </button>
          {#if bpmnSectionsOpen.selection}
            <div class="bpmn_collapse_body">
              {#if graphMode === "variants"}
                <div class="variant_topline">
                  <span
                    ><bold clas="black"
                      >{bpmnEffectiveVariantOptions.length} / {variantOptions.length}</bold
                    >
                    selected</span
                  >
                </div>
                <div class="variant_actions">
                  <button type="button" on:click={selectAllBpmnVariants}
                    >Select all</button
                  >
                  <button type="button" on:click={() => (bpmnVariantIds = [])}
                    >Deselect all</button
                  >
                </div>
                <div class="bpmn_variant_list">
                  {#each bpmnVariantGroups as group}
                    <div class="variant_group">
                      <div class="variant_group_row">
                        <button
                          type="button"
                          class="variant_group_toggle"
                          on:click={() => toggleBpmnVariantGroupOpen(group)}
                        >
                          {group.open ? "v" : ">"}
                        </button>
                        <input
                          type="checkbox"
                          checked={group.selected}
                          on:change={() => toggleBpmnVariantGroup(group)}
                        />
                        <strong>{group.name}</strong>
                        <small>{Math.round(group.coverage * 100)}%</small>
                        <small>{formatedTime(group.activeTime)} Avg.</small>
                      </div>
                      {#if group.open}
                        <div class="variant_group_items">
                          {#each group.variants as variant}
                            <label
                              class="variant_row"
                              class:selected={bpmnVariantIds.includes(
                                variant.id,
                              )}
                            >
                              <input
                                type="checkbox"
                                checked={bpmnVariantIds.includes(variant.id)}
                                on:change={() => toggleBpmnVariant(variant.id)}
                              />
                              <span class="variant_name">
                                {variant.name}
                                <small
                                  >- {Math.round(
                                    (variant.coverage || 0) * 100,
                                  )}% cases - {formatedTime(
                                    variant.activeTime,
                                  )}</small
                                >
                              </span>
                            </label>
                          {/each}
                        </div>
                      {/if}
                    </div>
                  {/each}
                </div>
              {:else}
                <div class="variant_topline">
                  <span
                    ><bold
                      >{bpmnSelectedActivities.length} / {bpmnActivityRows.length}</bold
                    > selected</span
                  >
                </div>
                <div class="variant_actions">
                  <button type="button" on:click={selectAllActivities}
                    >Select all</button
                  >
                  <button
                    type="button"
                    on:click={() => (includesActivities = [])}
                    >Deselect all</button
                  >
                </div>
                <DataTable
                  bind:selectedRowIds={includesActivities}
                  class="custom-table"
                  size="compact"
                  headers={tableHeaders}
                  pageSize={paginationBPMN.pageSize}
                  page={paginationBPMN.page}
                  rows={bpmnActivityRows}
                  sortable
                >
                  <svelte:fragment slot="cell-header" let:header>
                    {#if header.tooltip}
                      <div class="header_with_tooltip">
                        {header.value}
                        <Tooltip>{header.tooltip}</Tooltip>
                      </div>
                    {:else}
                      {header.value}
                    {/if}
                  </svelte:fragment>
                  <svelte:fragment slot="cell" let:cell let:row>
                    {#if cell.key === "include"}
                      <Checkbox
                        checked={includesActivities.includes(row.id)}
                        disabled={!bpmnAllowedActivities.has(row.activity)}
                        on:change={(e) => {
                          if (!bpmnAllowedActivities.has(row.activity)) return;
                          if (
                            e.target.checked &&
                            !includesActivities.includes(row.id)
                          ) {
                            includesActivities = [
                              ...includesActivities,
                              row.id,
                            ];
                          } else if (!e.target.checked) {
                            includesActivities = includesActivities.filter(
                              (id) => id !== row.id,
                            );
                          }
                        }}
                      />
                    {:else if cell.key === "cases"}
                      {cell.value || "0.0"}%
                    {:else}
                      <div
                        class:disabled_cell={!bpmnAllowedActivities.has(
                          row.activity,
                        )}
                        class="cell_content"
                        title={cell.value}
                      >
                        {cell.value}
                      </div>
                    {/if}
                  </svelte:fragment>
                </DataTable>
                <Pagination
                  bind:pageSize={paginationBPMN.pageSize}
                  bind:page={paginationBPMN.page}
                  pageSizeInputDisabled
                  totalItems={bpmnActivityRows.length}
                  pageSizes={[5]}
                  small
                />
              {/if}
            </div>
          {/if}
        </section>

        {#if showGatewayBehaviorSelection}
          <section class="bpmn_collapse_section">
            <button
              type="button"
              class="bpmn_collapse_header"
              on:click={() =>
                (bpmnSectionsOpen = {
                  ...bpmnSectionsOpen,
                  gateway: !bpmnSectionsOpen.gateway,
                })}
            >
              <span>Gateway Behavior</span>
              <span>{bpmnSectionsOpen.gateway ? "^" : "v"}</span>
            </button>
            {#if bpmnSectionsOpen.gateway}
              <div class="bpmn_collapse_body">
                <p class="description">
                  Define how gateways are represented in the model.
                </p>
                <div class="bpmn_gateway_options">
                  <div
                    class="bpmn_option_grid bpmn_radio_grid"
                    role="radiogroup"
                    aria-label="Gateway behavior"
                  >
                    <label class="bpmn_radio_option">
                      <input
                        type="radio"
                        bind:group={gatewayBehavior}
                        value="split_xor"
                      />
                      <span>Split XOR</span>
                      <p>Create separate XOR gateways.</p>
                    </label>
                    <label class="bpmn_radio_option">
                      <input
                        type="radio"
                        bind:group={gatewayBehavior}
                        value="split_merge_xor"
                      />
                      <span>Split and merge XOR</span>
                      <p>Merge XOR gateways where possible.</p>
                    </label>
                  </div>
                </div>
              </div>
            {/if}
          </section>
        {/if}

        <section class="bpmn_collapse_section">
          <button
            type="button"
            class="bpmn_collapse_header"
            on:click={() =>
              (bpmnSectionsOpen = {
                ...bpmnSectionsOpen,
                artifacts: !bpmnSectionsOpen.artifacts,
              })}
          >
            <span class="bpmn_collapse_title">
              <span>Additional Elements</span>
              <Tooltip text="Choose additional model artifacts." />
            </span>
            <span>{bpmnSectionsOpen.artifacts ? "^" : "v"}</span>
          </button>
          {#if bpmnSectionsOpen.artifacts}
            <div class="bpmn_collapse_body">
              <div class="bpmn_option_grid">
                <div class="bpmn_checkbox_option">
                  <Checkbox bind:checked={includeDatabases}>
                    <span slot="labelText" class="bpmn_checkbox_label">
                      IT-Systems
                      <Tooltip
                        text="Show IT systems interacting with activities."
                      />
                    </span>
                  </Checkbox>
                </div>
                <div class="bpmn_checkbox_option">
                  <Checkbox bind:checked={includeDocuments}>
                    <span slot="labelText" class="bpmn_checkbox_label">
                      Files
                      <Tooltip text="Show documents connected to activities." />
                    </span>
                  </Checkbox>
                </div>
                <div class="bpmn_checkbox_option">
                  <Checkbox bind:checked={includeAvgTime}>
                    <span slot="labelText" class="bpmn_checkbox_label">
                      Avg time
                      <Tooltip text="Show average time below activity names." />
                    </span>
                  </Checkbox>
                </div>
                <div class="bpmn_checkbox_option">
                  <Checkbox bind:checked={includeFrequency}>
                    <span slot="labelText" class="bpmn_checkbox_label">
                      Frequency
                      <Tooltip
                        text="Show activity frequency below activity names."
                      />
                    </span>
                  </Checkbox>
                </div>
              </div>
              <div class="bpmn_segmented bpmn_segmented_compact">
                <button
                  type="button"
                  class:active={bpmnArtifactMode === "simple"}
                  on:click={() => {
                    bpmnArtifactMode = "simple";
                  }}>Simple</button
                >
                <button
                  type="button"
                  class:active={bpmnArtifactMode === "balanced"}
                  on:click={() => {
                    bpmnArtifactMode = "balanced";
                  }}>Balanced</button
                >
                <button
                  type="button"
                  class:active={bpmnArtifactMode === "custom"}
                  on:click={() => {
                    bpmnArtifactMode = "custom";
                  }}>Custom</button
                >
              </div>
              <div class="bpmn_stepper_grid">
                <div
                  class="bpmn_stepper"
                  class:disabled={!includeDatabases ||
                    bpmnArtifactMode !== "custom"}
                >
                  <button
                    type="button"
                    disabled={!includeDatabases ||
                      bpmnArtifactMode !== "custom" ||
                      systemMinFrequency <= 0}
                    on:click={() =>
                      (systemMinFrequency = Math.max(
                        Number(systemMinFrequency) - 5,
                        0,
                      ))}>-</button
                  >
                  <div class="bpmn_stepper_value">
                    <span>Systems</span>
                    <strong>{bpmnEffectiveSystemMinFrequency}%</strong>
                  </div>
                  <button
                    type="button"
                    disabled={!includeDatabases ||
                      bpmnArtifactMode !== "custom" ||
                      systemMinFrequency >= 100}
                    on:click={() =>
                      (systemMinFrequency = Math.min(
                        Number(systemMinFrequency) + 5,
                        100,
                      ))}>+</button
                  >
                </div>
                <div
                  class="bpmn_stepper"
                  class:disabled={!includeDocuments ||
                    bpmnArtifactMode !== "custom"}
                >
                  <button
                    type="button"
                    disabled={!includeDocuments ||
                      bpmnArtifactMode !== "custom" ||
                      fileMinFrequency <= 0}
                    on:click={() =>
                      (fileMinFrequency = Math.max(
                        Number(fileMinFrequency) - 5,
                        0,
                      ))}>-</button
                  >
                  <div class="bpmn_stepper_value">
                    <span>Files</span>
                    <strong>{bpmnEffectiveFileMinFrequency}%</strong>
                  </div>
                  <button
                    type="button"
                    disabled={!includeDocuments ||
                      bpmnArtifactMode !== "custom" ||
                      fileMinFrequency >= 100}
                    on:click={() =>
                      (fileMinFrequency = Math.min(
                        Number(fileMinFrequency) + 5,
                        100,
                      ))}>+</button
                  >
                </div>
              </div>
            </div>
          {/if}
        </section>
      </div>

      <div class="bpmn_preview_column">
        <BpmnInlinePreview
          bpmnXml={bpmnPreviewXml}
          loading={bpmnPreviewLoading}
          error={bpmnPreviewError}
          orientation={bpmnExportOrientation}
        />
        <div class="bpmn_preview_actions">
          <Button kind="secondary" text="Cancel" on:click={closeBpmnModal} />
          <Button
            kind="secondary"
            text={bpmnGenerating ? "Exporting..." : "Export BPMN"}
            icon={DOWNLOAD_ICON}
            iconLeft
            on:click={async () => {
              generatedBpmnXml = null;
              await downloadBPMN();
              showBpmnViewer = true;
              closeBpmnModal();
            }}
          />
        </div>
      </div>
    </div>
  </Modal>
</div>

{#if toastMsg}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:absolute; top:0px; right:50px; z-index:100;"
  >
    <ToastNotification
      fullWidth
      hideAfter={saveSuccessful ? 3000 : null}
      timeout={saveSuccessful ? 3000 : null}
      kind={saveSuccessful ? "success" : "error"}
      title={saveSuccessful ? "Success" : "Error"}
      subtitle={toastMsg}
      caption={new Date().toLocaleString()}
      on:close={(e) => {
        e.preventDefault();
        toastMsg = "";
      }}
    />
  </div>
{/if}

{#if reportToastVisible}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:absolute; top:0px; right:50px; z-index:101;"
  >
    <ToastNotification
      fullWidth
      hideAfter={reportToastKind === "success" ? 3000 : null}
      timeout={reportToastKind === "success" ? 3000 : null}
      kind={reportToastKind}
      title={reportToastTitle}
      subtitle={reportToastSubtitle}
      caption={new Date().toLocaleString()}
      on:close={(e) => {
        e.preventDefault();
        clearReportToast();
      }}
    />
  </div>
{/if}

<style>
  .button_wrapper {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: calc(100vh - 6rem);
    overflow-x: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .menu::-webkit-scrollbar {
    display: none;
  }

  .main_wrapper {
    position: relative;
    z-index: var(--z5);
    height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .empty_state_title,
  .empty_state_hint {
    font-size: 1rem;
  }

  .empty_state_title {
    color: var(--pax-black);
  }

  .empty_state_hint {
    color: var(--pax-grey);
    margin-top: 0.5rem;
  }

  .menu_overlay {
    position: absolute;
    width: 100%;
    z-index: 1; /* Stellt sicher, dass das Overlay über dem Canvas liegt */
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: transparent !important;
    background-color: transparent !important;
  }

  .graph_top_right_toolbar {
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    z-index: 31;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-end;
  }

  .graph_left_toolbar {
    position: absolute;
    top: 0.25rem;
    left: 0.25rem;
    z-index: 3;
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .graph_top_right_toolbar :global(.bx--overflow-menu),
  .graph_left_toolbar :global(.bx--overflow-menu) {
    border-radius: 0.5rem;
    background-color: var(--pax-black);
    height: 3rem;
    width: 3rem;
  }

  :global(.task_explorer_export_menu) {
    z-index: 1000;
    width: min(15rem, calc(100vw - 2rem));
    min-width: min(15rem, calc(100vw - 2rem));
    max-width: calc(100vw - 2rem);
  }

  :global(.task_explorer_export_menu .bx--overflow-menu-options__btn) {
    width: 100%;
    max-width: 100%;
    min-height: 2.5rem;
    height: auto;
    padding-right: 2rem;
    white-space: nowrap;
  }

  :global(.transition_metric_menu .bx--overflow-menu-options__btn) {
    white-space: nowrap;
  }

  :global(.transition_metric_menu) {
    min-width: max-content;
  }

  .graph_top_right_toolbar :global(.bx--overflow-menu:hover),
  .graph_left_toolbar :global(.bx--overflow-menu:hover) {
    background-color: #2a2a2f;
  }

  .graph_top_right_toolbar :global(.bx--overflow-menu img),
  .graph_left_toolbar :global(.bx--overflow-menu img) {
    height: 1.25rem;
    width: 1.25rem;
    filter: brightness(0) invert(1);
  }

  .paxbot_chat_window {
    position: absolute;
    right: 1rem;
    bottom: 5.85rem;
    z-index: 4;
    width: min(28rem, calc(100% - 2rem));
    height: min(37rem, calc(100% - 8rem));
    min-height: 18rem;
    display: flex;
    flex-direction: column;
    border-radius: 0.5rem;
    background: #fff;
    border: 1px solid #e1e4e8;
    box-shadow: 0 1rem 2.5rem rgba(24, 28, 34, 0.18);
    overflow: visible;
  }

  .paxbot_chat_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.9rem 1rem;
    background: var(--pax-orange);
    color: white;
  }

  .paxbot_chat_header div {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
  }

  .paxbot_header_actions {
    display: flex !important;
    flex: 0 0 auto;
    flex-direction: row !important;
    align-items: center;
    gap: 0.35rem !important;
  }

  .paxbot_language_select {
    height: 1.75rem;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 0.35rem;
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    font-size: 0.72rem;
    font-weight: 800;
    padding: 0 0.35rem;
    cursor: pointer;
  }

  .paxbot_language_select option {
    color: var(--pax-black);
  }

  .paxbot_chat_header strong {
    font-size: 0.95rem;
    line-height: 1.2;
  }

  .paxbot_chat_header span {
    font-size: 0.75rem;
    opacity: 0.86;
  }

  .paxbot_reset_button,
  .paxbot_close_button {
    height: 1.75rem;
    width: 1.75rem;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 0.35rem;
    background: transparent;
    cursor: pointer;
  }

  .paxbot_reset_button {
    border: 1px solid rgba(255, 255, 255, 0.55);
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    font-size: 1.05rem;
    font-weight: 700;
    line-height: 1;
  }

  .paxbot_reset_button:hover,
  .paxbot_close_button:hover {
    background: rgba(255, 255, 255, 0.16);
  }

  .paxbot_close_button img {
    height: 0.75rem;
    width: 0.75rem;
    filter: brightness(0) invert(1);
  }

  .paxbot_chat_messages {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem;
    background: #f7f8fa;
  }

  .paxbot_chat_messages::-webkit-scrollbar {
    width: 0.45rem;
  }

  .paxbot_chat_messages::-webkit-scrollbar-thumb {
    border-radius: 99px;
    background: #c9ced6;
  }

  .paxbot_context_message {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.75rem;
    border-radius: 0.45rem;
    border: 1px solid #e0e4e8;
    background: #fff;
    color: #24282d;
    font-size: 0.78rem;
  }

  .paxbot_context_message strong,
  .paxbot_context_item span {
    font-size: 0.78rem;
    line-height: 1.3;
  }

  .paxbot_context_message p,
  .paxbot_context_item p,
  .paxbot_message_bubble p {
    margin: 0;
    line-height: 1.4;
    white-space: pre-line;
    overflow-wrap: anywhere;
  }

  .paxbot_context_item {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .paxbot_message_row {
    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .paxbot_message_row img {
    width: 1rem;
    height: 1rem;
    margin-top: 0.35rem;
    flex: 0 0 auto;
  }

  .paxbot_message_row.paxbot_user_message {
    justify-content: flex-end;
  }

  .paxbot_message_bubble {
    max-width: 82%;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.7rem 0.8rem;
    border-radius: 0.5rem;
    background: #fff;
    color: #24282d;
    border: 1px solid #e4e6ea;
    font-size: 0.82rem;
  }

  .paxbot_user_message .paxbot_message_bubble {
    background: var(--pax-black);
    color: #fff;
    border-color: var(--pax-black);
  }

  .paxbot_message_bubble span {
    font-size: 0.72rem;
    font-weight: 700;
    opacity: 0.75;
  }

  .paxbot_disclaimer {
    padding: 0 0.85rem 0.55rem;
    background: #fff;
    color: #8a929b;
    font-size: 0.68rem;
    line-height: 1.25;
    text-align: center;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .paxbot_starter_chips {
    display: flex;
    gap: 0.4rem;
    flex-wrap: wrap;
    max-height: none;
    overflow: hidden;
    padding: 0.5rem 0.75rem 0.85rem;
    background: #fff;
    border-top: 1px solid #eef0f2;
  }

  .paxbot_starter_chips button {
    flex: 1 1 calc(50% - 0.25rem);
    max-width: 100%;
    height: 1.75rem;
    min-width: 0;
    border: 1px solid #d7dbe0;
    border-radius: 99px;
    background: #fff;
    color: #3a3f46;
    font-size: 0.72rem;
    font-weight: 700;
    padding: 0 0.65rem;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .paxbot_starter_chips button:hover:not(:disabled) {
    border-color: var(--pax-orange);
    color: var(--pax-orange);
  }

  .paxbot_starter_chips button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .paxbot_chat_input {
    display: grid;
    grid-template-columns: 1fr 2.5rem;
    gap: 0.5rem;
    padding: 0.35rem 0.75rem 0.5rem;
    background: #fff;
  }

  .paxbot_chat_input textarea {
    min-height: 2.5rem;
    max-height: 7rem;
    resize: vertical;
    border: 1px solid #d7dbe0;
    border-radius: 0.45rem;
    padding: 0.65rem 0.75rem;
    font: inherit;
    font-size: 0.82rem;
    outline: none;
  }

  .paxbot_chat_input textarea:focus {
    border-color: var(--pax-orange);
  }

  .paxbot_chat_input button {
    height: 2.5rem;
    width: 2.5rem;
    border: 0;
    border-radius: 0.45rem;
    background: var(--pax-black);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .paxbot_chat_input button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  .paxbot_chat_input button:not(:disabled):hover {
    background: #2a2a2f;
  }

  .paxbot_chat_input button img {
    width: 1rem;
    height: 1rem;
    filter: brightness(0) invert(1);
  }

  .paxbot_chat_mascot {
    position: absolute;
    right: 1.55rem;
    bottom: -0.65rem;
    z-index: 5;
    height: 5.6rem;
    width: auto;
    pointer-events: none;
  }

  @media (max-width: 720px) {
    .paxbot_chat_window {
      right: 0.5rem;
      width: calc(100% - 1rem);
      height: min(28rem, calc(100% - 7.25rem));
      bottom: 5rem;
    }

    .paxbot_chat_mascot {
      right: 1rem;
      bottom: -0.5rem;
      height: 4.8rem;
    }
  }

  :global(.active_color_option .bx--overflow-menu-options__btn) {
    background-color: #ffe8dd;
    border-left: 0.25rem solid var(--pax-orange);
    font-weight: 600;
  }

  .bottom {
    bottom: 0;
  }

  .info_overlay {
    position: absolute;
    top: 3.9rem;
    left: 0;
    width: 16.5rem;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .info_card {
    border: 1px solid #e3e6ea;
    border-radius: 0.5rem;
    background: rgba(255, 255, 255, 0.95);
    overflow: hidden;
  }

  .info_header {
    width: 100%;
    min-height: 3.5rem;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.5rem;
    padding: 0 1rem;
    border: 0;
    border-bottom: 1px solid #e8e8e8;
    background: transparent;
    color: var(--pax-black);
    font-weight: 700;
    cursor: pointer;
    text-align: left;
  }

  .quant_summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.25rem;
    padding: 0.9rem 0.75rem;
  }

  .quant_summary div {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    text-align: center;
  }

  .quant_summary strong {
    font-size: 1rem;
    line-height: 1;
  }

  .quant_summary span,
  .variant_name small {
    color: #5f6770;
    font-size: 0.75rem;
  }

  .app_list {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
    padding: 1rem;
  }

  .app_row {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    font-size: 0.75rem;
  }

  .app_row > span:first-child {
    flex: 0 0 7rem;
    width: 7rem;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  .app_bar {
    flex: 1 1 auto;
    min-width: 0;
    height: 0.35rem;
    border-radius: 99px;
    background: linear-gradient(
      to right,
      #e3e5e8 calc(100% - 0.12rem),
      transparent calc(100% - 0.12rem)
    );
  }

  .app_bar span {
    display: block;
    height: 100%;
    border-radius: 99px;
    background: #ff5a1f;
  }

  .app_row > strong {
    flex: 0 0 2.1rem;
    text-align: right;
  }

  .app_type_legend {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
    padding: 1rem;
  }

  .app_type_row {
    display: grid;
    grid-template-columns: 1.1rem 1fr;
    align-items: center;
    gap: 0.65rem;
    color: var(--pax-black);
    font-size: 0.78rem;
  }

  .app_type_swatch {
    width: 1.1rem;
    height: 1.1rem;
    border: 1px solid var(--pax-black);
    border-radius: 0.25rem;
  }

  .canvas {
    height: 100%;
    min-height: 100%;
    width: 100%;
    z-index: 0; /* Platziert das Canvas hinter den Overlays */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .no_process {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-size: 2rem;
    color: var(--pax-black);
  }

  .simulation_slate {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 20;
    min-width: 7rem;
    padding: 1rem 1.5rem;
    border-radius: 0.5rem;
    background: rgba(28, 28, 32, 0.92);
    color: #fff;
    font-size: 2.5rem;
    font-weight: 800;
    text-align: center;
    pointer-events: none;
  }

  .variants_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-size: 0.8125rem;
  }

  .variant_row {
    display: grid;
    grid-template-columns: 1.25rem 1fr 1.7rem;
    align-items: center;
    height: 2.125rem;
    column-gap: 0.6rem;
  }

  .variant_row {
    cursor: pointer;
    border-radius: 0.5rem;
    background: var(--pax-smoke);
    border: 1px solid var(--pax-smoke);
    padding: 0 0.8rem;
    transition:
      background 0.15s ease,
      border-color 0.15s ease;
  }

  .variant_row:hover {
    background: #fbfbfb;
    border-color: #d4d8de;
  }

  .variant_row.selected {
    border-color: #ff6a1a;
    background: #fffaf6;
  }

  .variant_row input {
    margin: 0;
    justify-self: center;
  }

  .variant_name {
    display: flex;
    align-items: baseline;
    gap: 0.25rem;
    text-align: left;
    font-weight: 700;
    color: var(--pax-black);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .variant_name small {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .variant_play_button {
    width: 1.6rem;
    height: 1.6rem;
    border: 1px solid transparent;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .variant_play_button:hover,
  .variant_play_button.active {
    border-color: var(--pax-orange);
    color: var(--pax-orange);
  }

  .play_icon {
    width: 0;
    height: 0;
    border-top: 0.35rem solid transparent;
    border-bottom: 0.35rem solid transparent;
    border-left: 0.55rem solid currentColor;
    margin-left: 0.12rem;
  }

  .stop_icon {
    width: 0.55rem;
    height: 0.55rem;
    background: currentColor;
  }

  .variant_group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .variant_group_row {
    display: grid;
    grid-template-columns: 1rem 1.1rem minmax(6.5rem, 1fr) auto auto auto;
    align-items: center;
    height: 2.125rem;
    column-gap: 0.45rem;
    border-radius: 0.5rem;
    border: 1px solid var(--pax-smoke);
    background: var(--pax-smoke);
    padding: 0 0.55rem;
    min-width: 0;
  }

  .variant_group_row.selected {
    border-color: #ff6a1a;
    background: #fffaf6;
  }

  .variant_group_row input {
    margin: 0;
    justify-self: center;
  }

  .variant_group_row strong {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .variant_group_row small {
    color: #5f6770;
    white-space: nowrap;
    font-size: 0.72rem;
  }

  .variant_group_toggle {
    border: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .variant_group_toggle img {
    width: 0.8rem;
    height: 0.8rem;
  }

  .variant_group_items {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-left: 1.35rem;
    padding-left: 0.8rem;
    border-left: 1px dotted #c7ccd2;
  }

  .variant_topline {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5f6770;
    font-size: 0.75rem;
  }

  .transition_header,
  .transition_row {
    display: grid;
    grid-template-columns: 1.25rem minmax(0, 1fr) minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.5rem;
  }

  .optimization_positive {
    color: #08a339;
  }

  .transition_header {
    color: #5f6770;
    font-size: 0.72rem;
  }

  .transition_row {
    border-radius: 0.35rem;
    border: 1px solid var(--pax-smoke);
    background: var(--pax-smoke);
    height: 2.125rem;
    padding: 0 0.75rem;
    font-size: 0.75rem;
    cursor: pointer;
  }

  .transition_row.selected {
    border-color: #ff6a1a;
    background: #fffaf6;
  }

  .transition_row span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .opportunities_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.25rem 0;
  }

  .opportunity_color_swatch {
    display: block;
    justify-self: center;
    align-self: start;
    width: 0.7rem;
    height: 0.7rem;
    margin-top: 0.25rem;
    border-radius: 0.2rem;
    border: 1px solid rgba(0, 0, 0, 0.18);
  }

  .opportunity_item {
    border: 1px solid #e3e6ea;
    border-radius: 0.5rem;
    background: #fff;
    overflow: hidden;
  }

  .opportunity_item.selected {
    border-color: var(--pax-orange);
  }

  .opportunity_card_header {
    display: grid;
    grid-template-columns: 1rem 0.8rem minmax(0, 1fr) 1.25rem;
    gap: 0.45rem;
    align-items: start;
    padding: 0.75rem 0.8rem 0.45rem;
  }

  .opportunity_selection {
    display: flex;
    align-items: center;
    padding-top: 0.1rem;
  }

  .opportunity_selection input {
    margin: 0;
  }

  .opportunity_summary {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
  }

  .opportunity_summary > strong {
    min-width: 0;
    color: var(--pax-black);
    font-size: 0.9rem;
    font-weight: 700;
    line-height: 1.25;
  }

  .opportunity_details_toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    height: 1.25rem;
    border: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
  }

  .opportunity_details_toggle img {
    width: 0.8rem;
    height: 0.8rem;
  }

  .opportunity_tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .opportunity_tags span {
    border-radius: 0.35rem;
    background: #dbeafe;
    color: #1d4ed8;
    padding: 0.12rem 0.4rem;
    font-size: 0.58rem;
    font-weight: 700;
  }

  .opportunity_metrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
    padding: 0.15rem 0.8rem 0.75rem 3.95rem;
  }

  .opportunity_metrics div {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .opportunity_metrics span {
    color: #6f7680;
    font-size: 0.58rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  .opportunity_metrics strong {
    color: var(--pax-black);
    font-size: 0.9rem;
    font-weight: 800;
  }

  .opportunity_details {
    border-top: 1px solid #e3e6ea;
    padding: 0 0.8rem;
    color: #3d444d;
    background: #fff;
  }

  .opportunity_detail_item {
    display: grid;
    grid-template-columns: 2.4rem minmax(0, 1fr);
    gap: 0.7rem;
    padding: 0.85rem 0;
    border-bottom: 1px solid #e3e6ea;
  }

  .opportunity_detail_item:last-child {
    border-bottom: 0;
  }

  .opportunity_detail_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.1rem;
    height: 2.1rem;
    border-radius: 0.5rem;
  }

  .opportunity_detail_icon.problem {
    background: #fff1e8;
  }

  .opportunity_detail_icon.evidence {
    background: #eaf2ff;
  }

  .opportunity_detail_icon.target {
    background: #edf8ed;
  }

  .opportunity_detail_icon img {
    width: 1rem;
    height: 1rem;
    object-fit: contain;
  }

  .opportunity_detail_item p {
    margin: 0;
    color: #3d444d;
    font-size: 0.72rem;
    line-height: 1.35;
  }

  .opportunity_detail_item strong {
    display: block;
    margin-bottom: 0.28rem;
    color: #1c1c20;
    font-size: 0.62rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.01em;
  }

  /* .variant_settings label {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    color: #5f6770;
    font-size: 0.7rem;
  }

  .variant_settings input {
    width: 100%;
    border: 1px solid #d9d9d9;
    border-radius: 0.35rem;
    padding: 0.35rem;
    font-weight: 700;
    color: var(--pax-black);
  } */

  .variant_actions {
    display: flex;
    gap: 0.5rem;
  }

  .variant_actions button {
    flex: 1;
    height: 1.8rem;
    border: 0;
    border-radius: 0.375rem;
    background: var(--pax-black);
    color: var(--pax-white);
    cursor: pointer;
  }

  .variant_actions button:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .variant_stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.65rem;
  }

  .variant_stats div {
    border: 1px solid #e3e6ea;
    border-radius: 0.45rem;
    background: #fff;
    padding: 0.7rem 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.28rem;
  }

  .variant_stats span {
    color: #5f6770;
    font-size: 0.7rem;
  }

  .variant_stats strong {
    font-size: 0.9rem;
  }

  .empty_variants {
    color: var(--pax-black-inactive);
  }

  .hidden_header_filters {
    display: none;
  }

  :global(.task-Explorer-header-wrapper .custom_select) {
    width: 15rem;
  }

  :global(.task-Explorer-header-wrapper .custom_select select) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .modal_content {
    display: grid;
    gap: 1rem;
  }

  .bpmn_report_renderer {
    position: fixed;
    left: -10000px;
    top: 0;
    width: 1600px;
    height: 650px;
    overflow: hidden;
    pointer-events: none;
    opacity: 0;
  }

  .action_plan_modal {
    gap: 0.9rem;
    width: 100%;
  }

  :global(.ActionPlan-modal-wrapper .bx--modal-container),
  :global(.Report-modal-wrapper .bx--modal-container) {
    width: min(96vw, 74rem) !important;
    max-width: 74rem !important;
  }

  :global(.ActionPlan-modal-wrapper .custom-modal .bx--modal-content),
  :global(.ActionPlan-modal-wrapper .modal_wrapper),
  :global(.ActionPlan-modal-wrapper .modal_content),
  :global(.Report-modal-wrapper .custom-modal .bx--modal-content),
  :global(.Report-modal-wrapper .modal_wrapper),
  :global(.Report-modal-wrapper .modal_content) {
    width: 100% !important;
    max-width: none !important;
  }

  :global(.ActionPlan-modal-wrapper .modal_wrapper),
  :global(.Report-modal-wrapper .modal_wrapper) {
    padding-inline: 0.15rem;
  }

  :global(.ActionPlan-modal-wrapper .bx--modal-header),
  :global(.Report-modal-wrapper .bx--modal-header) {
    padding-right: 3.5rem;
  }

  .report_mode_toggle {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }

  .report_mode_toggle button {
    height: 2.35rem;
    border: 1px solid #d9d9d9;
    border-radius: 0.5rem;
    background: #fff;
    color: var(--pax-black);
    font-size: 0.88rem;
    font-weight: 700;
    cursor: pointer;
  }

  .report_mode_toggle button.active {
    border-color: var(--pax-black);
    background: var(--pax-black);
    color: var(--pax-white);
  }

  .report_mode_toggle button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .action_plan_modal .variant_topline {
    min-height: 2.2rem;
    border: 1px solid #e3e6ea;
    border-radius: 0.5rem;
    background: #fff;
    padding: 0.55rem 0.75rem;
    font-size: 0.78rem;
    font-weight: 700;
  }

  .action_plan_search {
    width: 100%;
  }

  .action_plan_search input {
    width: 100%;
    height: 2.4rem;
    border: 1px solid #d9d9d9;
    border-radius: 0.5rem;
    background: #fff;
    color: var(--pax-black);
    font-size: 0.88rem;
    padding: 0 0.85rem;
    outline: none;
  }

  .action_plan_search input:focus {
    border-color: var(--pax-orange);
    box-shadow: 0 0 0 1px var(--pax-orange);
  }

  .action_plan_search input:disabled {
    opacity: 0.55;
  }

  .report_filters {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(10rem, 0.32fr) minmax(
        10rem,
        0.32fr
      );
    gap: 0.5rem;
  }

  .report_filters input,
  .report_filters select {
    min-width: 0;
    width: 100%;
    height: 2.4rem;
    border: 1px solid #d9d9d9;
    border-radius: 0.5rem;
    background: #fff;
    color: var(--pax-black);
    font-size: 0.88rem;
    padding: 0 0.85rem;
    outline: none;
  }

  .report_filters input:focus,
  .report_filters select:focus {
    border-color: var(--pax-orange);
    box-shadow: 0 0 0 1px var(--pax-orange);
  }

  .report_filters input:disabled,
  .report_filters select:disabled {
    opacity: 0.55;
  }

  .action_plan_modal .variant_actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .action_plan_modal .variant_actions button {
    height: 2.15rem;
    font-weight: 700;
  }

  .action_plan_l3_list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
    gap: 0.65rem;
    max-height: min(58vh, 34rem);
    overflow: auto;
    padding-right: 0.3rem;
  }

  .action_plan_group {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
  }

  .action_plan_group_row {
    display: grid;
    grid-template-columns: 1rem 1.1rem minmax(0, 1fr) 4.2rem 4.2rem;
    align-items: center;
    gap: 0.5rem;
    min-height: 2.35rem;
    border: none;
    border-radius: 0.5rem;
    background: var(--pax-smoke);
    padding: 0.25rem 0.65rem;
    text-align: left;
    cursor: pointer;
    width: 100%;
  }

  .action_plan_group_row.selected {
    border: 1px solid var(--pax-orange);
  }

  .action_plan_group_row strong,
  .action_plan_task_row span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .action_plan_group_row small {
    color: #6f7680;
    font-size: 0.72rem;
    font-weight: 700;
    text-align: right;
    white-space: nowrap;
  }

  .action_plan_task_items {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    margin-left: 1.35rem;
    padding-left: 0.8rem;
    border-left: 1px dotted #c7ccd2;
  }

  .action_plan_task_row {
    display: grid;
    grid-template-columns: 1.1rem minmax(0, 1fr) 4.4rem;
    align-items: center;
    gap: 0.65rem;
    min-height: 2.25rem;
    border: 1px solid var(--pax-smoke);
    border-radius: 0.5rem;
    background: #fff;
    padding: 0.25rem 0.7rem;
    cursor: pointer;
  }

  .action_plan_task_row.selected {
    border-color: var(--pax-orange);
    background: #fff8f3;
  }

  .action_plan_task_row strong {
    font-size: 0.78rem;
    text-align: right;
    white-space: nowrap;
  }

  @media (max-width: 900px) {
    .action_plan_l3_list {
      grid-template-columns: 1fr;
    }

    .action_plan_group_row {
      grid-template-columns: 1rem 1.1rem minmax(0, 1fr) auto auto;
    }
  }

  :global(.BPMN-modal-wrapper .bx--modal-container) {
    width: min(99vw, 112rem) !important;
    max-width: 112rem !important;
  }

  :global(.BPMN-modal-wrapper .custom-modal .bx--modal-content),
  :global(.BPMN-modal-wrapper .modal_wrapper),
  :global(.BPMN-modal-wrapper .modal_content) {
    width: 100% !important;
    max-width: none !important;
  }

  .bpmn_modal_layout {
    grid-template-columns: 32rem minmax(0, 1fr);
    align-items: stretch;
    width: 100%;
    min-height: min(72vh, 52rem);
  }

  .bpmn_settings_column {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 32rem;
    min-width: 32rem;
    max-width: 32rem;
    max-height: min(72vh, 52rem);
    overflow: auto;
    padding-right: 0.25rem;
    min-width: 0;
  }

  .bpmn_preview_column {
    position: relative;
    min-width: 0;
    width: 100%;
    min-height: min(72vh, 52rem);
  }

  .bpmn_preview_actions {
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    z-index: 100;
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .bpmn_collapse_section {
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 0.75rem;
  }

  .bpmn_collapse_section:last-child {
    border-bottom: 0;
  }

  .bpmn_format_section {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
  }

  .bpmn_format_title,
  .bpmn_format_label {
    font-weight: 700;
  }

  .bpmn_format_details {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
    padding: 0.75rem;
    border-radius: 0.35rem;
    background: var(--pax-smoke);
  }

  .bpmn_format_label {
    font-size: 0.8125rem;
  }

  .bpmn_format_input {
    width: 100%;
    padding: 0.4rem 0.55rem;
    border: 1px solid var(--cds-ui-04, #8d8d8d);
    border-radius: 0.25rem;
    background: var(--cds-field-01, #f4f4f4);
    color: inherit;
    font-family: inherit;
    font-size: 0.8125rem;
  }

  .bpmn_format_textarea {
    resize: vertical;
  }

  .bpmn_format_check {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    font-size: 0.8125rem;
    cursor: pointer;
  }

  /* Die globale Regel "input, textarea { width: 100% }" trifft auch das
     Kaestchen: es wurde 409 statt 13 Einheiten breit und schob die
     Beschriftung auf x=405 aus dem 399 Einheiten breiten Feld heraus.
     Ohne Attributteil geschrieben: mit input[type="checkbox"] warf der
     Uebersetzer die Regel als ungenutzt weg - im Entwicklungsserver griff
     sie, im gebauten Bundle fehlte sie. In dem Label sitzt ohnehin nur
     dieses eine Feld. */
  .bpmn_format_check input {
    flex: 0 0 auto;
    width: auto;
    padding: 0;
  }

  .bpmn_collapse_header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    border: 0;
    background: transparent;
    color: var(--pax-black);
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 700;
    text-align: left;
    padding: 0.25rem 0;
  }

  .bpmn_collapse_title {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  .bpmn_collapse_body {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    padding-top: 0.65rem;
    min-width: 0;
  }

  :global(.BPMN-modal-wrapper .custom-table),
  :global(.BPMN-modal-wrapper .custom-table .bx--data-table-container),
  :global(.BPMN-modal-wrapper .custom-table .bx--data-table-content) {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  :global(.BPMN-modal-wrapper .custom-table table) {
    width: 100%;
    max-width: 100%;
    table-layout: fixed;
  }

  :global(.BPMN-modal-wrapper .custom-table thead th) {
    font-weight: 400;
  }

  .bpmn_segmented {
    display: flex;
    width: 100%;
    border: 1px solid #d9d9d9;
    border-radius: 0.35rem;
    overflow: hidden;
  }

  .bpmn_segmented button {
    flex: 1;
    height: 3rem;
    border: 0;
    border-right: 1px solid #d9d9d9;
    background: var(--pax-white);
    color: var(--pax-black);
    font-weight: 700;
    cursor: pointer;
  }

  .bpmn_segmented button:last-child {
    border-right: 0;
  }

  .bpmn_segmented button.active {
    background: var(--pax-black);
    color: var(--pax-white);
  }

  .bpmn_segmented_compact button {
    height: 2.35rem;
    font-size: 0.8125rem;
  }

  .disabled_cell {
    color: var(--pax-grey);
    opacity: 0.45;
  }

  :global(
      .BPMN-modal-wrapper
        .custom-modal
        .bx--modal-container
        .bx--modal-content
        .modal_wrapper
        .modal_content
        .modal_section
        .section
        .bx--slider
    ) {
    width: 17rem;
  }

  :global(
      .BPMN-modal-wrapper
        .custom-modal
        .bx--modal-container
        .bx--modal-content
        .modal_wrapper
        .modal_content
        .modal_section
        .section
        .slider_wrapper
        .bx--form-item
    ) {
    max-width: fit-content;
  }

  :global(
      .BPMN-modal-wrapper
        .custom-modal
        .bx--modal-container
        .bx--modal-content
        .modal_wrapper
        .modal_content
        .modal_section
        .section
        .bx--form-item
        .bx--slider__range-label
    ) {
    display: none;
  }
  :global(
      .BPMN-modal-wrapper
        .custom-modal
        .bx--modal-container
        .bx--modal-content
        .modal_wrapper
        .modal_content
        .modal_section
        .section
        .bx--slider-text-input
    ) {
    height: 1.6rem;
    width: 3rem;
    min-width: 3rem;
    padding: 0 0.25rem;
    border: 0;
    border-bottom: 1px solid var(--pax-black-inactive);
    border-radius: 0;
    background: transparent;
    text-align: center;
    line-height: 1.6rem;
  }

  :global(
      .BPMN-modal-wrapper
        .custom-modal
        .bx--modal-container
        .bx--modal-content
        .modal_wrapper
        .modal_content
        .modal_section
        .section
        .bx--radio-button-wrapper:not(:last-of-type)
    ) {
    margin-right: 0rem;
    width: 310.52px;
  }

  /* :global(
      .BPMN-modal-wrapper
        .custom-modal
        .bx--modal-container
        .bx--modal-content
        .modal_wrapper
        .modal_content
        .modal_section
        .section
        .bx--radio-button-wrapper:first-of-type
    ) { */
  /* width: 310.52px;
  } */
  :global(
      .BPMN-modal-wrapper
        .custom-modal
        .bx--modal-container
        .bx--modal-content
        .modal_wrapper
        .modal_content
        .modal_section
        .section
        .bx--radio-button__label
    ) {
    justify-content: flex-start;
  }

  .description {
    font-size: 0.85rem;
    color: var(--pax-grey);
  }

  .bpmn_gateway_options {
    min-width: 0;
  }

  .bpmn_option_grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.8rem 1.25rem;
  }

  .bpmn_radio_grid {
    gap: 0.55rem 1.25rem;
  }

  .bpmn_radio_option {
    display: grid;
    grid-template-columns: 1rem minmax(0, 1fr);
    column-gap: 0.45rem;
    row-gap: 0.08rem;
    align-items: start;
    min-width: 0;
    cursor: pointer;
  }

  .bpmn_radio_option input {
    grid-column: 1;
    grid-row: 1;
    width: 1rem;
    height: 1rem;
    margin: 0.05rem 0 0;
    accent-color: var(--pax-black);
  }

  .black {
    color: var(--pax-black);
    font-weight: bold;
  }

  .bpmn_radio_option span {
    grid-column: 2;
    grid-row: 1;
    font-weight: 700;
    color: var(--pax-black);
    line-height: 1.2;
  }

  .bpmn_radio_option p {
    grid-column: 2;
    grid-row: 2;
    margin: 0;
    color: var(--pax-grey);
    font-size: 0.6rem !important;
    line-height: 1.1 !important;
  }

  .bpmn_checkbox_option {
    display: flex;
    flex-direction: column;
    gap: 0.12rem;
    min-width: 0;
  }

  :global(.BPMN-modal-wrapper .bpmn_checkbox_label) {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  :global(.BPMN-modal-wrapper .bpmn_checkbox_option .bx--checkbox-label-text) {
    font-weight: 400;
    color: var(--pax-black);
    line-height: 1.2;
  }

  .team-modal-divider {
    width: 100%;
    height: 1px;
    margin-top: 1rem;
    background: #d9d9d9;
    margin-bottom: 1rem;
  }

  .bpmn_stepper_grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
    gap: 0.75rem;
    margin-top: 0.45rem;
  }

  .bpmn_stepper_grid_two {
    grid-template-columns: repeat(2, minmax(10rem, 1fr));
  }

  .bpmn_stepper {
    display: grid;
    grid-template-columns: 2.35rem minmax(0, 1fr) 2.35rem;
    align-items: stretch;
    min-height: 2.45rem;
    overflow: hidden;
    border: 1px solid #d9d9d9;
    border-radius: 0.45rem;
    background: var(--pax-white);
  }

  .bpmn_stepper button {
    border: 0;
    background: var(--pax-white);
    color: var(--pax-black);
    font-size: 1.1rem;
    cursor: pointer;
  }

  .bpmn_stepper button:first-child {
    border-right: 1px solid #d9d9d9;
  }

  .bpmn_stepper button:last-child {
    border-left: 1px solid #d9d9d9;
  }

  .bpmn_stepper button:hover:not(:disabled) {
    background: var(--pax-smoke);
  }

  .bpmn_stepper button:disabled {
    cursor: not-allowed;
    color: var(--pax-grey);
    opacity: 0.45;
  }

  .bpmn_stepper_value {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    min-width: 0;
    padding: 0 0.35rem;
    color: var(--pax-black);
    font-weight: 700;
    font-size: 0.78rem;
  }

  .bpmn_stepper_value span,
  .bpmn_stepper_value strong {
    min-width: 0;
    white-space: nowrap;
  }

  .bpmn_stepper_value span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bpmn_stepper.disabled .bpmn_stepper_value {
    color: var(--pax-grey);
  }

  :global(.BPMN-modal-wrapper .modal_wrapper .divider),
  :global(.BPMN-modal-wrapper .buttons-container) {
    display: none;
  }

  :global(.BPMN-modal-wrapper .bx--modal-scroll-content > *:last-child) {
    padding-bottom: 1rem !important;
  }

  :global(.BPMN-modal-wrapper .bx--modal-header) {
    margin-bottom: 0rem;
  }

  :global(.BPMN-modal-wrapper .custom-modal .bx--modal-content) {
    padding-top: 0rem;
  }

  :global(.BPMN-modal-wrapper .bx--modal-content p) {
    padding-right: 0;
  }

  :global(
      .BPMN-modal-wrapper
        .bx--modal-content
        .bx--form-item
        .bx--checkbox-label
        .bx--checkbox-label-text
    ) {
    padding-left: 0.5rem;
  }

  :global(.BPMN-modal-wrapper tbody td) {
    font-size: 0.785rem;
  }

  .cell_content {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
